/* eslint @typescript-eslint/camelcase: ["error", {allow: ["UNSAFE_componentWillMount"]}] */
export const data = [
  {
    Elected: 'Ja',
    Sitznummer: '1',
    Rat: 'Nationalrat',
    'Funktion de': 'Präsidentin',
    'Funktion fr': 'Présidente',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'VD',
    Nachname: 'Moret',
    Vorname: 'Isabelle',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2006',
    'DabeiSeit fr': 'Au Conseil national depuis 2006',
    'Alte Texte DE':
      'Die Vizepräsidentin der FDP Schweiz ist eine Schnellrednerin. Sie politisiert in der Gesundheits- und der Staatspolitischen Kommission.',
    'Text de':
      'Ihre Bundesratskandidatur für die Nachfolge von Didier Burkhalter diente in erster Linie dazu, sich zu profilieren und im Parlament ein grösseres Gewicht zu erhalten. Zu reden gab 2018 die Enthüllung, dass Moret seit 2009 von der Waadtländer Steuerverwaltung mehr ordentlich veranlagt worden ist.',
    'BAT DE': 'daf',
    'Text fr':
      "Elle n'a pas été élue au Conseil fédéral en 2017; qu'à cela ne tienne: elle deviendra la première citoyenne du pays en présidant le conseil national l'an prochain. Spécialiste des assurances sociales et des questions de santé, Isabelle Moret est aussi la présidente d'H+, l'association faîtière des hôpitaux. L'avocate a dernièrement fait parler d'elle pour instaurer davantage de transparence dans le \"petchi\" des intergroupes parlementaires.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Yens',
    'Wohnort fr': 'Yens',
    Geburtsdatum: '30.12.1970',
    'Beruf de': 'Anwältin',
    'Beruf fr': 'Avocate-conseil'
  },
  {
    Elected: 'Ja',
    Sitznummer: '1',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BE',
    Nachname: 'Stöckli',
    Vorname: 'Hans',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2012, im Nationalrat von 2004 bis 2012 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2012, précédement au National de 2004 à 2012',
    'Alte Texte DE':
      'Der frühere Stadtpräsident von Biel eroberte vor vier Jahren den Sitz zurück, den kurzzeitig die SVP gehalten hatte.',
    'Text de':
      'Auch mit 67 ist Hans Stöckli im Ständerat der umtriebige, nimmermüde und leutselige \nBrückenbauer, der er schon als Bieler Stadtpräsident war. Seine Hauptthemen sind die\nGesundheitsprävention und der Tourismus. ',
    'BAT DE': 'daf',
    'Text fr':
      "A 67 ans, Hans Stöckli semble infatigable. L'ancien très populaire maire de Bienne est connu pour être un constructeur de ponts. Depuis qu'il est au Conseil des Etats, il s'intéresse notamment aux domaines de la prévention et du tourisme. Il s'est pris une claque avec Sion 2026, massivement rejeté par les Valaisans, et dont il était le vice-président du comité de candidature.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Biel',
    'Wohnort fr': 'Bienne',
    Geburtsdatum: '12.04.1952',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '2',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BE',
    Nachname: 'Aebi',
    Vorname: 'Andreas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Der Landwirt aus dem Berner Emmental setzt sich im Nationalrat für seinen Berufsstand ein. 2011 bis 2013 amtete er als Präsident der Aussenpolitischen Kommission.',
    'Text de':
      'Der Landwirt aus dem Berner Emmental ist einer der wenigen in der SVP-Fraktion, die sich besorgt ob des Klimawandels zeigen. Er sagt, die SVP dürfe zwar nicht in die Klimahysterie der anderen Parteien verfallen. Aber nach dem Hitzesommer im letzten Jahr und der Wahlniederlage in verschiedenen Kantonen müsse die Partei ihre Umweltpolitik überprüfen.',
    'BAT DE': 'fre',
    'Text fr':
      "L'agriculteur de l'Emmental est l'un des rares membres de l'UDC à se préoccuper du changement climatique. Selon lui, l'UDC ne doit certes pas tomber dans \"l'hystérie\" des autres partis. Mais après les derniers étés caniculaires - et les défaites électorales dans plusieurs cantons, il estime que l'UDC doit revoir sa politique environnementale.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Alchenstorf',
    'Wohnort fr': 'Alchenstorf',
    Geburtsdatum: '26.11.1958',
    'Beruf de': 'eidg. dipl. Landwirt, Unternehmer',
    'Beruf fr': 'Agriculteur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '2',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'TG',
    Nachname: 'Häberli-Koller',
    Vorname: 'Brigitte',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Ständerat seit 2011, im Nationalrat von 2003 bis 2011 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2011, précédement au National de 2003 à 2011',
    'Alte Texte DE':
      'Vor ihrem Einzug in die kleine Kammer war die als eher konservativ geltende CVP-Frau acht Jahre im Nationalrat und amtete dort als Vize-Präsidentin ihrer Fraktion. Sie ist Vize-Präsidentin der Bildungskommission und sitzt in der Finanz- und Rechtskommission.',
    'Text de':
      'Die zurückhaltend auftretende Thurgauerin setzt sich für Gleichstellungsthemen ein und sitzt im Fraktionsvorstand der CVP. Sie politisiert bereits seit 16 Jahren in Bern: von 2003 bis 2011 im Nationalrat, seit 2011 als Ständerätin. ',
    'BAT DE': 'fre',
    'Text fr':
      "Cette Thurgovienne discrète intervient sur les questions d'égalité et fait partie du comité directeur du groupe parlementaire du PDC. Elle siège à Berne depuis 2003, d’abord au Conseil national jusqu'en 2011, puis comme membre du Conseil des États.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Bichelsee-Balterswil',
    'Wohnort fr': 'Bichelsee-Balterswil',
    Geburtsdatum: '23.08.1958',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '3',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SG',
    Nachname: 'Büchel',
    Vorname: 'Roland Rino',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2010',
    'DabeiSeit fr': 'Au Conseil national depuis 2010',
    'Alte Texte DE':
      'Im Zuge der Fifa-Affäre war der Sportmanager, der früher selbst für den Weltfussballverband tätig war, auch im deutschen Fernsehen ein gern zitierter Experte. Daneben fällt der Rheintaler als kritischer Aussenpolitiker auf; er ist Vize-Präsident der entsprechenden Kommission.',
    'Text de':
      'Im Zuge der Fifa-Affäre war der Sportmanager, der früher selbst für den Weltfussballverband tätig war, auch im deutschen Fernsehen ein gern zitierter Experte. Daneben fällt der Rheintaler als kritischer Aussenpolitiker auf.',
    'BAT DE': 'fre',
    'Text fr':
      "Il a été directeur sportif à la FIFA et juge sévèrement les scandales qui touchent l'organisation internationale. Au sein de la Commission de politique extérieure, il s'est montré très critique envers tout rapprochement institutionnel avec l'Union européenne. Le Saint-Gallois a appris le français en travaillant aux remontées mécaniques de Villars durant sa jeunesse.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Oberriet',
    'Wohnort fr': 'Oberriet',
    Geburtsdatum: '08.10.1965',
    'Beruf de': 'Sportmanager, Kleinunternehmer',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '3',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SZ',
    Nachname: 'Kuprecht',
    Vorname: 'Alex',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2003',
    'DabeiSeit fr': 'Au Conseil des États depuis 2003',
    'Alte Texte DE':
      'Versicherungslobbyist und gemeinsam mit Peter Föhn ein Teil der Doppel-SVP-Vertretung des Kantons Schwyz.',
    'Text de':
      'Der in Pfäffikon wohnhafte Versicherungsfachmann sitzt seit 2003 im Ständerat. Kuprecht dürfte seine Karriere mit dem Ständeratspräsidium 2020/21 krönen.',
    'BAT DE': 'fre',
    'Text fr':
      "Le spécialiste en assurance, qui vit à Pfäffikon, est membre du Conseil des États depuis 2003. La présidence du Conseil des États devrait venir couronner la carrière politique d'Alex Kuprecht en 2020/21.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Pfäffikon',
    'Wohnort fr': 'Pfäffikon',
    Geburtsdatum: '22.12.1957',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '4',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'AG',
    Nachname: 'Kälin',
    Vorname: 'Irène',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2017',
    'DabeiSeit fr': 'Au Conseil national depuis 2017',
    'Alte Texte DE': '',
    'Text de':
      'Irène Kälin rutschte im November 2017 für den zurückgetretenen Jonas Fricker in den Nationalrat nach. Kälin arbeitete als Gewerkschaftssekretärin bei der Unia und ist jetzt Präsidentin der Aargauer Dachorganisation der Arbeitnehmenden.\n',
    'BAT DE': 'Gelb',
    'Text fr':
      "Irène Kälin est entrée au Conseil national en novembre 2017 pour Jonas Fricker, qui avait démissionné. Elle a travaillé comme secrétaire syndical chez Unia et est actuellement présidente de l'association faîtière des employés en Argovie.",
    'BAT FR': '',
    'Wohnort de': 'Schinznach',
    'Wohnort fr': 'Schinznach',
    Geburtsdatum: '06.02.1987',
    'Beruf de': 'Nationalrätin und Mutter',
    'Beruf fr': 'Politicienne et mère'
  },
  {
    Elected: 'Ja',
    Sitznummer: '4',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'GE',
    Nachname: 'Mazzone',
    Vorname: 'Lisa',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Ständerat seit 2019, im Nationalrat von 2015-2019',
    'DabeiSeit fr':
      'Au Conseil des Etats depuis 2019, au Conseil national de 2015 à 2019',
    'Alte Texte DE': 'Die junge Grüne ist Koordinatorin von Pro Velo Genf.',
    'Text de':
      'Die Genferin ist Vizepräsidentin der Grünen und insbesondere als Sicherheitspolitikerin in Erscheinung getreten. Mazzone ist auch ausserhalb des Parlaments äusserst aktiv. Sie engagiert sich in Organisationen wie WWF, Pro Natura, Public Eye und in der Gesellschaft für bedrohte Völker.',
    'BAT DE': 'daf',
    'Text fr':
      "Très présente dans les médias, la Genevoise a atteint une notoriété nationale depuis son élection à la vice-présidence du parti. En siégeant à la commission de politique de sécurité, elle s'est mise en avant sur des dossiers chauds: achat d'avions, exportation de matériel militaire, réforme du service civil. Elle milite aussi pour le mariage pour tous et l'accès à la procréation médicalement assistée. La Verte porte la voix d'organisations telles que le WWF, ATE, Pro Natura ou Public Eye.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Genf',
    'Wohnort fr': 'Genève',
    Geburtsdatum: '25.01.1988',
    'Beruf de': '',
    'Beruf fr': 'Politicienne professionnelle'
  },
  {
    Elected: 'Ja',
    Sitznummer: '5',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'LU',
    Nachname: 'Estermann',
    Vorname: 'Yvette',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2010',
    'DabeiSeit fr': 'Au Conseil national depuis 2010',
    'Alte Texte DE':
      'Die gebürtige Slowakin kümmert sich vor allem um Aussenpolitik und Gesundheitsthemen. Sie ist auch Mitglied der Geschäftsprüfungskommission. Ihr grösster Erfolg: Sie erreichte, dass auf dem Bundeshaus künftig immer eine Schweizerfahne weht.',
    'Text de':
      'Estermann kümmert sich vor allem um Aussenpolitik und Gesundheitsthemen. Die Ärztin macht regelmässig mit eher ausfgefallenen Vorstössen von sich reden. So kämpft sie seit Jahren für die Abschaffung der Sommerzeit. Ihr meistbeachteter Erfolg bisher: Sie erreichte, dass auf dem Bundeshaus immer eine Schweizerfahne weht.',
    'BAT DE': 'fre',
    'Text fr':
      "Militante de longue date pour l’abolition de l’heure d’été, Yvette Estermann se fait également remarquer par ses propositions insolites, son plus grand succès étant d’avoir obtenu qu'un drapeau suisse flotte en permanence sur le Palais fédéral. La médecin lucernoise s'occupe principalement des questions de santé public et de politique étrangère.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Kriens',
    'Wohnort fr': 'Kriens',
    Geburtsdatum: '26.02.1967',
    'Beruf de': 'Ärztin, Beraterin',
    'Beruf fr': 'Médecin, consultante'
  },
  {
    Elected: 'Ja',
    Sitznummer: '5',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'GL',
    Nachname: 'Hefti',
    Vorname: 'Thomas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2014',
    'DabeiSeit fr': 'Au Conseil des États depuis 2014',
    'Alte Texte DE':
      'Der Rechtsanwalt aus Schwanden wurde vor einem Jahr zum Nachfolger des im Amt verstorbenen Pankraz Freitag gewählt. Daneben ist er Gemeindepräsident von Glarus Süd, einer der drei aus der Fusion hervorgegangenen neuen Glarner Gemeinden.',
    'Text de':
      'Thomas Hefti folgte 2014 auf den im Amt verstorbenen Ständerat Pankraz Freitag. Davor war der 60-jährige Rechtsanwalt Gemeindpräsident von Glarus Süd. Im Ständerat kümmert er sich vor allem um Finanz- und Wirtschaftspolitik.',
    'BAT DE': 'fre',
    'Text fr':
      "Thomas Hefti a succédé à Pankraz Freitag, décédé en fonction en 2014. Auparavant, l'avocat de 60 ans était le président de Glaris Sud. Il siège dans quatre commissions du Conseil des Etats: Finances, affaires juridiques, économie et redevances et dans une sous-commission des finances.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Schwanden',
    'Wohnort fr': 'Schwanden',
    Geburtsdatum: '30.10.1959',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '6',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Lega',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'TI',
    Nachname: 'Quadri',
    Vorname: 'Lorenzo',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Quadri ist Chefredaktor des Lega-Blatts “Domenica della Mattina”, das im Tessin für seine politischen Kampagnen gefürchtet ist. Er sitzt auch im Stadtrat von Lugano. In Bern eine unauffällige Figur. Mitglied der Verkehrskommission.',
    'Text de':
      'Quadri ist Chefredaktor des Lega-Blatts “Il Mattino della Domenicaa”, das im Tessin für seine politischen Kampagnen gefürchtet ist. Er sitzt auch im Stadtrat von Lugano. In Bern eine unauffällige Figur.',
    'BAT DE': 'fre',
    'Text fr':
      'Lorenzo Quadri est directeur du journal gratuit de la Lega "Il Mattino della Domenicaa", un redoutable organe de presse qui inspire la crainte au Tessin en raison de ses campagnes politiques. Il est également membre de l’exécutif de la ville de Lugano. Un personnage pourtant bien discret à Berne.',
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lugano',
    'Wohnort fr': 'Lugano',
    Geburtsdatum: '05.11.1974',
    'Beruf de': 'Direktor vom Mattino della Domenica',
    'Beruf fr': 'Directeur du Mattino della Domenica'
  },
  {
    Elected: 'Ja',
    Sitznummer: '6',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'NE',
    Nachname: 'Vara',
    Vorname: 'Céline',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      '2015 verloren die Neuenburger Grünen ihren Nationalratssitz an die Arbeiterpartei. Celine Vara gelang es, das Mandat im Bundeshaus wieder zu ihrer Partei zurückzuholen. Das Ergebnis erstaunte nicht. Die Ambitionen der Anwältin waren seit langem bekannt. Energisch und eloquent wurde Celine Vara zum Stern der Neuenburger Grünen. Auch darum wurde sie Vizepräsidentin der Grünen Partei Schweiz.',
    'BAT DE': 'Gelb',
    'Text fr':
      "C'est elle qui met fin à la présence du POP neuchâtelois à Berne. Céline Vara a piqué le siège à son allié, puisque les listes des deux partis étaient apparentés. L'issue n'est pas surprenant sachant que l'avocate avait clairement affiché ses ambitions avant même le début de la campagne. Energique, éloquente, Céline Vara a très tôt revêtu le costume de nouvelle star des Verts dans son canton. Une image que son accès à la vice-présidence du parti suisse a consolidé.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Cressier',
    'Wohnort fr': 'Cressier',
    Geburtsdatum: '04.10.1984',
    'Beruf de': 'Anwältin',
    'Beruf fr': 'Avocate, députée'
  },
  {
    Elected: 'Ja',
    Sitznummer: '7',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'TG',
    Nachname: 'Graf-Litscher',
    Vorname: 'Edith',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2005',
    'DabeiSeit fr': 'Au Conseil national depuis 2005',
    'Alte Texte DE':
      'Die in Frauenfeld wohnhafte Gewerkschaftssekretärin hat sich einen Namen als Medien- und Sicherheitspolitikerin gemacht. So präsentierte sie etwa nach dem knappen Ja zum RTVG rasch Positionierungsvorschläge für die SRG.',
    'Text de':
      'Die in Frauenfeld wohnhafte Gewerkschaftssekretärin politisiert vor allem in den Bereichen Verkehr, Gesundheit und Medien. Als Präsidentin der Verkehrskommission äussert sie sich regelmässig mit deutlichen Worten zu den Problemen bei den SBB und bei der Post.',
    'BAT DE': 'fre',
    'Text fr':
      "Habitant à Frauenfeld, la secrétaire du puissant Syndicat du personnel des transports (SEV) intervient principalement dans les domaines des transports, de la santé et des médias. En tant que présidente de la Commission des transports, elle s'exprime régulièrement sur les problèmes des CFF et de La Poste en faisant preuve d’une très bonne connaissance des dossiers.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Frauenfeld',
    'Wohnort fr': 'Frauenfeld',
    Geburtsdatum: '25.03.1964',
    'Beruf de': 'Gewerkschaftssekretärin SEV',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '7',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'JU',
    Nachname: 'Juillard',
    Vorname: 'Charles',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019',
    'DabeiSeit fr': 'Au Conseil des États depuis 2019.',
    'Alte Texte DE': '',
    'Text de':
      'Charles Juillard ist das Gesicht und die Stimme der CVP im Jura. Als Präsident der Finanzdirektorenkonferenz war der Regierungsrat in den letzten Jahren über die Kantonsgrenzen hinaus aktiv. Juillard kennt die Mechanismen des Politgeschäfts bis in letzte Details, was ihm die Arbeit im Bundeshaus erleichtern wird. Der Jurassier ist ein kluger, unaufgeregter Gesprächspartner.',
    'BAT DE': 'Gelb',
    'Text fr':
      'L’homme fort de l’actuel gouvernement a dirigé les finances du Jura d’une main de fer. Avec ses plans d’austérité, le grand argentier a tenu la barque. Pour le vice-président du PDC Suisse et président de la puissante Conférence des directeurs cantonaux des finances, accéder au Conseil des Etats est la plus logique des suites. ',
    'BAT FR': '',
    'Wohnort de': 'Pruntrut',
    'Wohnort fr': 'Porrentruy',
    Geburtsdatum: '17.12.1962',
    'Beruf de': 'Jurist',
    'Beruf fr': 'Juriste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '8',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'FR',
    Nachname: 'Andrey',
    Vorname: 'Gerhard',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der Unternehmer ist Mitbegründer und Partner von Liip, eine  Softwarefirma für Internetlösungen. Sein Profil als Unternehmer hat die Wähler offensichtlich überzeugt. Der Neuling im Parlament beschäftigt mehr als 180 Mitarbeiter und war bisher noch nie politisch engagiert. Andrey ist ausserdem Vizepräsident der Schweizer Grünen. Er ist Verheiratet und Vater von zwei Kindern. Er ist von deutscher Muttersprache stammt aber von Grenchen-Paccot und damit perfekt bilingue was ihm seine Arbeit in Bern erleichtern wird.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Entrepreneur, Co-fondateur et partenaire de Liip, une entreprise de développement de solutions internet, Gerhard Andrey est aussi vice-président des Verts suisses. Marié et père de deux enfants, son profil d’entrepreneur actif dans le développement durable a manifestement séduit. Le nouvel élu emploie plus de 180 collaborateurs et ne s’est jamais, jusque-là, investi en politique. De langue maternelle allemande, le citoyen de Granges-Paccot aura sa tâche facilitée à Berne de par son bilinguisme. Il a pris le temps de fonder son action écologique, privilégiant l’économie circulaire et le management social.',
    'BAT FR': '',
    'Wohnort de': 'Granges-Paccot',
    'Wohnort fr': 'Granges-Paccot',
    Geburtsdatum: '21.01.1976',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '8',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'BL',
    Nachname: 'Graf',
    Vorname: 'Maya',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Ständerat seit 2019, im Nationalrat von 2001 bis 2019',
    'DabeiSeit fr':
      'Au Conseil des Etats depuis 2019, au Conseil national de 2001 à 2019',
    'Alte Texte DE':
      'Die ehemalige Nationalratspräsidentin und Biobäuerin engagiert sich für Landwirtschaftsthemen im Allgemeinen und gegen den Einsatz von Gentechnik im Speziellen.',
    'Text de':
      'Die ehemalige Nationalratspräsidentin und Biobäuerin engagiert sich für Landwirtschaftsthemen im Allgemeinen und gegen den Einsatz von Gentechnik im Speziellen.',
    'BAT DE': 'fre',
    'Text fr':
      "L'ancienne présidente du Conseil national et agricultrice bio s'engage d’une manière générale sur les questions d’agriculture et plus particulièrement contre l'utilisation des manipulations génétiques. En 2003, elle était l'un des personnages principaux du film documentaire \"Le génie helvétique\", de Jean-Stéphane Bron. Très populaire dans son canton, elle vise aussi le Conseil des Etats.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Sissach',
    'Wohnort fr': 'Sissach',
    Geburtsdatum: '28.02.1962',
    'Beruf de': 'dipl. Sozialarbeiterin HFS, Biobäuerin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '9',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'JU',
    Nachname: 'Fridez',
    Vorname: 'Pierre-Alain',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Fridez ist Mitglied der Sicherheitskommission. Er gehört zu den fleissigen Vorstoss-Schreibern. Dabei drückt auch seine berufliche Herkunft durch: Fridez ist Arzt.',
    'Text de':
      'Der Arzt aus Fontenais hat sich in seinen beiden ersten Legislaturen vor allem als Sicherheitspolitiker betätigt. Er kämpft unter anderem für weniger Waffenexporte und für einen Ausbau der Friedensförderung. ',
    'BAT DE': 'fre',
    'Text fr':
      "Au cours de ses deux premières législatures, le médecin de Fontenais a été surtout actif dans le domaine de la sécurité. Il se bat entre autres pour la réduction des exportations d'armes et pour le développement de la promotion de la paix.\n\n",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Fontenais',
    'Wohnort fr': 'Fontenais',
    Geburtsdatum: '20.11.1957',
    'Beruf de': '',
    'Beruf fr': 'Médecin généraliste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '9',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'VS',
    Nachname: 'Maret',
    Vorname: 'Marianne',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Ständerat seit 2019',
    'DabeiSeit fr': 'Au Conseil des États depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Sie ist seit mehr als fünf Jahren Vizepräsidentin der CVP des französischsprachigen Wallis. Im Kantonsparlament hat sie bereits eine 20-Jährige politischer Karriere hinter sich. In Bundespolitik ist Marianne Maret jedoch Novizin. Geschichte schreibt sie dennoch. Sie ist die erste Frau in der Walliser Geschichte im Ständerat.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Vice-présidente du PDC du Valais romand durant plus de 5 ans, une figure du parlement cantonal avec 20 ans de carrière politique derrière elle, Marianne Maret n’en est pas moins une novice en matière de politique fédérale. Peu importe: elle entre quoi qu’il arrive dans l’histoire valaisanne en tant que première sénatrice de son canton. L’ancienne président du village de Troistorrents, perché au-dessus de la ville industrielle de Monthey, est davantage centriste que son prédécesseur Jean-René Fournier, surtout sur les question économiques et environnementales.',
    'BAT FR': '',
    'Wohnort de': 'Troistorrents',
    'Wohnort fr': 'Troistorrents',
    Geburtsdatum: '15.06.1958',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '10',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'VS',
    Nachname: 'Roduit',
    Vorname: 'Benjamin',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2018',
    'DabeiSeit fr': 'Au Conseil national depuis 2018',
    'Alte Texte DE': '',
    'Text de':
      'Der Walliser gehört zum rechten Flügel seiner Partei. Als Rektor des Kollegiums Les Creuset in Sitten hat Roduit 2016 eine Veranstaltung gegen Homophobie abgesagt. In einem Vorstoss fordert er vom Bundesrat einen Bericht über die negativen Auswirkungen des Fleischverzichts.',
    'BAT DE': 'fre',
    'Text fr':
      "Arrivé en cours de législature pour remplacer Yannick Buttet, emporté par ses affaires de harcèlement, Benjamin Roduit est parvenu à sauver son siège. Situé sur l'aile droite de son parti, il a toutefois pris soin d'éviter les prises de position polémiques. En 2016, alors recteur du Collège des Creusets à Sion, il avait annulé un atelier de prévention sur l'homophobie. Cela lui avait valu un tollé.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Saillon',
    'Wohnort fr': 'Saillon',
    Geburtsdatum: '22.11.1962',
    'Beruf de': '',
    'Beruf fr': 'Professeur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '10',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'AG',
    Nachname: 'Knecht',
    Vorname: 'Hansjörg',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019, im Nationalrat von 2011 bis 2019',
    'DabeiSeit fr':
      'Au Conseil des Etats depuis 2019, au Conseil national de 2011 à 2019',
    'Alte Texte DE':
      'Knecht führt einen Mühlebetrieb in seinem Wohnort Leibstadt - ein Familienunternehmen. Im Nationalrat sitzt er in der Umwelt- und Energiekommission.',
    'Text de':
      'Knecht führt einen Mühlebetrieb in seinem Wohnort Leibstadt - ein Familienunternehmen. Im Nationalrat sitzt er in der Umwelt- und Energiekommission. Dieses Jahr kandidiert er auch für den Ständerat und muss in den zweiten Wahlgang. ',
    'BAT DE': 'fre',
    'Text fr':
      "Hansjörg Knecht dirige l’entreprise familiale de meunerie dans sa ville natale de Leibstadt, l'un des berceaux du nucléaire en Suisse. Il siège à la Commission de l'environnement, des transports et de l'énergie du Conseil national. Il s'est lancé cette année dans la course au Conseil national et  au Conseil des Etats dans son canton d'Argovie.",
    'BAT FR': 'Relu et complété par Lise',
    'Wohnort de': 'Leibstadt',
    'Wohnort fr': 'Leibstadt',
    Geburtsdatum: '24.03.1960',
    'Beruf de': 'Müllerei-Unternehmer, Präs. Hauseigentümerverband',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '11',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'VD',
    Nachname: 'Brélaz',
    Vorname: 'Daniel',
    Bisher: 'Schon früher',
    Geschlecht: 'm',
    'DabeiSeit de':
      'Nationalrat von 1979 à 1989, danach von 2007 bis 2011 und anschliessend wiedergewählt in 2015',
    'DabeiSeit fr':
      'Conseiller national de 1979 à 1989, puis de 2007 à 2011 et réélu en 2015',
    'Alte Texte DE':
      'Brélaz war lange Jahre Stadtpräsident von Lausanne und von 2007 bis 2011 schon einmal im Nationalrat.',
    'Text de':
      'Brélaz ist ein politisches Urgestein. 1979 wurde er erstmals Nationalrat und war weltweit der erste Grüne, der in ein nationales Parlament gewählt wurde. Brélaz gehörte dem Rat bis 1989 an, dann wieder von 2007 bis 2011 und schliesslich ein drittes Mal seit 2015. Der Grüne war jahrelang Stadtpräsident von Lausanne. In der Westschweiz wird er wegen seiner Grösse und seinem Gewicht oft als "géant vert", als "grüner Riese" bezeichnet. Seien Katzenkrawatten sind legendär.',
    'BAT DE': 'daf',
    'Text fr':
      'En 1979, Daniel Brelaz était le premier écologiste au monde à être élu à dans un parlement national. Il y sera resté dix ans, avant de revenir par deux fois de 2007 à 2011 et depuis 2015. Ancien syndic de Lausanne, le "géant vert" – en referance à son physique hors norme – est une figure connue des Romands. Si ces cravates sont légendaires, il n\'a pas vraiment réussi à percer sur la scène nationale. Il a déjà assuré qu\'il se retirerait en cours de législature.',
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lausanne',
    'Wohnort fr': 'Lausanne',
    Geburtsdatum: '04.01.1950',
    'Beruf de': '',
    'Beruf fr': 'Syndic retraité'
  },
  {
    Elected: 'Ja',
    Sitznummer: '11',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'VS',
    Nachname: 'Rieder',
    Vorname: 'Beat',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015',
    'DabeiSeit fr': 'Au Conseil des États depuis 2015',
    'Alte Texte DE':
      'Neben Fournier der andere siegreiche Kandidat, der die Walliser CVP-Festung im Ständerat gegen den freisinnigen Angriff abgewehrt hat. Rieder ersetzt René Imoberdorf, der zurückgetreten ist.',
    'Text de':
      'Beat Rieder ist ein typischer Vertreter der Randregionen. Der Rechtsanwalt und Notar aus dem Lötschental wollte beispielsweise mit einer Interpellation vom Bundesrat wissen, wie es um die Zukunft der (von Wallisern dominierten) Skialpinismus-Mannschaft des Grenzwachtkorps stehe. ',
    'BAT DE': 'fre',
    'Text fr':
      "Contrairement au siège qui revient traditionnellement au Valais romand, son fauteuil de sénateur n'a jamais été menacé. Beat Rieder est sans concurrence dans le Haut-Valais. A Berne, il se présente sans cesse en défenseur des régions de montagne. Un principe qui paraît dicter toutes ses prises de position.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Wiler',
    'Wohnort fr': 'Wiler',
    Geburtsdatum: '12.02.1963',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '12',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'ZH',
    Nachname: 'Kutter',
    Vorname: 'Philipp',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der Wädenswiler Philipp Kutter ist vollamtlicher Politiker. Seit 2006 sitzt er im Stadtrat von Wädenswil, seit 2010 ist er Stadtpräsident. 2015 verpasste er als Drittplatzierter die Wahl in den Nationalrat, rückte aber nach dem Rücktritt von Barbara Schmid-Federer ins Parlament nach.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Philipp Kutter est un homme politique professionnel. Il est membre du conseil municipal de Wädenswil depuis 2006 et en est le maire depuis 2010. En 2015, il a raté de peu l'élection au Conseil national, mais a accédé au Parlement après la démission de Barbara Schmid-Federer.",
    'BAT FR': '',
    'Wohnort de': 'Wädenswil',
    'Wohnort fr': 'Wädenswil',
    Geburtsdatum: '31.08.1975',
    'Beruf de': 'lic. phil., Stadtpärisident, PR-Berater',
    'Beruf fr': 'Président de commune, conseiller en communication'
  },
  {
    Elected: 'Ja',
    Sitznummer: '12',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Parteilos',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SH',
    Nachname: 'Minder',
    Vorname: 'Thomas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2011',
    'DabeiSeit fr': 'Au Conseil des États depuis 2011',
    'Alte Texte DE':
      'Thomas Minder ist eine Art nationaler Robin Hood – bekannt geworden als Vater der Abzocker-Initiative. Im Ständerat ist er ein Einzelkämpfer geblieben. Er selbst hebt gerne seine Unabhängigkeit zurück. In Umweltthemen politisiert er sehr links. In Ausländerfragen sehr rechts.',
    'Text de':
      'Thomas Minder ist eine Art nationaler Robin Hood – bekannt geworden als Vater der Abzocker-Initiative. Im Ständerat ist er ein Einzelkämpfer geblieben. Er selbst streicht gerne seine Unabhängigkeit hervor. In Umweltthemen politisiert er sehr links. In Ausländerfragen sehr rechts.',
    'BAT DE': 'fre',
    'Text fr':
      "Thomas Minder est parfois présenté comme une sorte de Robin des Bois helvétique – rendu célèbre pour avoir été à l'origine de l'initiative contre les rémunérations abusives. Au conseil des Etats, il est resté un combattant solitaire. Lui-même aime souligner son indépendance. Sur les questions environnementales, il est proche de la gauche et des Verts. En ce qui concerne la politique des étrangers, il est très à droite. Il siège d'ailleurs dans le groupe UDC.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Neuhausen am Rheinfall',
    'Wohnort fr': 'Neuhausen am Rheinfall',
    Geburtsdatum: '26.12.1960',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '13',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'PdA',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'NE',
    Nachname: 'De la Reussille',
    Vorname: 'Denis',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Denis De la Reussille hat in Neuenburg den Grünen einen Sitz weggeschnappt.',
    'Text de':
      'De la Reussille ist als Vertreter der Partei der Arbeit ein Exot im Nationalrat. Er schloss sich der Fraktion der Grünen an und entdeckte nebst der Sozial- auch die Aussenpolitik für sich. Sein Einfluss blieb während der letzten Legislatur gering.',
    'BAT DE': 'fre',
    'Text fr':
      "En tant que représentant de l'extrême gauche (POP), le Neuchâtelois est une espèce rare sous la Coupole. Membre du groupe des Verts depuis 2015, le très populaire membre de l'exécutif du Locle n'a pas réussi à faire de son exception un atout à Berne et ne s’est que rarement illustré lors de la dernière législature.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Le Locle',
    'Wohnort fr': 'Le Locle',
    Geburtsdatum: '24.10196',
    'Beruf de': 'Gemeindepräsident',
    'Beruf fr': 'Président de commune'
  },
  {
    Elected: 'Ja',
    Sitznummer: '13',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'SG',
    Nachname: 'Würth',
    Vorname: 'Benedikt',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019',
    'DabeiSeit fr': 'Au Conseil des États depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der Regierungsrat des Kantons St. Gallen wurde im Mai 2019 als Nachfolger von Karin Keller-Sutter gewählt.',
    'BAT DE': 'Gelb',
    'Text fr':
      "En mai 2019, le conseiller d'Etat saint-gallois a été élu pour succéder à Karin Keller-Sutter, devenue conseillère fédérale.",
    'BAT FR': '',
    'Wohnort de': 'Berg (SG)',
    'Wohnort fr': 'Berg (SG)',
    Geburtsdatum: '20.01.2968',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '14',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SG',
    Nachname: 'Reimann',
    Vorname: 'Lukas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Der Jurist profilierte sich parteiintern rasch als rechts-aussen Politiker. Vor eineinhalb Jahren übernahm er das Auns-Präsidium – und wartete alsbald mit einem Coup auf: Er lud den britischen EU-Kritiker Nigel Farage als Auns-Gast nach Winterthur ein. Der Kampf gegen eine Annäherung an die EU ist ohnehin ein politischer Schwerpunkt des Wilers.',
    'Text de':
      'Der Präsident der Aktion für eine unabhängige und neutrale Schweiz\n(Auns) hat sich den Kampf gegen eine Annäherung an die EU auf die Fahne geschrieben. Er ist europaweit gut vernetzt mit EU-Kritikern. Obwohl die Europapolitik mit den Debatten um das Rahmenabkommen in den letzten Jahren wieder mehr zum Thema wurde, ist es eher stiller geworden um Reimann.',
    'BAT DE': 'fre',
    'Text fr':
      "Le président de l'Action pour une Suisse indépendante et neutre (ASIN) a fait de la lutte contre le rapprochement avec l'UE sa mission. Il est en étroite relations dans toute l'Europe avec les plus fervents anti-européens. Bien que la politique européenne soit redevenue une question plus importante ces dernières années avec les débats sur l'accord-cadre, l’ASIN est restée plutôt calme durant l’ère de Lukas Reimann.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Wil',
    'Wohnort fr': 'Wil',
    Geburtsdatum: '18.09.1982',
    'Beruf de': 'Jurist',
    'Beruf fr': 'Juriste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '14',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BE',
    Nachname: 'Salzmann',
    Vorname: 'Werner',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019, im Nationalrat von 2015 bis 2019',
    'DabeiSeit fr':
      'Au Conseil des Etats depuis 2019, au Conseil national de 2015 à 2019',
    'Alte Texte DE': 'Der Steuerexperte ist Präsident der Berner SVP.',
    'Text de':
      'Der Präsident der bernischen SVP und Oberst politisiert ehrgeizig, zielstrebig, kantig. In der SVP-Fraktion ist er eine wichtige Figur. National in Erscheinung getreten ist er im erfolglosen Kampf gegen die Verschärfung des Waffenrechts. ',
    'BAT DE': 'daf',
    'Text fr':
      "Président de l'UDC bernoise et colonel à l'armée, Wener Salzmann s'est spécialisé depuis 2015 sur les questions sécuritaire. Figure importante de son groupe parlementaire, il a beaucoup fait parler de lui en incarnant en Suisse alémanique le combat contre la directive UE sur les armes. Une votation qu'il a nettement perdue.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Mülchi',
    'Wohnort fr': 'Mülchi',
    Geburtsdatum: '05.11.1962',
    'Beruf de': 'Ing. Agr. FH, Chefexperte Landwirtschaft',
    'Beruf fr': 'Ingénieur agronome'
  },
  {
    Elected: 'Ja',
    Sitznummer: '15',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SOL',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'GE',
    Nachname: 'Prezioso',
    Vorname: 'Stéfanie',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Stefanie Prezioso, geboren in La Chaux-de-Fonds, ist Professorin für Zeitgeschichte an der Universität Lausanne. Sie ist Expertin für die Arbeiterbewegung, die Einwanderungsgeschichte und die Geschichte des Totalitarismus. Sie stammt selber aus einer italienischen Einwandererfamilie der Arbeiterklasse. Sie engagiert sich für die Rechte der Frauen. In der Legislative hat sie bisher wenig Erfahrungen gesammelt. Sie war 2014 nur wenige Monate Stadträtin in Genf.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Née à la Chaux-de-Fonds, Stefanie Prezioso enseigne l’histoire contemporaine à l’Université de Lausanne avec le statut de professeure associée. Ell est une spécialiste du mouvement ouvrier, de l’immigration et de l’histoire du totalitarisme. Elle est issue d’une famille ouvrière de l’immigration italienne. Membre de SolidaritéS, elle représentera Ensemble à Gauche à la Chambre du peuple dont elle est l’unique élue. Bien qu’elle n’est arrivée qu’en troisième position de sa liste, c’est elle qui siégera à Berne puisque la mieux élue, Jocelyne Haller, de même que le premier vient-ensuite, lui ont cédé la place. Active notamment dans les mobilisations pour les droits des femmes, très engagée dans le mouvement SolidaritéS, Stefanie Prezioso n’a que peu d’expérience en tant qu’élue. Elle n’a siégé que quelques mois en tant que conseillère municipale de la Ville de Genève en 2014.',
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Genf',
    'Wohnort fr': 'Genève',
    Geburtsdatum: '25.01.1969',
    'Beruf de': 'Professorin an der Universität Lausanne',
    'Beruf fr': "Professeure à l'Université de Lausanne"
  },
  {
    Elected: 'Ja',
    Sitznummer: '15',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'SZ',
    Nachname: 'Reichmuth',
    Vorname: 'Othmar',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019',
    'DabeiSeit fr': 'Au Conseil des États depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Othmar Reichmuth ist gelernter Käser und Handelsfachmann. Er wurde 2010 in die Schwyzer Kantonsregierung gewählt. Reichmuth äussert sich bisweilen auch unkonventionell - und kritisiert beispielsweise als Bürgerlicher das Wachstum im Kanton Schwyz.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Othmar Reichmuth a commencé par un apprentissage de fromager avant de se lancer dans le commerce. Il a été élu au gouvernement du canton Schwyz en 2010. Il s’exprime parfois de manière peu conventionnelle, car il a par exemple critiqué la croissance du canton de Schwyz malgré son appartenance au camp bourgeois.',
    'BAT FR': 'pas relu',
    'Wohnort de': 'Illgau',
    'Wohnort fr': 'Illgau',
    Geburtsdatum: '24.01.1964',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '16',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SG',
    Nachname: 'Egger',
    Vorname: 'Mike',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2018',
    'DabeiSeit fr': 'Au Conseil national depuis 2018',
    'Alte Texte DE': '',
    'Text de':
      'Mike Egger arbeitet in der Fleischverarbeitung. Im November 2018 rutschte er für Toni Brunner in den Nationalrat nach. Jetzt sichert er sich die Wiederwahl.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Mike Egger travaille dans la transformation de la viande. En novembre 2018, il a remplacé l'ancien président de l'UDC Toni Brunner au Conseil national.",
    'BAT FR': '',
    'Wohnort de': 'Berneck',
    'Wohnort fr': 'Berneck',
    Geburtsdatum: '02.08.1992',
    'Beruf de': 'Fleischfachmann',
    'Beruf fr': 'Expert de la viande'
  },
  {
    Elected: 'Ja',
    Sitznummer: '16',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'TG',
    Nachname: 'Stark',
    Vorname: 'Jakob',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der frühere Journalist (unter anderem beim «Tages-Anzeiger» und bei der «Weltwoche») ist seit 2006 Regierungsrat des Kantons Thurgau. Stark gilt als typischer Vertreter des gemässigten Thurgauer SVP-Flügels. 2011 wollte er Bundesrat werden, scheiterte aber bereits parteiintern.',
    'BAT DE': 'Gelb',
    'Text fr':
      'L\'ancien journaliste (du "Tages-Anzeiger" et de la "Weltwoche" entre autres) est membre du Conseil d’Etat de Thurgovie depuis 2006. Le chef du département des finances est considéré comme un représentant de l\'aile modérée de l\'UDC du canton de Thurgovie. En 2011, Jakob Stark voulait devenir conseiller fédéral, mais il a déjà échoué lors de la sélection interne au parti.',
    'BAT FR': 'pas relu',
    'Wohnort de': 'Weinfelden',
    'Wohnort fr': 'Weinfelden',
    Geburtsdatum: '08.09.1958',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '17',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'VD',
    Nachname: 'Michaud Gigon',
    Vorname: 'Sophie',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Sophie Michaud Gigon gilt als künftige Parteigrösse bei den Waadtländer Grünen. Die Lausanner Gemeinderätin ist eloquent, energiegeladen und umgänglich. Seit 2017 ist sie Generalsekretärin des Westscheizer Verbraucherverbands, was ihr viele öffentliche Auftritte ermöglicht. Davor war sie während neun Jahren als Sekretärin von Pro Natura tätig und leitete das Champ-Pittet-Zentrum bei Yverdon. Sie hat einen Abschluss in Politikwissenschaft und spricht Französisch und Deutsch.',
    'BAT DE': 'Gelb',
    'Text fr':
      "La Verte Sophie Michaud Gigon incarne la Fédération romande des consommateurs, dont elle est la secrétaire générale depuis 2017. Avant cela, elle a été neuf années durant la secrétaire romande de Pro Natura, dirigeant le centre de Champ-Pittet près d'Yverdon. Diplômée en sciences politiques, français et allemand, elle siège au Conseil communal de Lausanne.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lausanne',
    'Wohnort fr': 'Lausanne',
    Geburtsdatum: '20.01.1975',
    'Beruf de': '',
    'Beruf fr':
      'Secrétaire générale de la Fédération romande des consommateurs (FRC)'
  },
  {
    Elected: 'Ja',
    Sitznummer: '17',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'AG',
    Nachname: 'Burkart',
    Vorname: 'Thierry',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019, im Nationalrat von 2015 bis 2019',
    'DabeiSeit fr':
      'Au Conseil des Etats depuis 2019, au Conseil national de 2015 à 2019',
    'Alte Texte DE':
      'Burkart ist seit 2011 Mitglied des Aargauer Grossen Rats. Seine politischen Schwerpunkte setzt der Rechtsanwalt in der Verkehrs-, Wirtschafts- und Sicherheitspolitik. ',
    'Text de':
      'Thierry Burkart erzielte im Rennen um den Aargauer Ständeratssitz am meisten Stimmen, muss aber trotzdem in den zweiten Wahlgang. Der Rechtsanwalt aus Baden ist vor allem als Verkehrspolitiker in Erscheinung getreten. ',
    'BAT DE': 'fre',
    'Text fr':
      'Arrivé en 2015 au Conseil national, le jeune Argovien Thierry Burkart ambitionne de succéder à Philipp Müller au Conseil des Etats. Lors de sa première législature à Berne, cet avocat a été actif avant tout dans le domaine de la politique des transports. ',
    'BAT FR': 'relu et réécrit par Lise',
    'Wohnort de': 'Baden',
    'Wohnort fr': 'Baden',
    Geburtsdatum: '21.08.1975',
    'Beruf de': 'Rechtsanwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '18',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'AR',
    Nachname: 'Zuberbühler',
    Vorname: 'David',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Überraschend errang der Kantonsrat den Ausserrhoder Nationalratssitz auf Kosten der FDP.',
    'Text de':
      'Der pointiert rechts politisierende Zuberbühler war in seiner ersten Legislatur vor allem als Sicherheitspolitiker aktiv. Seine Wahl vor vier Jahren war eine Überraschung. Dass er nun seinen Sitz gegen FDP-Kandidatin Jennifer Abderhalden verteidigen konnte, erstaunte viele in Ausserrhoden ebenfalls.',
    'BAT DE': 'fre',
    'Text fr':
      "Au cours de sa première législature, David Zuberbühler, qui se situe à l'aile droite de l'UDC, s'est avant tout montré actif dans le domaine de la sécurité. Son élection il y a quatre ans avait été une surprise. Le fait qu'il soit parvenu à défendre son siège contre la candidate du PLR Jennifer Abderhalden a également surpris beaucoup de monde en Rhodes-Extérieures.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Herisau',
    'Wohnort fr': 'Herisau',
    Geburtsdatum: '20.02.1979',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '18',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'VD',
    Nachname: 'Thorens Goumaz',
    Vorname: 'Adèle',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Ständerat seit 2019, im Nationalrat von 2007-2019',
    'DabeiSeit fr':
      'Au Conseil des Etats depuis 2019, au Conseil national de 2007 à 2019',
    'Alte Texte DE':
      'Thorens ist Co-Präsidentin der Grünen Schweiz und Mitglied der Umwelt- und Raumplanungskommission. Ökologische Themen sind denn auch ihr Kerngebiet.',
    'Text de':
      'Thorens war Co-Präsidentin der Grünen Schweiz. Ökologische Themen sind denn auch ihr Kerngebiet, aktuell zum Beispiel mit dem Kampf gegen den Einsatz von Pestiziden in der Landwirtschaft. Die Philosophin hat das eigene Potenzial und jenes der Waadtländer Grünen bei weitem noch nicht ausgeschöpft.',
    'BAT DE': 'fre',
    'Text fr':
      "Ancienne coprésidente des Verts, la Vaudoise Adèle Thorens est toujours une des voix écologistes qui compte le plus à Berne. Elle est notamment aux premières lignes pour combattre l'utilisation de pesticides, ou pour promouvoir une alimentation plus respectueuse du climat avec un argiculture locale. La philosophe de formation est aussi à la pointe pour verdir la place financière suisse, avec des succès qui commencent à poindre leur nez.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lausanne',
    'Wohnort fr': 'Lausanne',
    Geburtsdatum: '15.12.1971',
    'Beruf de': 'Berufspolitikerin',
    'Beruf fr': 'Politicienne professionnelle'
  },
  {
    Elected: 'Ja',
    Sitznummer: '19',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'BE',
    Nachname: 'Baumann',
    Vorname: 'Kilian',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der Biobauer und Grossrat ist der Sohn von Ruedi und Stephanie Baumann, die beide einst ebenfalls im Nationalrat sassen. Er für die Grünen, sie für die SP. 2001 wanderten sie nach Südfrankreich aus und Kilian Baumann übernahm den Biobauernhof.',
    'BAT DE': 'Gelb',
    'Text fr':
      "L'agriculteur bio et membre du Grand Conseil est le fils de Ruedi et Stephanie Baumann, qui ont également été politiciens au Conseil national. Lui pour les Verts, elle pour le PS. En 2001, ils ont émigré dans le sud de la France et Kilian Baumann a repris la ferme biologique.",
    'BAT FR': '',
    'Wohnort de': 'Suberg',
    'Wohnort fr': 'Suberg',
    Geburtsdatum: '14.12.1980',
    'Beruf de': 'Biobauer, Grossrat, Hausmann',
    'Beruf fr': 'Agriculteur bio, homme au foyer'
  },
  {
    Elected: 'Ja',
    Sitznummer: '19',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'TI',
    Nachname: 'Chiesa',
    Vorname: 'Marco',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019, Nationalrat von 2015-2019',
    'DabeiSeit fr':
      'Au Conseil des Etats depuis 2019, au Conseil national de 2015 à 2019',
    'Alte Texte DE':
      'Marco Chiesa ersetzt seinen Parteikollegen Pierre Rusconi im Nationalrat. Der frühere Banker, der unter anderem für die UBS in Mailand arbeitete, führt heute ein Seniorenzentrum im Tessin. Er ist leidenschaftlicher Jäger.  ',
    'Text de':
      'Der frühere Banker, der für die UBS in Mailand arbeitete, setzt sich vor allem für regionalpolitische Anliegen ein. Auch forderte er eine zusätzliche Gebühr für Fahrzeuge, die im Ausland immatrikuliert sind und durch den Gotthardstrassentunnel fahren.',
    'BAT DE': 'fre',
    'Text fr':
      "L'ancien banquier, qui travaillait pour l’UBS à Milan, s'occupe essentiellement des questions de politique régionale. Il a également exigé une taxe supplémentaire pour les véhicules immatriculés à l'étranger qui traversent le tunnel du Gothard. Il a tenté en vain d'interdire la double nationalité pour les conseillers fédéraux.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lugano',
    'Wohnort fr': 'Lugano',
    Geburtsdatum: '10.10.1974',
    'Beruf de': 'Direttore sociosanitario',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '20',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'AG',
    Nachname: 'Heimgartner',
    Vorname: 'Stefanie',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Stefanie Heimgartner setzt sich stark für den Motorisierten Individualverkehr ein. Der 6-Spuren-Ausbau auf der A1 will sie so rasch wie möglich vorantreiben.',
    'BAT DE': '§',
    'Text fr':
      "Stefanie Heimgartner est une fervente partisane du transport individuel motorisé et veut réaliser l'extension à six voies de l'Autoroute A1 le plus rapidement possible.",
    'BAT FR': '',
    'Wohnort de': 'Baden',
    'Wohnort fr': 'Baden',
    Geburtsdatum: '25.04.1987',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '20',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'GL',
    Nachname: 'Zopfi',
    Vorname: 'Mathias',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': '2019',
    'DabeiSeit fr': '2019',
    'Alte Texte DE': '',
    'Text de':
      'Seine Wahl ist eine der grossen Überraschungen: Der Grüne Mathias Zopfi erobert im Kanton Glarus auf Kosten der SVP einen Ständeratssitz. Der 35-jährige Rechtsanwalt und Notar ist Mitinhaber einer Kanzlei in Glarus. Seit 2010 beziehungsweise 2011 ist Zopfi als Politiker auf kommunaler und kantonaler Ebene aktiv. Im Kantonsrat ist er Fraktionschef der Grünen.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Son élection est l'une des grandes surprises des élections fédérales de 2019: le Vert Mathias Zopfi est parvenu à conquérir un siège au Conseil des Etats du canton de Glaris aux dépens de l'UDC. L'avocat-notaire de 35 ans est associé dans un cabinet d'avocats à Glaris. Depuis 2010 et 2011, Zopif est actif en tant qu'homme politique au niveau communal et cantonal. Il est le chef du groupe parlementaire des Verts au Grand conseil.",
    'BAT FR': '',
    'Wohnort de': 'Engi',
    'Wohnort fr': 'Engi',
    Geburtsdatum: '14.12.1983',
    'Beruf de': 'Rechtsanwalt und Notar',
    'Beruf fr':
      'Avocat et notaire, directeur général et propriétaire de Zopfi & Partner GmbH'
  },
  {
    Elected: 'Ja',
    Sitznummer: '21',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'TG',
    Nachname: 'Egger',
    Vorname: 'Kurt',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Kurt Egger ist seit 1996 Mitinhaber und Geschäftsleiter einer Energie- und Umweltberatungsfirma. Seit 2015 ist er Parteipräsident der Grünen Thurgau. Als Unternehmer mit 25 Mitarbeitenden habe er bewiesen, dass mit einer umweltbewusste Energiepolitik lokale Arbeitsplätze geschaffen werden können. ',
    'BAT DE': 'Gelb',
    'Text fr':
      "Kurt Egger est copropriétaire et directeur d'une société de conseil en énergie et environnement depuis 1996. En 2015, il est devenu président des Verts thurgoviens. En tant qu'entrepreneur avec près de 25 employés, il estime avoir prouvé qu'une politique énergétique respectueuse de l'environnement peut créer des emplois locaux. ",
    'BAT FR': '',
    'Wohnort de': 'Eschlikon',
    'Wohnort fr': 'Eschlikon',
    Geburtsdatum: '19.01.1956',
    'Beruf de': 'Dipl. Masch. Ing. ETH/SIA, Energiefachmann',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '21',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'UR',
    Nachname: "Z'graggen",
    Vorname: 'Heidi',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      "Mit Heidi Z'graggen schickt der Kanton Uri erstmals in seiner Geschichte eine Frau in den Ständerat. Die langjährige Urner Regierungsrätin ist 2018 national bekannt geworden, als sie für die Nachfolge von CVP-Bundesrätin Doris Leuthard kandidierte, schliesslich aber Viola Amherd unterlag.",
    'BAT DE': 'Gelb',
    'Text fr':
      "Avec Heidi Z'graggen, le canton d'Uri envoie pour la première fois de son histoire une femme au Conseil des Etats. Celle qui fut longtemps conseillère d'Etat s'est fait connaître l'an dernier grâce à sa candidature au Conseil fédéral. Son aplomb, son caractère jovial et son assurance lui avaient même permis de réussire l'exploit de figurer sur le ticket final, avant de perdre face à Viola Amherd.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Erstfeld',
    'Wohnort fr': 'Erstfeld',
    Geburtsdatum: '01.02.1966',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '22',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'ZH',
    Nachname: 'Schaffner',
    Vorname: 'Barbara',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Energieexpertin und Physikerin politisierte seit 2011 im Zürcher Kantonsrat. Seit 2018 ist sie zudem Gemeindepräsidentin in Otelfingen. Im Kanton Zürich sorgte sie mit ihrem erfolgreichen Engagement gegen das neue Wassergesetz für Schlagzeilen.',
    'BAT DE': 'Gelb',
    'Text fr':
      "L'expert en énergie et physicienne est active au Grand-Conseil zurichois depuis 2011 et depuis 2018, elle est également maire d'Otelfingen. Dans le canton de Zurich, elle a fait la une des journaux avec son engagement contre la nouvelle loi sur l'eau.",
    'BAT FR': '',
    'Wohnort de': 'Otelfingen',
    'Wohnort fr': 'Otelfingen',
    Geburtsdatum: '28.07.1968',
    'Beruf de':
      'Dr. sc. nat. ETH, Physikerin Energieberatung/Geschäftsleiterin, Gemeindepräsidentin',
    'Beruf fr': 'Experte en énergie'
  },
  {
    Elected: 'Ja',
    Sitznummer: '22',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'SO',
    Nachname: 'Zanetti',
    Vorname: 'Roberto',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2010, im Nationalrat von 1999 bis 2003 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2010, précédement au National de 1999 à 2003',
    'Alte Texte DE':
      'Zanetti gilt als politischer Zwilling von Anita Fetz. Er präsidiert die gewichtige Wirtschaftskommission. Gilt nicht eben als Arbeitstier, doch seinen Voten hört man gerne zu.',
    'Text de':
      'Seit 2010 vertritt Roberto Zanetti den Kanton Solothurn im Ständerat, jetzt muss er in den zweiten Wahlgang. Zanetti ist Mitglied der Wirtschaftskomission und setzt sich für soziale Anligen ein.',
    'BAT DE': 'fre',
    'Text fr':
      "Depuis 2010, Roberto Zanetti représente le canton de Soleure au Conseil des États. Il est membre de la Commission économique et s'engage sur les questions sociales. «Robin le rouge» («der rote Röbu») est en politique depuis longtemps: à l'âge de 22 ans, il était déjà conseiller municipal.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Gerlafingen',
    'Wohnort fr': 'Gerlafingen',
    Geburtsdatum: '14.12.1954',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '23',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'SO',
    Nachname: 'Wettstein',
    Vorname: 'Felix',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Felix Wettstein ist seit 2010 im Solothurner Kantonsrat und setzt sich dort unter anderem für Klimaschutz-Themen ein. Er kandierte auch für den Ständerat.\n',
    'BAT DE': 'Gelb',
    'Text fr':
      "Felix Wettstein est membre du Grand conseil soleurois depuis 2010, où il s'occupe notamment de la protection du climat.",
    'BAT FR': '',
    'Wohnort de': 'Olten',
    'Wohnort fr': 'Olten',
    Geburtsdatum: '19.01.1958',
    'Beruf de': 'Dozent Fachhochschule',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '23',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'AI',
    Nachname: 'Fässler',
    Vorname: 'Daniel',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019, m Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Fässler ist im Hauptberuf Landammann und Vorsteher des Volkwirtschaftsdepartements seines Kantons. Entsprechend wird er als Nationalrat nicht sehr stark wahrgenommen.',
    'Text de':
      'Bereits im April wurde Daniel Fässler an der Landsgemeinde in Appenzell zum Ständerat gewählt - der Anwalt war damit der erste neu gewählte Ständerat der kommenden Legislatur. Zuvor sass Fässler acht Jahre im Nationalrat, wo er unter anderem als Umweltpolitiker in Erscheinung trat.',
    'BAT DE': 'fre',
    'Text fr':
      "Daniel Fässler a déjà été élu en avril au Conseil des États lors de la Landsgemeinde en Appenzell, devenant ainsi le premier conseiller aux États de cette législature. Auparavant, l'avocat a passé huit ans au Conseil national, où il s'est illustré, entre autres, sur les questions environnementales.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Appenzell',
    'Wohnort fr': 'Appenzell',
    Geburtsdatum: '22.08.1960',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '24',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BE',
    Nachname: 'Hess',
    Vorname: 'Erich',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Gegen Linke, gegen zuviel Ausländer, gegen Europa: Erich Hess macht schon seit mehreren Jahren Schlagzeilen als besonders radikaler SVP-Vertreter in Bern.',
    'Text de':
      'Erich Hess hat es mit seinem extrem provokativen Stil 2015 in den Nationalrat geschafft, ist den vier Jahren aber primär Lokalpolitiker geblieben. Er sitzt nach wie vor auch in der Berner Kantons- und Stadtlegislative. Sein Hauptthema ist der Kampf gegen die Berner Reitschule. \n',
    'BAT DE': 'fre',
    'Text fr':
      "Erich Hess est entré in extremis au Conseil national en 2015. Provocateur né, il est l'élu le plus à droite du Parlement. Figure de la politique bernoise, notamment pour sa haine viscérale de la Reitschule, le centre alternatif de la capitale, il n'a pas vraiment réussi à s'imposer au niveau national. Il faut dire qu'il cumule trois mandats, communal, cantonal et fédéral.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Berne',
    Geburtsdatum: '25.03.1981',
    'Beruf de': 'Unternehmer, Lastwagenführer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '24',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'JU',
    Nachname: 'Baume-Schneider',
    Vorname: 'Elisabeth',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Sie kann nicht von der Politik lassen. Nach einer vierjährigen Absenz kehrt Elisabeth Baume-Schneider, die ehemalige Lokomotive der jurassischen Regierung, auf die Politbühne zurück. Die Pause nutzte sie für ihre Tätigkeit als Hochschuldirektorin in Lausanne. Im Jura kümmerte sie sich um Bildung und Sport.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Après quatre ans de pause politique et un poste de rectrice dans une haute école lausannoise, c'est le retour aux affaires pour la socialiste. À 55 ans, EBS est une femme de poigne qui, durant douze ans, a fait figure de locomotive au Gouvernement jurassien, comme ministre de l’instruction publique, de la culture et des sports.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Les Breuleux',
    'Wohnort fr': 'Les Breuleux',
    Geburtsdatum: '24.12.1963',
    'Beruf de': 'Politikerin',
    'Beruf fr': 'Assistante sociale et femme politique'
  },
  {
    Elected: 'Ja',
    Sitznummer: '25',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'LU',
    Nachname: 'Töngi',
    Vorname: 'Michael',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2018',
    'DabeiSeit fr': 'Au Conseil national depuis 2018',
    'Alte Texte DE': '',
    'Text de':
      'Gemäss einer Analyse der Voten im Nationalrat der letzten Legislaturperiode im Auftrag des Schweizerischer Gewerbeverband ist Michael Töngi der wirtschaftsunfreundlichste Politiker. Das bewegte den Michael Töngi nicht wirklich. Er stellte die Seriosität der "Studie" Punkt für Punkt in Frage. Bevorzugte Themen des Berufspolitikers sind die umweltfreundliche Mobilität und der Mietrechtsschutz.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Selon une analyse des votes des parlementaires de la dernière législature commandée par L’Union suisse des arts et métiers, l'organisation faîtière des PME, Michael Töngi serait le politicien le plus hostile aux entreprises. Cela n’avait pas vraiment ému le politicien professionnel, qui avait contesté point par point le sérieux de l’«étude». Les thèmes de prédilection de Michael Töngi sont la mobilité douce et la défense des locataires.",
    'BAT FR': '',
    'Wohnort de': 'Kriens',
    'Wohnort fr': 'Kriens',
    Geburtsdatum: '16.03.1967',
    'Beruf de': 'Nationalrat und Historiker',
    'Beruf fr': 'Conseiller national et historien'
  },
  {
    Elected: 'Ja',
    Sitznummer: '25',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'LU',
    Nachname: 'Gmür-Schönenberger',
    Vorname: 'Andrea',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Seit 2014 präsidiert die ausgebildete Gymnasiallehrerin Gmür die CVP der Stadt Luzern, seit 2015 auch die Staatspolitische Kommission des Kantonsrates. Gmür ist seit 2007 Geschäftsführerin der Stiftung Josi J. Meier, die sich für Menschen in Not einsetzt. Ersetzt den Gewerbler Ruedi Lustenberger.',
    'Text de':
      'Gmür war lange Gymnasiallehrerin für Englisch und Französisch. 2015 wurde die Luzernerin in den Nationalrat gewählt, bis 2019 war sie Präsidentin der CVP Stadt Luzern. Gmür ist zudem Geschäftsführerin der Stiftung Josi J. Meier, die sich für Menschen in Not einsetzt. ',
    'BAT DE': 'fre',
    'Text fr':
      "Ancienne professeur d'anglais et de français au lycée et mère de quatre enfants, la Lucernoise a été élue au Conseil national en 2015. Andrea Gmür a été présidente du PDC de la ville de Lucerne jusqu'en 2019 et dirige également la Fondation Josi J. Meier, qui soutient les personnes dans le besoin.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Luzern',
    'Wohnort fr': 'Lucerne',
    Geburtsdatum: '17.07.1964',
    'Beruf de': '',
    'Beruf fr': 'Professeure au gymnase, Directrice de fondation'
  },
  {
    Elected: 'Ja',
    Sitznummer: '26',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SZ',
    Nachname: 'Schwander',
    Vorname: 'Pirmin',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2003',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Schwander ist allen Ratings regelmässig der rechteste aller Nationalräte. Der ehemalige Präsident der Auns (Aktion für eine unabhängige Schweiz) sitzt in der Rechts- und der Finanzkommission.',
    'Text de':
      'Schwander ist allen Ratings regelmässig der rechteste aller Nationalräte. Der ehemalige Präsident der Auns (Aktion für eine unabhängige Schweiz) ist vor allem aktiv im Kampf gegen die Kindes- und Erwachsenenschutzbehörden (Kesb).',
    'BAT DE': 'fre',
    'Text fr':
      "Dans les ratings des parlementaires, Pirmin Schwander est régulièrement classé comme étant le plus à droite de tous les conseillers nationaux. L'ancien président de l'ASIN (Action pour une Suisse indépendante et neutre) est avant tout actif dans la lutte contre les autorités de protection de l’enfant et de l’adulte (APEA).",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lachen',
    'Wohnort fr': 'Lachen',
    Geburtsdatum: '28.12.1961',
    'Beruf de': 'Dr. oec. publ., Unternehmer',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '26',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'SG',
    Nachname: 'Rechsteiner',
    Vorname: 'Paul',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2011, im Nationalrat von 1986 bis 2011 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2011, après avoir siégé au National de 1986 à 2011',
    'Alte Texte DE':
      'Bevor der Präsident des Gewerkschaftsbunds 2011 in die kleine Kammer gewählt wurde, war er 25 Jahre Nationalrat. Im Parlament engagiert er sich dezidiert für die Anliegen der Arbeitnehmenden. Er arbeitet als Anwalt im eigenen Anwaltsbüro in St. Gallen.',
    'Text de':
      'Rechsteiner sitzt seit 1986 im Parlament und ist damit der amtsälteste Parlamentarier. Der frühere Gewerkschaftspräsident engagiert sich dezidiert für die Anliegen der Arbeitnehmenden. Er arbeitet als Anwalt im eigenen Anwaltsbüro in St. Gallen. ',
    'BAT DE': 'fre',
    'Text fr':
      'Rechsteiner est surnommé le "dinosaure" du Parlement fédéral. Il y siège depuis 1986, ce qui en fait le doyen de fonction. Ancien président de l\'USS, il a laissé sa place à Pierre-Yves Maillard. Mais il reste un ardent défenseur des préoccupations des employés. Il travaille comme avocat dans son propre cabinet  à Saint-Gall. ',
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'St.Gallen',
    'Wohnort fr': 'St. Gall',
    Geburtsdatum: '26.08.1952',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '27',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'ZH',
    Nachname: 'Schneider',
    Vorname: 'Meret',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Im Frühling wurde Meret Schneider, die bereits im Ustermer Parlament sitzt, in den Zürcher Kantonsrat gewählt. Nun ergatterte die Co-Geschäftsleiterin einer Tierschutzorganisation bereits ein Nationalratsmandat. Die junge Zürcher Oberländerin machte landesweit Schlagzeilen als Mitinitiantin der Volksinitiative «Abschaffung der Massentierhaltung».',
    'BAT DE': 'Gelb',
    'Text fr':
      "Au printemps 2019, quelques mois avant les élections fédérales, Meret Schneider, qui siègeait déjà au Parlement d'Uster, avait été élue au Grand Conseil zurichois. La codirectrice de l'organisation anti-spéciste Sentience Politics avait fait l'actualité nationale avec l'initiative populaire \"Abolition de l'élevage de masse\" qu'elle a contribué à lancer.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Uster',
    'Wohnort fr': 'Uster',
    Geburtsdatum: '22.08.1992',
    'Beruf de': 'Co-Geschäftsleitung Sentience Politics, Gemeinderätin',
    'Beruf fr': "Co-directrice d'une organisation anti-spéciste"
  },
  {
    Elected: 'Ja',
    Sitznummer: '27',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'UR',
    Nachname: 'Dittli',
    Vorname: 'Josef',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015',
    'DabeiSeit fr': 'Au Conseil des États depuis 2015',
    'Alte Texte DE':
      'Dittli wurde 2004 in die Urner Regierung gewählt und war mitverantwortlich für das Engagement von Samih Sawiris in Andermatt.',
    'Text de':
      'Der frühere Urner Regierungsrat und Oberst im Generalstab ist vor allem als Lobbyist im Gespräch. Er ist unter anderem Präsident des Krankenkassenverbands Curafutura.',
    'BAT DE': 'fre',
    'Text fr':
      "L'ancien conseiller d’Etat d'Uri et colonel à l'état-major est principalement connu comme étant un lobbyiste. Il est, entre autres, président de Curafutura, l’association des «assureurs maladie innovants» regroupant CSS, Helsana, Sanitas et CPT. Il a succédé à ce poste à un certain Ignazio Cassis.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Attinghausen',
    'Wohnort fr': 'Attinghausen',
    Geburtsdatum: '11.04.1957',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '28',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Vogt',
    Vorname: 'Hans-Ueli',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der Rechtsprofessor steht hinter der Volksinitiative «Schweizer Recht statt fremde Richter». Er ist seit 2011 Mitglied des Zürcher Kantonsparlaments.',
    'Text de':
      'Es waren Tage, die den SVP-Mann Hans-Ueli Vogt an den Rand der Belastbarkeit brachten: Fast im Alleingang kämpfte der argumentativ starke Rechtsprofessor letztes Jahr für die Selbstbestimmungsinitiative. Selbst parteiintern war das Begehren vielen zu kopflastig. Vogt ist nie in den inneren Machtzirkel der SVP vorgestossen.',
    'BAT DE': 'fre',
    'Text fr':
      "Le professeur de droit à l'Université de Zurich est considéré comme le père de l'initiative UDC dite d'autodétermination, qui voulait faire primer le droit suisse sur le droit international. Vu comme un pur intellectuel au sein de son parti, il n'est pas parvenu à y gravir les échelons du pouvoir. Au Conseil national, il a fait preuve d'un certain sens du compromis. Avec Karl Vogler (PDC/OW), il a notamment élaboré un contre-projet à l'initiative \"pour des multinationales responsables\". ",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '05.12.1969',
    'Beruf de': 'Professor für Wirtschaftsrecht Universität Zürich',
    'Beruf fr': 'Professeur de doit'
  },
  {
    Elected: 'Ja',
    Sitznummer: '28',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'VD',
    Nachname: 'Français',
    Vorname: 'Olivier',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015, im Nationalrat von 2007 bis 2015 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2015, précédement au National de 2007 à 2015',
    'Alte Texte DE':
      'Français ist bereits seit 2000 Stadtrat von Lausanne und war in dieser Funktion verantwortlich für den Bau der Metro M2. Im Nationalrat ist er Mitglieder der Verkehrskommission – und schreibt fast keine Vorstösse.',
    'Text de':
      "Der Höhepunkt von Olivier Français' Karriere war, als er 2015 dem Grünen Luc Recordon den Ständeratssitz abjagte. Français' Handycap ist, dass er kein Deutsch spricht. Weil er zugleich als Unternehmer tätig ist, drohten bei seinem Engagement für öffentliche Bauten seine Rollen als Parlamentarier und Ingenieur zu vermischen.",
    'BAT DE': 'daf',
    'Text fr':
      "Ancien municipal de la ville de Lausanne, Olivier Français est l'homme qui a permis à la droite vaudoise de briser l'hégémonie rose-verte au Conseil des Etats. Spécialiste des questions de transports, mais aussi de sécurité, l'ingénieur spécialisé en géotechnique est à l'origine du metro à Lausanne, le seul de Suisse. Né à Metz, naturalisé en 1988, il a tenté une candidature pour succéder à Didier Burkhalter au Conseil fédéral, avant de s'effacer.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lausanne',
    'Wohnort fr': 'Lausanne',
    Geburtsdatum: '01.10.1955',
    'Beruf de': '',
    'Beruf fr': 'Ingénieur civil'
  },
  {
    Elected: 'Ja',
    Sitznummer: '29',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'BE',
    Nachname: 'Badertscher',
    Vorname: 'Christine',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Agronomin aus dem Oberaargau ist Vizepräsidentin der Grünen im Kanton Bern und präsidiert den Oberaargauischen Bauernverein. Sie arbeitet für das Hilfswerk Swissaid, wo sie für das Dossier Landwirtschaft zuständig ist.',
    'BAT DE': 'Gelb',
    'Text fr':
      "L'ingénieure agronome est vice-présidente des Verts du canton vert de Berne et président de l'association des agriculteurs de Haute-Argovie. Elle travaille pour l'organisation humanitaire Swissaid, où elle est responsable du dossier agricole.",
    'BAT FR': '',
    'Wohnort de': 'Madiswil',
    'Wohnort fr': 'Madiswil',
    Geburtsdatum: '10.01.1982',
    'Beruf de':
      'Wiss. Mitarbeiterin SWISSAID Entwicklungspolitik, Präsidentin Oberaargauer Bauernverband',
    'Beruf fr': 'Conseillère scientifique chez Swissaid'
  },
  {
    Elected: 'Ja',
    Sitznummer: '29',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'ZH',
    Nachname: 'Noser',
    Vorname: 'Ruedi',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015, im Nationalrat von 2003 bis 2015 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2015, précédement au National de 2003 à 2015',
    'Alte Texte DE':
      'Der Wirtschaftspolitiker führt im Kanton Zürich sein eigenes Unternehmen. Er gilt als treibende Kraft hinter dem Schweizer Innovationspark.',
    'Text de':
      'Wirtschaftspolitiker Noser führt im Kanton Zürich sein eigenes IT-Unternehmen. Er gilt als treibende Kraft hinter dem Schweizer Innovationspark. Nach 12 Jahren im Nationalrat ist er 2015 in den Ständerat gewählt worden. ',
    'BAT DE': 'fre',
    'Text fr':
      "Ruedi Noser dirige sa propre société informatique dans le canton de Zurich. Il est considéré comme le moteur de Switzerland Innovation, réparti sur cinq sites proches des hautes-écoles, afin de favoriser l'émulation entre le monde académique et les entreprises. Après douze ans au Conseil national, il a été élu au Conseil des Etats en 2015. Capable de penser en dehors des sentiers battus, il s'est établi durant une année à Genève en 2009 avec sa famille pour apprendre le français.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zürich',
    Geburtsdatum: '14.04.1961',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '30',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Tuena',
    Vorname: 'Mauro',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'In der Stadt Zürich ist Tuena ein bekannter Kopf: Seit Jahren sitzt er im Lokalparlament und präsidiert die Fraktion. Im Frühling ist er in den Zürcher Kantonsrat gewählt worden.',
    'Text de':
      'Der Präsident der SVP der Stadt Zürich blieb während seiner ersten Amtszeit in Bern unsichtbar. Der gebürtige Bündner ist Direktor eines kleinen IT-Unternehmens.',
    'BAT DE': 'fre',
    'Text fr':
      "Le président de l'UDC de la ville de Zurich est resté invisible durant sa première législature à Berne. Administrateur d'une petite société d'informatique, ce Grison d'origine siège dans la Commission de la science, de l'éducation et de la culture, ainsi que dans la commission de l'environnement, de l'aménagement du territoire et de l'énergie",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '25.01.1972',
    'Beruf de': 'Kleinunternehmer, Computer-Techniker',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '30',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'NE',
    Nachname: 'Bauer',
    Vorname: 'Philippe',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Bauer ist Anwalt in Neuenburg und Mitglied des Grossen Rats des Kantons.',
    'Text de':
      'Der Anwalt aus Neuenburg gilt als wirtschaftspolitisch liberal und gesellschaftspolitisch eher konservativ. Als Anwalt von GastroNeuchâtel kämpfte Bauer 2017 vergeblich bis vor Bundesgericht dagegen, dass Neuenburg als erster Kanton einen minimalen Stundenlohn von 19 Franken 70 eingeführt hat. ',
    'BAT DE': 'fre',
    'Text fr':
      "En quatre ans, l'avocat s'est fait une place à Berne, notamment dans la Commission des affaires juridiques. Après le retrait de Raphaël Comte, il s'est naturellement profilé comme un successeur crédible pour le Conseil des Etats, bien qu'il soit plus libéral sur les questions économiques et conservateur sur les questions de société que son prédécesseur.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Auvernier',
    'Wohnort fr': 'Auvernier',
    Geburtsdatum: '09.04.1962',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '31',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'BL',
    Nachname: 'Brenzikofer',
    Vorname: 'Florence',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die frühere Parteipräsidentin der Grünen in Baselland gilt als solide Sachpolitikerin mit grüner Grundhaltung. Die langjährige Kantonsparlamentarierin und Sekundarlehrerin hat sich bisher vor allem als Bildungspolitikerin profiliert. Neuerdings versucht sie sich als Finanzpolitikerin - im Präsidium der kantonalen Finanzkommission.',
    'BAT DE': 'Gelb',
    'Text fr':
      "L'ancienne présidente des Verts est connue pour être en adéquation avec les idées chères à son parti. Jusqu'à présent, cette parlementaire cantonale de longue date et enseignante dans le secondaire s'est surtout fait un nom en tant que spécialiste des questions de formation. Récemment, elle s'est également essayée à la politique budgétaire - avec la présidence de la Commission cantonale des finances.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Oltingen',
    'Wohnort fr': 'Oltingen',
    Geburtsdatum: '15.04.1975',
    'Beruf de': 'Sekundarlehrerin phil.-hist., Landrätin',
    'Beruf fr': 'Professeure au secondaire'
  },
  {
    Elected: 'Ja',
    Sitznummer: '31',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'LU',
    Nachname: 'Müller',
    Vorname: 'Damian',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015',
    'DabeiSeit fr': 'Au Conseil des États depuis 2015',
    'Alte Texte DE':
      'Der 31-Jährige ist das jüngste Mitglied im Ständerat. Er konnte den FDP-Sitz verteidigen, der durch den Rücktritt von Georges Theiler frei geworden war.',
    'Text de':
      'Müller hat sich im Wahljahr vor allem als umweltpolitischer Wortführer innerhalb der FDP einen Namen gemacht. Er unterstützte von Beginn weg den Kurs von Parteipräsidentin Petra Gössi, den Freisinn stärker ökologisch auszurichten.',
    'BAT DE': 'fre',
    'Text fr':
      "Au cours de l'année électorale, Damian Müller s'est surtout fait connaître comme chantre de la nouvelle politique environnementale au sein du PLR. En effet, il a soutenu dès le départ la présidente du parti Petra Gössi dans sa tentative de virage écologique.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Hitzkirch',
    'Wohnort fr': 'Hitzkirch',
    Geburtsdatum: '25.10.1984',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '32',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'AG',
    Nachname: 'Gallati',
    Vorname: 'Jean-Pierre',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der Rechtsanwalt aus Wohlen gilt als Hardliner. Zudem ist er einer der schärfsten Kritiker der Aargauer SVP-Regierungsrätin Franziska Roth, die zurückgetreten ist.\n',
    'BAT DE': 'Gelb',
    'Text fr':
      "L'avocat de Wohlen est considéré comme un partisan de la ligne dure. Il est également l'un des critiques les plus sévères à l'encontre de Franziska Roth, membre UDC du gouvernement argovien qui a démissionné.",
    'BAT FR': '',
    'Wohnort de': 'Wohlen',
    'Wohnort fr': 'Wohlen',
    Geburtsdatum: '24.08.1966',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '32',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BS',
    Nachname: 'Herzog',
    Vorname: 'Eva',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Ständerat seit 2019',
    'DabeiSeit fr': 'Au Conseil des États depuis 2019.',
    'Alte Texte DE': '',
    'Text de':
      'Eva Herzog trat 2005 als Leiterin der Finanzabteilung in die Basler Stadtverwaltung ein. Im Jahr 2010 hatte sie sich um die Nachfolge von Bundesrat Moritz Leuenberger beworben, aber ihre Partei hat sie nicht als Kandidatin akzeptiert, weil sie sie für zu unerfahren hielt. In Basel ist Herzog ausgesprochen beliebt.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Eva Herzog est entrée au gouvernement de Bâle-Ville en 2005, comme cheffe du Département des finances. En 2010, elle s’était portée candidate à la succession du conseiller fédéral Moritz Leuenberger, mais son parti n’avait pas retenu sa candidature, la jugeant trop peu expérimentée. Eva Herzog est titulaire d’un doctorat en histoire.',
    'BAT FR': '',
    'Wohnort de': 'Basel',
    'Wohnort fr': 'Bâle',
    Geburtsdatum: '25.12.1961',
    'Beruf de': 'Historikerin und Kulturmanagerin',
    'Beruf fr': 'Historienne et gestionnaire de projets culturels'
  },
  {
    Elected: 'Ja',
    Sitznummer: '33',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'GE',
    Nachname: 'Walder',
    Vorname: 'Nicolas',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Nicolas Walder ist seit 2011 Gemeindepräsident von Carouge und seit 2016 Präsident der Genfer Grünen. In Carouge beschäftigt er sich mit den ThemenUmwelt, Energie, Mobilität und Finanzen. Er ist ausserdem Präsident der Uniion Genfer Gemeinden. Walder ist eine der prägendenden Figuren bei den Genfer Grünen und mitverantwortlich für deren Aufschwung.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Conseiller administratif de Carouge depuis 2011, président des Verts genevois depuis 2016, Nicolas Walder a participé à la remontée électorale de son parti sévèrement étrillé aux élections cantonales de 2013. A Carouge, il s'occupe des questions d'aménagement, d'environnement, d'énergie et de mobilité; de finance. Il est président de la Fondation des Terrains Industriels (FTI), et de l'Union des villes genevoises (UVG).",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Carouge (GE)',
    'Wohnort fr': 'Carouge (GE)',
    Geburtsdatum: '02.05.1966',
    'Beruf de': '',
    'Beruf fr': 'Conseiller administratif'
  },
  {
    Elected: 'Ja',
    Sitznummer: '33',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SH',
    Nachname: 'Germann',
    Vorname: 'Hannes',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2002',
    'DabeiSeit fr': 'Au Conseil des États depuis 2002',
    'Alte Texte DE':
      'Hannes Germann gehört zu den konzilianten SVP-Politikern. Er betont gerne, dass er Politik in erster Linie für den Stand Schaffhausen macht, nicht für seine Fraktion. Germann präsidierte die kleine Kammer 2014. Zu seinen Schwerpunktsthemen gehört die Wirtschaftspolitik. Im FC Nationalrat verteidigt er und ärgert sich über selbstverliebte Einzelakteure auf.',
    'Text de':
      'Hannes Germann gehört zu den konzilianten SVP-Politikern. Er betont gerne, dass er Politik in erster Linie für den Stand Schaffhausen macht, nicht für seine Fraktion. Zu seinen Schwerpunktsthemen gehört die Wirtschaftspolitik.',
    'BAT DE': 'fre',
    'Text fr':
      "Considéré comme un modéré à l'UDC, Hannes Germann aime souligner qu'il fait de la politique avant tout pour son canton: Schaffhouse. Il aurait bien voulu lui offrir son premier siège au Conseil fédéral, mais a été recalé lors de la course qui a vu l'élection de Guy Parmelin. Le sénateur est aussi le président de l'Association des communes suisses.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Opfertshofen',
    'Wohnort fr': 'Opfertshofen',
    Geburtsdatum: '01.07.1956',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '34',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'AG',
    Nachname: 'Glarner',
    Vorname: 'Andreas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Glarner, Fraktionspräsident der SVP Aargau, sorgte mit seiner harten Flüchtlingspolitik und seinen Wahlplakaten, in denen er auf die Terrormiliz Islamischer Staat anspielt, vor den Wahlen bis über die Schweizer Grenze für Aufsehen.',
    'Text de':
      'Andreas Glarner sorgt mit seiner harten Flüchtlingspolitik und provokanten Aktionen immer wieder für Aufmerksamkeit. Diesen Frühling wurde er kritisiert, weil er die Telefonnummer einer jungen Lehrerin öffentlich machte, die muslimischen Schülern wie von der Schulordnung vorgesehen für einen religiösen Feiertag frei gegeben hatte.',
    'BAT DE': 'fre',
    'Text fr':
      "Avec ses positions très dures en matière de politique d'asile et ses opérations de provocation, Andreas Glarner attire toujours autant l'attention. Ce printemps, il avait fait scandale en Suisse alémanique pour avoir rendu public le numéro de téléphone d'une jeune enseignante qui, ayant suivi le règlement de l’école sur les fêtes religieuses, avait accordé un congé à ses élèves musulmans.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Oberwil-Lieli',
    'Wohnort fr': 'Oberwil-Lieli',
    Geburtsdatum: '09.10.1962',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '34',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'TI',
    Nachname: 'Carobbio Guscetti',
    Vorname: 'Marina',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Ständerat seit 2019, im Nationalrat von 2007 bis 2019',
    'DabeiSeit fr':
      'Au Conseil des Etats depuis 2019, au Conseil national de 2007 à 2019',
    'Alte Texte DE':
      'Ärztin wie ihr Vorgänger Franco Cavalli, dessen Sitz sie erbte. War kurzzeitig Kandidatin der SP für die Nachfolge von Micheline Calmy-Rey im Bundesrat. Carobbio ist Mitglied der Sozial- und Gesundheitskommission, der Finanzkommission sowie der Finanzdelegation.',
    'Text de':
      'Die Ärztin krönte ihre politische Karriere mit dem Nationalratspräsidium im Amtsjahr 2018/2019. Sie unterbrach während des Frauenstreiks vom 14. Juni 2019 die Sitzung der grossen Kammer für eine Viertelstunde, was ihr Kritik von der Ratsrechten und Lob von linker Seite einbrachte. Ihr Sprung in den Ständerat als erste Senatorin und erste Sozialistin für das Tessin war eine Sensation.',
    'BAT DE': 'fre',
    'Text fr':
      "La médecin a couronné sa carrière politique avec la présidence du Conseil national pendant l’année parlementaire 2018/2019. Lors de la grève des femmes du 14 juin 2019, elle a interrompu la séance pendant un quart d'heure, ce qui lui a valu les critiques de la droite et les compliments de la gauche. Son accession au Conseil des Etats en tant que première femme sénatrice et première socialiste pour le Tessin a fait sensation.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lumino',
    'Wohnort fr': 'Lumino',
    Geburtsdatum: '12.06.1966',
    'Beruf de': 'Ärztin',
    'Beruf fr': 'Médecin'
  },
  {
    Elected: 'Ja',
    Sitznummer: '35',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'BS',
    Nachname: 'Arslan',
    Vorname: 'Sibel',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Die Juristin arbeitet seit 2015 beim Sicherheitsdepartement des Kantons Basel-Land. Die in der Türkei geborene Arslan ist seit 2004 Schweizerin. Ende 2014 sorgte sie für Aufmerksamkeit, weil sie eine bereits zugesagte Stelle wegen offener Betreibungen nicht bekam.',
    'Text de':
      'Sibel Arslan ist ausgebildete Juristin und sitzt in der aussenpolitischen Kommission und in der Rechtskommission. Sie ist Vizepräsidentin der Neuen Europäischen Bewegung Schweiz und kämpft für die Gleichstellung der Frauen. Sie kritisiert regelmässig die türkische Regierung für ihren Umgang mit den Kurden. ',
    'BAT DE': 'fre',
    'Text fr':
      "Sibel Arslan est avocate de formation et siège à la Commission de politique extérieure et à la Commission juridique. La vice-présidente du NOMES est favorable à l'adhésion de la Suisse à l'UE et se bat pour l'égalité des hommes et des femmes. Elle critique régulièrement le gouvernement turc pour sa politique répressive envers les Kurdes. ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Basel',
    'Wohnort fr': 'Bâle',
    Geburtsdatum: '23.06.1980',
    'Beruf de': 'Nationalrätin, Juristin, Unternehmerin',
    'Beruf fr': 'Juriste, entrepreneure'
  },
  {
    Elected: 'Ja',
    Sitznummer: '35',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'ZG',
    Nachname: 'Hegglin',
    Vorname: 'Peter',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015',
    'DabeiSeit fr': 'Au Conseil des États depuis 2015',
    'Alte Texte DE':
      'Der Zuger Finanzdirektor ist als Präsident der Finanzdirektorenkonferenz eine national bekannte Figur.',
    'Text de':
      'Seit 2015 sitzt Peter Hegglin im Ständerat. Der frühere Finanzdirektor des Kantons Zug bewarb sich 2018 um die Nachfolge von Bundesrätin Doris Leuthard. Hegglin unterlag in der parteiinternen Ausmarchung allerdings Heidi Z’graggen und Viola Amherd, die schliesslich das Rennen machte.',
    'BAT DE': 'fre',
    'Text fr':
      "Peter Hegglin est conseiller aux États depuis 2015. L'ancien directeur des finances du canton de Zoug avait été le premier à poser sa candidature en 2018 pour succéder à la conseillère fédérale Doris Leuthard. Mais, lors du processus de sélection interne au parti, il ne s’est pas montré convainquant et il a été battu par Heidi Z'Graggen et Viola Amherd, qui a finalement été élue.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Edlibach',
    'Wohnort fr': 'Edlibach',
    Geburtsdatum: '25.12.1960',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '36',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'AG',
    Nachname: 'Bircher',
    Vorname: 'Martina',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Betriebsökonomin sitzt seit 2017 im Aargauer Grossen Rat. Sie vertritt stramm den Kurs der SVP. Martina Bircher setzt sich für eine restriktive Finanz- und Migrationspolitik ein. Mit ihrer Forderung nach einem Deckel der Sozialhilfe für Familien mit mehr als drei Kindern sorgte sie ihm Wahlkampf für Schlagzeilen.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Cette économiste d'entreprise représente l’UDC au Grand Conseil depuis 2017. Martina Bircher adhère aux thèmes privilégiés de son partie et plaide ainsi en faveur d'une politique financière et migratoire rigoureuse. En réclamant un plafonnement de l'aide sociale pour les familles de plus de trois enfants, elle a mené sa campagne à coup de gros titres.",
    'BAT FR': '',
    'Wohnort de': 'Aarburg',
    'Wohnort fr': 'Aarburg',
    Geburtsdatum: '13.04.1984',
    'Beruf de': 'Betriebsökonomin, Vizeammann',
    'Beruf fr': "Économiste d'entreprise, vice-présidente de la bourgeoisie"
  },
  {
    Elected: 'Ja',
    Sitznummer: '36',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'GE',
    Nachname: 'Sommaruga',
    Vorname: 'Carlo',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019, im Nationalrat von 2003-2019',
    'DabeiSeit fr':
      'Au Conseil des Etats depuis 2019, au Conseil national de 2003 à 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der Genfer Anwalt Carlo Sommaruga gehört zu den profiliertesten SP-Politikern im Bundeshaus. Vor allem in der Aussenpolitik hat seine Stimme Gewicht. Er politisiert am äussersten linken Rand innerhalb der Partei. In der SP Genf kommt er damit sehr gut an. Dennoch weigerte sich seine Partei mehrfach, ihn für die Regierungsraswahlen zu nominieren, was seinem Einfluss in Bern keinen Abbruch tat. Sommaruga ist der aktuelle Präsident der Mieterinnen- und Mietervereinigung Asloca und der NGO Solidar.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Poids lourd du PS Genevois, l'avocat est également une pointure au niveau national. Membre de la comission de politique extérieure, et depuis peu de celle de la sécurité, il intervient régulièrement sur les questions de politique étrangère. Carlo Sommaruga est également connu pour être l'actuel président de l'Asloca.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Genf',
    'Wohnort fr': 'Genève',
    Geburtsdatum: '08.07.1959',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '37',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'VD',
    Nachname: 'Porchet',
    Vorname: 'Léonore',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Léonore Porchet sitzt erst seit 2017 im Waadtländer Kantonsrat. Doch die ehemalige Präsidentin der Lausanner Grünen ist längst im ganzen Kanton bekannt. Im Radio und Fernsehen ist sie regelmässiger Gast, wo sie wortgewaltig und kompromisslos für ihre Anliegen kämpft. Auf ihre Initiative hin, hat die Stadt Lausanne eine App entwickelt, mit der Frauen sexuelle Übergriffe sofort melden und um Hilfe rufen können. ',
    'BAT DE': 'Gelb',
    'Text fr':
      "L'étoile montante des Verts vaudois n'a pas pris beaucoup de temps pour se faire une place au Grand Conseil, où elle siège depuis 2017. Cette spécialiste en communication, licenciée en Histoire de l'art, cumule nombre d'engagements associatifs. Militante pour les droits des femmes dès son plus jeune âge, elle a activement participé à la création d'une application contre le harcèlement de rue, l'un de ses chevaux de bataille.",
    'BAT FR': 'pas relu',
    'Wohnort de': 'Lausanne',
    'Wohnort fr': 'Lausanne',
    Geburtsdatum: '09.07.1989',
    'Beruf de': '',
    'Beruf fr': 'Cheffe de projet en communication'
  },
  {
    Elected: 'Ja',
    Sitznummer: '37',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'GR',
    Nachname: 'Engler',
    Vorname: 'Stefan',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2011',
    'DabeiSeit fr': 'Au Conseil des États depuis 2011',
    'Alte Texte DE':
      'Der frühere Regierungsrat Stefan Engler hat sich in einer ersten Legislatur im Ständerat rasch etabliert. Der Anwalt präsidiert die Rechtskommission des Rats und ist Mitglied der Wirtschaftskommission sowie der Staatspolitischen Kommission.',
    'Text de':
      'Der frühere Bündner Regierungsrat ist Vizepräsident der Verkehrskommission. Der passionierte Jäger vertritt die Interessen seines Herkunftkantons mit grossem Engagement.',
    'BAT DE': 'fre',
    'Text fr':
      "L'ancien conseiller d'Etat grison, avocat de formation, est un chasseur passionné qui représente les intérêts de son canton d'origine avec beaucoup d'engagement.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Chur',
    'Wohnort fr': 'Coire',
    Geburtsdatum: '30.05.1960',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '38',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BE',
    Nachname: 'Guggisberg',
    Vorname: 'Lars',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Lars Guggisberg ist der Sprung auf die grosse Bühne doch noch geglückt, den er 2016 noch verpasst hat. Damals scheiterte er bei den Regierungsersatzwahlen. Auf kantonaler Ebene hat er sich als Gewerbevertreter profiliert.',
    'BAT DE': 'daf',
    'Text fr':
      "Lars Guggisberg est enfin parvenu à se hisser sur le devant la scène après son échec de 2016. À l’époque, il avait échoué lors de l’élection au Conseil d’Etat. Au niveau cantonal, l’avocat s'est fait un nom en tant que représentant des artisans.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Kirchlindach',
    'Wohnort fr': 'Kirchlindach',
    Geburtsdatum: '19.07.1977',
    'Beruf de': 'Geschäftsführer',
    'Beruf fr': "Chef d'entreprise"
  },
  {
    Elected: 'Ja',
    Sitznummer: '38',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'FR',
    Nachname: 'Levrat',
    Vorname: 'Christian',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2011, im Nationalrat von 2003 bis 2011 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2011, précédement au National de 2003 à 2011',
    'Alte Texte DE':
      'Der SP-Präsident war vor dem zweiten Ständeratswahlgang sichtlich nervös: Die SVP hatte einen prominenten Kandidaten ins Rennen geschickt. Hätte dieser obsiegt, wäre das nicht nur für Levrat persönlich ein grosses Debakel gewesen. Doch es kam anders. Der Sozialdemokrat distanzierte den Kontrahenten am Schluss deutlich.',
    'Text de':
      'Der SP-Präsident ist einer der einflussreichsten Politiker in Bern. Er ist der dienstälteste Parteichef der Schweiz und gilt als gewiefter Taktiker. Ursprünglich ein Gewerkschafter, versucht er heute, die verschiedenen SP-Flügel möglichst konfliktfrei zu integrieren.',
    'BAT DE': 'fre',
    'Text fr':
      "Le président du PS est l'une des personnalités politiques les plus influentes de Berne. Joueur d'échecs et fin tacticien, Christian Levrat reconnaît rapidement les faiblesses de ses adversaires politiques. Le Fribourgeois pourrait laisser sa place de président du PS durant cette législature.  ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Vuadens',
    'Wohnort fr': 'Vuadens',
    Geburtsdatum: '07.07.1970',
    'Beruf de': 'Präsident SP Schweiz',
    'Beruf fr': 'Président du Parti socialiste suisse'
  },
  {
    Elected: 'Ja',
    Sitznummer: '39',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'TI',
    Nachname: 'Storni',
    Vorname: 'Bruno',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Umweltfreundliche Mobilität, Energieeffizienz, Biodiversität - Bruno Storni\'s Lieblingsthemen machen ihn wohl zum "grünsten" unter den Sozialisten. Aber als der EPFL-Gastprofessor für Weltraum-Avionik in die Politik eintrat, gab es die Grünen im Tessin noch nicht wirklich...',
    'BAT DE': 'Gelb',
    'Text fr':
      "Mobilité douce, efficacité énergétique, biodiversité, les thèmes favori de Bruno Storni en font probablement le plus \"vert\" parmi les socialistes. Mais quand le professeur invité à l'EPFL en avionique spaciale s'est lancé en politique, les Verts n'existaient pas vraiment encore au Tessin.",
    'BAT FR': '',
    'Wohnort de': 'Gordola',
    'Wohnort fr': 'Gordola',
    Geburtsdatum: '17.08.1954',
    'Beruf de': 'Ingenieur, ETH Professor',
    'Beruf fr': 'Ingénieur, professeur EPFL'
  },
  {
    Elected: 'Ja',
    Sitznummer: '39',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'OW',
    Nachname: 'Ettlin',
    Vorname: 'Erich',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015',
    'DabeiSeit fr': 'Au Conseil des États depuis 2015',
    'Alte Texte DE':
      'Mit dem Steuerexperten und Wirtschaftsprüfer aus Kerns hat die Obwaldner CVP der FDP den Sitz im Ständerat abgeluchst, den der Freisinnige Hans Hess lange Zeit besetzt hatte.',
    'Text de':
      'Der Steuerexperte und Wirtschaftsprüfer aus Kerns tritt vor allem als Finanzpolitiker in Erscheinung. Er sitzt in der einflussreichen Kommission für Wirtschaft und Abgaben sowie in der Finanzdelegation. Kurzzeitig war Ettlin als Nachfolger von Bundesrätin Doris Leuthard im Gespräch.',
    'BAT DE': 'fre',
    'Text fr':
      "L'expert fiscal de Kerns se profile principalement sur les questions de politique financière. Il siège à la fois à l'influente Commission de l'économie et des redevances et à la délégation des finances. Erich Ettlin avait été évoqué pour succéder à la conseillère fédérale Doris Leuthard.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Kerns',
    'Wohnort fr': 'Kerns',
    Geburtsdatum: '30.05.1962',
    'Beruf de': 'Steuerexperte',
    'Beruf fr': 'Expert fiscal'
  },
  {
    Elected: 'Ja',
    Sitznummer: '40',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'BS',
    Nachname: 'Christ',
    Vorname: 'Katja',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Grossrätin der Grünliberalen ist die profilierteste und eifrigste Poltikerin der Grünliberalen in Basel-Stadt. Auf Bildungspolitik spezialisiert, spielt sie im Kantonsparlament zusammen mit ihren fraktionslosen Parteikollegen das Zünglein an der Waage. Bei den Nationalratswahlen war sie als Expertin für Listen- und Unterlistenverbindungen unterwegs.',
    'BAT DE': 'Gelb',
    'Text fr':
      "La députée des Vert’libéraux au Grand Conseil est la figure phare du parti de Bâle-Ville. Spécialiste des questions de formation, elle peut souvent faire pencher la balance de son côté avec ses collègues sans groupe parlementaire. Lors des élections au Conseil national, elle s'est également montrée experte en matière d'apparentements et de sous-apparentements de listes.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Riehen',
    'Wohnort fr': 'Riehen',
    Geburtsdatum: '01.08.1972',
    'Beruf de': 'lic.iur., Advokatin',
    'Beruf fr': 'Avocate'
  },
  {
    Elected: 'Ja',
    Sitznummer: '40',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'ZH',
    Nachname: 'Jositsch',
    Vorname: 'Daniel',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015, im Nationalrat von 2007 bis 2015 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2015, précédement au National de 2007 à 2015',
    'Alte Texte DE':
      'Rechtsprofessor Jositsch politisiert am bürgerlichen Rand der SP. Er sitzt in den Kommissionen für Rechtsfragen und für Finanzen. Er ist bekannt dafür, dass er im Strafrecht eine harte Linie vertritt.',
    'Text de':
      'Rechtsprofessor Jositsch politisiert am bürgerlichen Rand der SP. Er sitzt in den Kommissionen für Rechtsfragen und für Finanzen. Er ist bekannt dafür, dass er im Strafrecht eine harte Linie vertritt.',
    'BAT DE': 'fre',
    'Text fr':
      "Les mauvaises langues disent que le professeur de droit Daniel Jositsch politise à l'extrême droite du parti socialiste. Il siège dans les commissions des affaires juridiques et des finances. Il est connu pour sa ligne dure en matière de droit pénal.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zurich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '25.03.1965',
    'Beruf de': 'Rechtsprofessor',
    'Beruf fr': 'Professeur de droit'
  },
  {
    Elected: 'Ja',
    Sitznummer: '41',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BE',
    Nachname: 'Funiciello',
    Vorname: 'Tamara',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die kämpferische Feministin war von 2016 bis 2019 Präsidentin der Juso. Funiciello machte die Jungpartei weiter populär. Gleichzeitig sorgte sie mit  radikalen Forderungen wie der Einführung der 25-Stunden-Arbeitswoche für Kritik.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Militante féministe à la provocation assurmée, la bernoise Tamara Funiciello a été la très médiatique présidente de la Jeunesse socialiste (JSS) de 2016 à 2019. Trilingue, cette étudiante bernoise a également marqué les JSS en lançant plusieurs initiatives populaires durant sa présidence, notamment celle intitulée 99%, qui exige que les 1% les plus riches contribuent davantage à la fiscalité du pays.',
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Berne',
    Geburtsdatum: '20.03.1990',
    'Beruf de': 'Präsidentin JUSO Schweiz',
    'Beruf fr': 'Présidente des JSS'
  },
  {
    Elected: 'Ja',
    Sitznummer: '41',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'SO',
    Nachname: 'Bischof',
    Vorname: 'Pirmin',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2011, im Nationalrat von 2007 bis 2011 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2011, précédement au National de 2007 à 2011',
    'Alte Texte DE':
      'Wenn der Solothurner Anwalt das Wort ergreift, dann dauerts meist länger: Kein anderer redet so gern und so lang wie Bischof. Er ist ein profilierter Wirtschaftspolitiker und mag juristische Fragen. Bischof werden Ambitionen auf ein höheres Amt nachgesagt, zum Beispiel Bundesrat. Einen Fraktions- oder Parteipräsidenten Bischof wird es drum nie geben. Der Solothurner Ständerat ist ein begnadeter Fasnächtler.',
    'Text de':
      'Pirmin Bischof schaffte es im ersten Wahlgang in den Ständerat. Er ist ein Wirtschaftspolitiker und mag staatspolitische Fragen. Bischof war im Gespräch um die Nachfolge von Bundesrätin Doris Leuthard, sagte jedoch aus familiären Gründen ab. ',
    'BAT DE': 'fre',
    'Text fr':
      "Souvent considéré comme l'un des politiciens les plus influents de la Berne fédérale, Pirmin Bischof est profilé sur les questions économiques. Alors que tout le monde voyait cet avocat-notaire diplômé de Harvard se porter candidat à la succession de la conseillère fédérale Doris Leuthard, ce dernier a renoncé pour des raisons familiales. Il est en effet papa de deux jeunes enfants. Aux côtés de Roberto Zanetti (PS), il représente Soleure à la chambre des cantons.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Solothurn',
    'Wohnort fr': 'Soleure',
    Geburtsdatum: '24.02.1959',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '42',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'BE',
    Nachname: 'Bertschy',
    Vorname: 'Kathrin',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Die Ökonomin, die früher im Berner Stadtparlament politisierte, sitzt in der wichtigen Wirtschaftskommission. In gesellschaftspolitischen Fragen setzt sie sich für progressive Lösungen ein, beispielsweise bei der Homo-Ehe und beim Elternurlaub.',
    'Text de':
      'Mit ihrem Einsatz für mehr Markt und Ökologie in der Landwirtschaft hat sich die Ökonomin im Bundeshaus einen Namen als Bauernschreck gemacht. Die Co-Präsidentin von Alliance F setzt sich für Gleichstellung ein.',
    'BAT DE': 'daf',
    'Text fr':
      "La jeune vert'libérale fait figure d'ennemi numéro un pour les agriculteurs. L'économiste plaide pour davantage de concurrence et d'écologie dans ce domaine. Elle assume aux côtés de Maya Graf la co-présidence d'Alliance F, qui promeut la place des femmes en politique, une association qui a pesé sur la double élection de Karin Keller-Sutter et de Viola Amherd au Conseil fédéral. ",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Berne',
    Geburtsdatum: '02.07.1979',
    'Beruf de': 'Ökonomin lic.rer.pol.',
    'Beruf fr': 'Economiste et politologue'
  },
  {
    Elected: 'Ja',
    Sitznummer: '42',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'FR',
    Nachname: 'Gapany',
    Vorname: 'Johanna',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Ständerat seit 2019',
    'DabeiSeit fr': 'Au Conseil des États depuis 2019.',
    'Alte Texte DE': '',
    'Text de':
      'Johanna Gapany, Mitglied der Exekutive der Stadt Bulle, sorgte für Aufsehen, weil sie den bisherigen CVP Ständerat Beat Vonlanthen überholte und damit die erste Ständerätin des Kantons Freiburg wurde. Sie ist jung, fleissig und talentiert und wird wohl noch viel von sich reden lassen.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Johanna Gapany a fait sensation en devançant de quelques voix le PDC sortant Beat Vonlanthen, devenant ainsi la première femme sénatrice pour le canton de Fribourg. Jeune, bûcheuse et talentueuse, la membre de l'exécutif de la ville de Bulle devrait faire reparler d'elle encore longtemps.",
    'BAT FR': '',
    'Wohnort de': 'Bulle',
    'Wohnort fr': 'Bulle',
    Geburtsdatum: '25.07.1988',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '43',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BS',
    Nachname: 'Atici',
    Vorname: 'Mustafa',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der türkische Einwanderer und Unternehmer hat eine steile Karriere hinter sich. In der Schweiz hat er ein Wirtschaftsstudium absolviert und ein Master-Studium am Europainstitut abgeschlossen. In der Basler SP und in der sozialdemokratischen Grossratsfraktion ist Atici beliebt. Er ist Finanzpolitiker und präsidiert die SP-MigrantInnen.',
    'BAT DE': 'Gelb',
    'Text fr':
      "L'immigrant et entrepreneur turc a une carrière de plongeur dans un restaurant derrière lui. Il a étudié l'économie en Suisse et a obtenu un Master au Europainstitut de l’Université de Bâle. Mustafa Atici est populaire au sein du PS bâlois et du groupe parlementaire social-démocrate au Grand Conseil. Il s’occupe essentiellement des questions de politique financière et préside le PS migrant-e-s.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Basel',
    'Wohnort fr': 'Bâle',
    Geburtsdatum: '02.10.1969',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '43',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'AR',
    Nachname: 'Caroni',
    Vorname: 'Andrea',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015, im Nationalrat von 2011 bis 2015 ',
    'DabeiSeit fr':
      'Au Conseil des États depuis 2015, précédement au National de 2011 à 2015',
    'Alte Texte DE':
      'Die schnörkellose Karriere des Andrea Caroni geht weiter: Mit 35 Jahren nimmt der FDP-Hoffnungsträger bereits Einsitz in der „Chambre de Réflexion“. Er versucht sich als (unabhängiger) Wirtschaftspolitiker zu etablieren, kämpft für rechtsstaatliche Prinzipien und gilt auch gesellschaftspolitisch als liberal. Der eloquente Redner spricht gerne bildhaft.',
    'Text de':
      'Andrea Caroni gehört zu den FDP-Politikern mit der höchsten Medienpräsenz. Der 39-jährige Anwalt aus Herisau ist ein eloquenter Redner. Sein Themengebiet ist die Wirtschaftspolitik, aber Caroni äussert sich mit Vorliebe auch zu staats- und gesellschaftspolitischen Themen.',
    'BAT DE': 'fre',
    'Text fr':
      "Andrea Caroni est l'une des personnalités politiques du PLR les plus présentes dans les médias alémaniques. L'avocat de 39 ans de Herisau est un orateur hors pair. Il s'intéresse à la politique économique, mais aime aussi parler des questions sociales ou du rôle de l'Etat.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Herisau',
    'Wohnort fr': 'Herisau',
    Geburtsdatum: '19.04.1980',
    'Beruf de': 'Anwalt, Lehrbeauftragter Universität St. Gallen',
    'Beruf fr': "Avocat, chargé de cours à l'Université de Saint-Gall"
  },
  {
    Elected: 'Ja',
    Sitznummer: '44',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'VD',
    Nachname: 'Pointet',
    Vorname: 'François',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der Grünliberale Mathematiker und Analyst für Informationsdienste, kam im Jahr 2017 in den Waadtländer Grossen Rat. Er setzt sich dort dezidiert für Zukunfts-Technologien ein. Seine Aktion für eine Steuersenkung für die Wadtländer erinnert, dass er in vielen Punkten Mitte-Rechts orientiert ist. ',
    'BAT DE': 'Gelb',
    'Text fr':
      "Le député Vert’libéral de la Riviera dirige la section vaudoise depuis 2014. Mathématicien et analyste en services d'information, il est arrivé au Grand Conseil en 2017 lors des élections générales. Féru d’écologie, il milite pour les technologies du futur et se penche aussi sur des thèmes simples comme le gaspillage alimentaire dont la lutte est portée à Berne par sa mentor Isabelle Chevalley. Son action en faveur d’une baisse d’impôts pour les Vaudois rappelle qu’il reste orienté au centre-droite. ",
    'BAT FR': '',
    'Wohnort de': 'Jongny',
    'Wohnort fr': 'Jongny',
    Geburtsdatum: '25.06.1969',
    'Beruf de': 'Mathematiker',
    'Beruf fr': 'Mathématicien'
  },
  {
    Elected: 'Ja',
    Sitznummer: '44',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'ZG',
    Nachname: 'Michel',
    Vorname: 'Matthias',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2019',
    'DabeiSeit fr': 'Au Conseil des États depuis 2019.',
    'Alte Texte DE': '',
    'Text de':
      'Regierungsrat Matthias Michel hat in seiner Zeit als Volkswirtschaftsdirektor die dynamische Entwicklung des Kantons Zug mitgeprägt. 16 Jahre lang war er Mitglied der Zuger Regierung. Er plädiert für neue Wege, insbesondere in der Bildung und der Altersvorsorge.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Le conseiller d’Etat Matthias Michel a contribué au dynamisme du canton de Zoug lorsqu’il occupé la direction de l’économie publique. Il a été membre du gouvernement zougois pendant 16 ans. Il plaide en faveur de nouvelles approches, notamment en matière de formation et de prévoyance vieillesse.',
    'BAT FR': '',
    'Wohnort de': 'Oberwil',
    'Wohnort fr': 'Oberwil',
    Geburtsdatum: '20.03.1963',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '45',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'NE',
    Nachname: 'Hurni',
    Vorname: 'Baptiste',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der 33-jährige Neuenburger Anwalt war der Favorit für die Nachfolge von Nationalrat Jacques-André Maire, dessen parlamentarischer Assistent er war. Baptiste Hurni präsidierte die SP-Fraktion im Neuenburger Kantonsparlament.',
    'BAT DE': 'Gelb',
    'Text fr':
      "L'avocat neuchâtelois de 33 ans était le favori pour prendre la succession de Jacques-André Maire, dont il a été un temps l'assistant parlementaire. Pari réussi pour ce visage de la politique local. Baptiste Hurni est en effet l'actuel président du groupe socialiste au Parlement cantonal.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Neuenburg',
    'Wohnort fr': 'Neuchâtel',
    Geburtsdatum: '04.04.1986',
    'Beruf de': '',
    'Beruf fr': 'Avocat, député'
  },
  {
    Elected: 'Ja',
    Sitznummer: '45',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'NW',
    Nachname: 'Wicki',
    Vorname: 'Hans',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2015',
    'DabeiSeit fr': 'Au Conseil des États depuis 2015',
    'Alte Texte DE':
      'Wicki wurde 2010 in die Nidwaldner Regierung gewählt, war dort Baudirektor und wechselt nun in den Ständerat.',
    'Text de':
      'Alt Regierungsrat Wicki wurde dieses Jahr in stiller Wahl als Ständerat bestätigt. Im Dezember 2018 kandidierte für den Bundesrat, unterlag aber Karin Keller-Sutter klar. Wicki war unter anderem Börsenhändler und arbeitete als Geschäftsführer und Verwaltungsrat. Seit 2016 präsidiert er die Branchenorganisation Bauenschweiz.',
    'BAT DE': 'fre',
    'Text fr':
      "Ancien membre du gouvernement nidwaldien, Hans Wicki est au Conseil des Etats depuis 2015. En 2019, il a été élu tacitement, faute de candidats d'autres partis. En décembre 2018, il s'était présenté au Conseil fédéral, mais avait été clairement battu par Karin Keller-Sutter. Wicki a – entre autres – été trader à la bourse, administrateur et membre de conseils d'administration. Depuis 2016, il préside l'organisation faîtière Constructionsuisse.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Hergiswil',
    'Wohnort fr': 'Hergiswil',
    Geburtsdatum: '18.02.1964',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '46',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'VD',
    Nachname: 'Chevalley',
    Vorname: 'Isabelle',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Chevallay ist die einzige Repräsentantin der Grünliberalen aus der Romandie. Die Naturwissenschaftlerin gehört der Rechts- und der Bildungskommission an. Medial aufgefallen ist sie mit ihrem Einsatz für die Zulassung von Insekten als Lebensmittel und dem Halteverbot von Delfinen in der Schweiz.',
    'Text de':
      'Sie wäre 2017 gerne Waadtländer Regierungsrätin geworden. Doch mit ihrer Kandidatur scheiterte Isabelle Chevalley kläglich - trotz einer Allianz mit SVP und FDP. Also politisiert die Chemikerin mit Doktortitel weiter im Bundeshaus und ist häufig auf dem afrikanischen Kontinent unterwegs, um Umweltprojekte umzusetzen.',
    'BAT DE': 'daf',
    'Text fr':
      "Isabelle Chevalley aurait bien aimé devenir conseillère d'Etat en 2017, mais la Vaudoise a échoué dans sa candidature, malgré – ou à cause de – son alliance avec l'UDC et le PLR. La chimiste, titulaire d'un doctorat, continue de siéger sous la Coupole, où elle est la seule élue romande des Vert'libéraux. Celle qui occupe aussi la vice-présidence du parti suisse est connue pour ses dégustations d'insectes et se rend fréquemment sur le continent africain pour réaliser des projets environnementaux.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'St-George',
    'Wohnort fr': 'St-George',
    Geburtsdatum: '13.04.1972',
    'Beruf de': '',
    'Beruf fr': 'Consultante'
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '46',
    Rat: 'Ständerat',
    'Funktion de': 'Mitglied des Bundesraats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '47',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'ZG',
    Nachname: 'Weichelt',
    Vorname: 'Manuela',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Sie ist die einzige Frau in der Zuger Regierung und die letzten linken Regierungsrätin der Zentralschweiz. Ihr gelingt nun praktisch nahtlos der Übergang von der Exekutive in die Legsilative. Sie ist die erste Frau, welche den Kanton Zug im Nationalrat vertritt.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Unique femme au Conseil d’Etat zougois et dernière conseillère d'Etat de gauche de Suisse centrale, Manuela Weichelt-Picard assure une transition quasi sans heurt entre l'exécutif et le législatif. Elle est également devenue la première femme à représenter le canton de Zoug au Conseil national.",
    'BAT FR': 'pas relu',
    'Wohnort de': 'Zug',
    'Wohnort fr': 'Zug',
    Geburtsdatum: '21.07.1967',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '47',
    Rat: 'Ständerat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'GR',
    Nachname: 'Schmid',
    Vorname: 'Martin',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Ständerat seit 2011',
    'DabeiSeit fr': 'Au Conseil des États depuis 2011',
    'Alte Texte DE':
      'Schmid ist Spezialist für Steuer- und Finanzrecht und Mitglied mehrere Kommissionen: der Geschäftsprüfungskommission, der Kommission für Wirtschaft und Abgaben, der Kommission für Umwelt, Raumplanung und Energie sowie der Begnadigungskommission. Neben dem Ständeratsmandat ist er als Rechtsanwalt tätig.',
    'Text de':
      'Der Rechtsanwalt ist Spezialist für Steuer- und Finanzrecht. Schmid war im Gespräch als Nachfolger von Bundesrat Johann Schneider-Ammann, sagte aber mit Blick auf die Kandidatur der schliesslich gewählten Favoritin Karin Keller-Sutter ab. Ihm werden aber weiterhin Bundesratsambitionen nachgesagt.',
    'BAT DE': 'fre',
    'Text fr':
      "L'avocat est spécialiste en droit fiscal et financier. Martin Schmid était en lice pour succéder au conseiller fédéral Johann Schneider-Ammann, mais il a finalement renoncé face à l'ultra-favorite Karin Keller-Sutter, finalement élue. On lui prête toutefois l'ambition de toujour vouloir accéder, un jour, à la charge surprême.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Chur',
    'Wohnort fr': 'Coire',
    Geburtsdatum: '24.05.1969',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '48',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'GE',
    Nachname: 'Matter',
    Vorname: 'Michel',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Im Jahr 2000 eröffnete er mit einem Partner ein augenärztliches Zentrum in Genf. Seit 2014 ist er Präsident des Ärzteverbandes des Kantons Genf und seit Mai 2018 Vizepräsident der FMH, des Berufsverbandes der Schweizer Ärztinnen und Ärzte. Er hat sich einen Namen gemacht, als er die Ärzte in der Debatte über hohe Ärzte-Löhne verteidigte. In Genf hatte er sich bereits 2011 im Rahmen der Kampagne gegen die obligatorische Managed Care einen Namen gemacht.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Il a ouvert en 2000, avec un associé, un centre ophtalmologique à Genève. Il est président de l'Association des médecins du canton de Genève depuis 2014 et vice-président de la Fédération suisse des médecins (FMH) depuis mai 2018. Il s'est notamment fait un nom en défendant les médecins dans le débat sur leurs revenus. A Genève, il s'était déjà lancé sur la scène publique en 2011, dans le cadre de la campagne contre le Managed Care obligatoire.",
    'BAT FR': '',
    'Wohnort de': 'Thônex',
    'Wohnort fr': 'Thônex',
    Geburtsdatum: '31.12.1964',
    'Beruf de': 'Augenarzt',
    'Beruf fr': 'Médecin ophtalmologue'
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '48',
    Rat: 'Ständerat',
    'Funktion de': 'Mitglied des Bundesraats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '49',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'BE',
    Nachname: 'Rytz',
    Vorname: 'Regula',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Rytz ist Co-Präsidentin der Grünen Schweiz. In dieser Funktion setzt sie sich vor allem für die Energiewende ein.',
    'Text de':
      'Die Präsidentin der Grünen führt ihre Partei pointiert links, aber lösungsorientiert. Sie versteht es, mit ihrer einnehmenden, aber hartnäckigen und zielstrebigen Art parteiübergreifende Allianzen zu schmieden. ',
    'BAT DE': 'fre',
    'Text fr':
      'La présidente des Verts Suisses, ancienne syndicaliste, maintient la barre de son parti bien à gauche. Mais la Bernoise sait aussi dépasser les clivages et parvient à forger des alliances avec les autres partis tout en se montrant déterminée. Reste que sa volonté de voler un siège de conseiller fédéral au PLR pourrait lui valoir certaines vengeances sous la Coupole.',
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Berne',
    Geburtsdatum: '02.03.1962',
    'Beruf de': 'Präsidentin Grüne Schweiz',
    'Beruf fr': 'Présidente des Verts suisses'
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '49',
    Rat: 'Ständerat',
    'Funktion de': 'Mitglied des Bundesraats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '50',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'VS',
    Nachname: 'Ruppen',
    Vorname: 'Franz',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der Präsident der SVP Oberwallis, Grossrat im Kanton und Gemeinderat von Naters.',
    'Text de':
      'Ruppen ist ein typischer Vertreter der Randregionen. Er ist Präsident der SVP Oberwallis und Gemeindepräsident von Naters. Im Rat ist er unauffällig und äussert sich vor allem bei regionalpolitischen Vorlagen.',
    'BAT DE': 'fre',
    'Text fr':
      "Pur défenseur des régions de montagne, Franz Ruppen s'aligne avec la majorité de la députation valaisanne lorsqu'il s'agit de défendre les intérêts de son canton. De la problématique des redevances hydrauliques à celle de l'aménagement du territoire, il est un homme de dossiers. Président de la commune de Naters, on lui prête des intentions pour le Conseil d'Etat valaisan dans deux ans, où il pourrait reprendre la place perdue par Oskar Freysinger.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Naters',
    'Wohnort fr': 'Naters',
    Geburtsdatum: '24.02.1971',
    'Beruf de': 'Advokat und Notar',
    'Beruf fr': 'Avocat et notaire'
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '50',
    Rat: 'Ständerat',
    'Funktion de': 'Mitglied des Bundesraats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '51',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'VS',
    Nachname: 'Clivaz',
    Vorname: 'Christophe',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der Sittener Stadtrat ist zweifellos der bekannteste Walliser Grüne. Der Politologe und Professor am Institut für Geographie und Nachhaltigkeit der Universität Lausanne ist Experte für Tourismusfragen. Als solcher scheut er sich nicht, offen seine Meinung einzubringen. So schrieb er ein Buch, in dem er den Wintertourismus in Frage stellte. Im Wallis ein mutiger Schritt. Doch an Mut fehlt es Christophe Clivaz nicht.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Le conseiller communal sédunois est sans doute la personnalité valaisanne des Verts la plus connue. Sa campagne était d'ailleurs plutôt discrète. Politologue et professeur d'université, il est un spécialiste des questions touristiques et n'hésite pas à s'inscrire à contre-courant de la pensée dominante dans son canton. On se souvient d'ailleurs de son livre questionnant la fin du tourisme d'hiver tel qu'on le connaît en raison du changement climatique.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Sitten',
    'Wohnort fr': 'Sion',
    Geburtsdatum: '07.01.1969',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '51',
    Rat: 'Ständerat',
    'Funktion de': 'Mitglied des Bundesraats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '52',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BL',
    Nachname: 'de Courten',
    Vorname: 'Thomas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'De Courten ist ehemaliger Wirtschaftsförderer des Kantons Baselland. Mitglied der Kommission für soziale Sicherheit und Gesundheit.',
    'Text de':
      'Thomas de Courten ist Mitglied der Sozial- und Gesundheitskommission. Dort setzt er sich für mehr Wettebwerb im Gesundheitswesen ein. Er steht dem Verband der Generikaindustrie vor und setzt sich gegen feste Höchstpreise bei Generika ein. ',
    'BAT DE': 'fre',
    'Text fr':
      "Thomas de Courten est membre de la commission de sécurité sociale et de la santé publique. Il y prône une concurrence accrue dans le secteur de la santé. Président de la faitière qui défend l'industrie des médicaments génériques, l'UDC s'est porté candidat à la succession d'Evelyne Widmer-Schlumpf au Conseil fédéral en 2015, mais il n'a pas été retenu par son groupe.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Rünenberg',
    'Wohnort fr': 'Rünenberg',
    Geburtsdatum: '29.07.1966',
    'Beruf de': 'eidg. dipl. Betriebsökonom, Unternehmer',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '52',
    Rat: 'Ständerat',
    'Funktion de': 'Sekretär/-in',
    'Funktion fr': 'Secrétaire',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '53',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'ZH',
    Nachname: 'Schlatter',
    Vorname: 'Marionna',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Marionna Schlatter ist seit acht Jahren Präsidentin der Zürcher Grünen und nimmt dort eine zentrale Stellung ein. Sie hat unter anderem die Kulturlandinitiative mitinitiiert, die vom Volk angenommen wurde. Die Soziologin aus Hinwil ist seit ihrer Jugendzeit Pilzkontrolleurin und heute auch Instruktorin der Vereinigung amtlicher Pilzkontrolleure der Schweiz.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Marionna Schlatter est présidente des Verts zurichois depuis huit ans. Son thème principal est évidemment l'environnement. Elle a été, entre autres, l'une des initiatrices de l'Initiative Kulturland qui donne un frein au mitage du territoire dans son canton. La sociologue de Hinwil, village du conseiller fédéral UDC Ueli Maurer, est contrôleuse de champignons depuis sa jeunesse et est aujourd'hui formatrice pour l'Association suisse des organes officiels de contrôle des champignons.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Hinwil',
    'Wohnort fr': 'Hinwil',
    Geburtsdatum: '14.11.1980',
    'Beruf de': 'Pilzkontrolleurin',
    'Beruf fr': 'Formatrice en contrôle de champignons'
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '53',
    Rat: 'Ständerat',
    'Funktion de': 'Mitglied des Bundesraats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '54',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'TG',
    Nachname: 'Herzog',
    Vorname: 'Verena',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2013',
    'DabeiSeit fr': 'Au Conseil national depuis 2013',
    'Alte Texte DE':
      'Im Rennen um die gesellschaftskonservativste Person im Nationalrat mischt die Nachfolgerin des zurückgetretenen Peter Spuhler ganz vorne mit. Herzog setzt sich für die traditionelle Familie ein und will die Homo-Ehe verhindern. Die ausgebildete Kindergärtnerin sitzt in der Bildungskommission.',
    'Text de':
      'Herzog vertritt gesellschaftskonservative Positionen. Sie setzt sich für die traditionelle Familie ein und will die Homo-Ehe verhindern. Die ausgebildete Kindergärtnerin sitzt in der Bildungskommission.',
    'BAT DE': 'fre',
    'Text fr':
      "Verena Herzog soutient des positions conservatrices sur les questions de société. Elle est attachée au modèle de la famille traditionnelle et souhaite empêcher le mariage homosexuel. L'ancienne enseignante d’école enfantine est membre de la Commission de l'éducation (CSEC).",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Frauenfeld',
    'Wohnort fr': 'Frauenfeld',
    Geburtsdatum: '07.02.1956',
    'Beruf de': 'Geschäftsfrau',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '54',
    Rat: 'Ständerat',
    'Funktion de': 'Protokollführer/-in',
    'Funktion fr': 'Procès-verbal',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '55',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'GE',
    Nachname: 'Klopfenstein-Broggini',
    Vorname: 'Delphine',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Co-Generalsekretärin der Grünen engagiet sich für den Ausbau des sogenannten Langsamverkehrs. Politischen Einfluss nahm sie lange Zeit als Verantwortliche der Vereinszeitung von Pro Vélo. Delphine Klopfenstein-Broggini trat 2015 ins Genfer Kantonsparlament ein, wo sie Mitglied der Verkehrskommission war. Gemeinsam mit anderen Frauen engagierte sie sich am Frauenstreik des 14. Juni.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Co-secrétaire-générale des Verts, venant des milieux liés à la mobilité douce (elle a été responsable du journal de Pro Vélo), Delphine Klopfenstein-Broggini est entrée au parlement genevois en 2015. Elle est notamment membre des commissions des affaires communales et des transports. Avec d'autres, elles s'est montrée très active à l'occasion de la grève des femmes du 14 juin.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Versoix',
    'Wohnort fr': 'Versoix',
    Geburtsdatum: '09.06.1976',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '55',
    Rat: 'Ständerat',
    'Funktion de': 'Amtliches Bulletin',
    'Funktion fr': 'Bulletin officiel',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '56',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'OW',
    Nachname: 'Rüegger',
    Vorname: 'Monika',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Monika Rüegger präsidiert die SVP des Kanton Obwalden. Die gelernte Metallbauplanerin kämpft vor allem für gute Rahmenbedingungen für den Tourismus und die Landwirtschaft. Ihre Nomination verlief nicht ohne Nebengeräusche - verschiedene Votanten hätten lieber Kantonsrat und Landwirt Peter Seiler als Kandidaten gesehen.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Monika Rüegger préside l'UDC du canton d'Obwald. La spécialiste en constructions métalliques se bat avant tout pour de bonnes conditions cadres pour le tourisme et l'agriculture. Sa nomination n'est pas passée inaperçue au sein de son parti – plusieurs orateurs lui auraient préféré le député cantonal et l'agriculteur Peter Seiler. Elle aime soigner les traditions, le golfe, la responsabilité individuelle, plaide pour le retour à une immigration \"à un niveau sain\" et – s'agissant de la touche écologique –, elle rappelle s'est battu pour la répouverture de la centrale de collecte de plastique dans sa commune d'Engelberg.",
    'BAT FR': '',
    'Wohnort de': 'Engelberg',
    'Wohnort fr': 'Engelberg',
    Geburtsdatum: '25.02.1968',
    'Beruf de': 'Metallbauplanerin',
    'Beruf fr': 'Spécialiste en constructions métalliques'
  },
  {
    Elected: 'Ja',
    Sitznummer: '57',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'VD',
    Nachname: 'Python',
    Vorname: 'Valentine',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Ihre Wahl war für die Grünen eine grosse Überraschung. Sie ist erst seit 2018 im Kanton Waadt domiziliert, und stand dort nur auf dem 13. von 19. Plätzen der Liste der grünen Kandidaten, hatte also eingentlich kaum eine Wahlchance. Doch die Wählerinnen und Wähler seztzten auf sie. Man erklärt sich ihren Erfolg mit einem Slogan der im Rahmen der Klimademonstrationen skandiert wurde: "Hört auf die Wissenschaftler!". Valentine Python hat einen Master-Abschluss in Geschichte und Geographie, doktorierte 2010 in Klimatologie.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Son élection a été une grande surprise chez les Verts. Elle l'explique par un des slogans des manifestations pour le climat, \"Ecoutez les scientifiques!\". Établie dans le canton de Vaud depuis 2018 seulement, elle se retrouve en 13e position sur la liste de 19 candidats verts Détentrice d'un master en histoire et géographie, elle obtient un doctorat en climatologie en 2010, puis un diplôme d'enseignante en 2014.",
    'BAT FR': '',
    'Wohnort de': 'La Tour-de-Peilz',
    'Wohnort fr': 'La Tour-de-Peilz',
    Geburtsdatum: '17.06.1975',
    'Beruf de': 'Klimatologin',
    'Beruf fr': 'Climatologue'
  },
  {
    Elected: 'Ja',
    Sitznummer: '58',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'VD',
    Nachname: 'Nicolet',
    Vorname: 'Jacques',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Die Bauern sind im Parlament leicht schwächer vertreten als in der letzten Legislatur. Aus dem Kanton Waadt bekommen sie aber Verstärkung: Durch den überraschend neu gewählten Meisterlandwirt Nicolet.',
    'Text de':
      'Der Landwirt wollte für die Waadtländer Bürgerlichen die Mehrheit in der Regierung zurückgewinnen. Er scheiterte klar. Die FDP liess ihn im Stich. In diesem bitteren Moment war Jacques Nicolet froh, sein Mandat als Nationalrat zu haben. Doch in Bern ist er erst wenig in Erscheinung getreten.',
    'BAT DE': 'daf',
    'Text fr':
      "Ancien président du parlement vaudois, cet agriculteur a tenté le grand saut en 2017 en se lançant dans la course au Conseil d'Etat. Mais malgré son profil plus agrarien que blochérien, Jacques Nicolet n'a pas fait le plein des voix à droite et à échoué à reconquérir un siège UDC au grouvernement. Celui qui préside la section cantonale de son parti est élu à Berne depuis 2015, mais peine à exister dans ce parti qui compte déjà de très nombreux spécialistes des questions agricoles.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lignerolle',
    'Wohnort fr': 'Lignerolle',
    Geburtsdatum: '24.10.1965',
    'Beruf de': 'Landwirt',
    'Beruf fr': 'Maître agriculteur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '59',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'ZH',
    Nachname: 'Prelicz-Huber',
    Vorname: 'Katharina',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Katharina Prelicz-Huber war bereits 2008 bis 2011 einmal Nationalrätin. Heute ist sie Zürcher Gemeinderätin und Präsidentin des Verbands des Personals öffentlicher Dienste VPOD. Dort tritt sie vor allem in Frauen- und Sozialfragen in Erscheinung.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Katharina Prelicz-Huber a déjà été conseillère nationale de 2008 à 2011. Aujourd'hui, elle est membre du conseil municipal de Zurich et, en tant que présidente de l'Association du personnel de la fonction publique (VPOD), elle est particulièrement active sur les questions féminines et sociales.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '12.10.1959',
    'Beruf de':
      'Präsidentin Gewerkschaft VPOD, Prof. Soziale Arbeit, Gemeinderätin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '60',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'AG',
    Nachname: 'Burgherr',
    Vorname: 'Thomas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Burgherr ist seit 1997 Grossrat. Er führt die Holzbaufirma Burgherr Moosersäge AG und ist Dozent an der Fachhochschule für die Holzwirtschaft.',
    'Text de':
      'Burgherr ist ein unscheinbarer Parlamentarier. Er führt die Holzbaufirma Burgherr Moosersäge AG und ist Dozent an der Fachhochschule für die Holzwirtschaft. Sein Gebiet ist die Wirtschafts- und Energiepolitik.',
    'BAT DE': 'daf',
    'Text fr':
      "Thomas Burgherr est un parlementaire discret. Il dirige l'entreprise de construction en bois Burgherr Moosersäge AG, tout en étant formateur à la Haute école spécialisée bernoise section bois à Bienne. Son domaine d'expertise est la politique économique et énergétique.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Wiliberg',
    'Wohnort fr': 'Wiliberg',
    Geburtsdatum: '01.08.1962',
    'Beruf de': 'Holzbau-Unternehmer, Kantonalparteipräsident',
    'Beruf fr': 'Entrepreneur dans le bois, président du parti cantonal'
  },
  {
    Elected: 'Ja',
    Sitznummer: '61',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'ZH',
    Nachname: 'Badran',
    Vorname: 'Jacqueline',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Badran führt eine IT-Firma in Zürich. Die Hauptthemen der Ökonomin sind Wirtschaft, Steuern und Immobilien. Sie ist Mitglied der Kommission für Umwelt, Raumplanung und Energie',
    'Text de':
      'Gefürchtet von den politischen Gegnern, fraktionsintern mehr geduldet als geschätzt: Badran lässt niemanden kalt. Die wortgewaltige SP-Frau ist sehr präsent auf allen medialen Kanälen. Ihr Einfluss in der Fraktion korrespondiert zwar nicht mit ihrer grossen Aussenwirkung, aber Badran setzt auch im Bundeshaus Themen. Etwa bei der von ihr angestrebten Verschärfung der Lex Koller.',
    'BAT DE': 'fre',
    'Text fr':
      "Crainte par ses opposants politiques, davantage tolérée au sein de son groupe parlementaire qu'appréciée, Jacqueline Badran ne laisse personne indifférent. L'éloquente femme socialiste est très présente dans les médias alémaniques et sur les réseaux sociaux. Bien que son influence au sein du groupe parlementaire ne corresponde pas à son grand impact à l'extérieur, Jacqueline Badran donne tout de même des impulsions au Parlement, comme par exemple sur le renforcement de la Lex Koller.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '12.11.1961',
    'Beruf de': 'Biologin, Staatswissenschafterin HSG, Unternehmerin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '62',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'BE',
    Nachname: 'Grossen',
    Vorname: 'Jürg',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der Vize-Fraktionspräsident der Grünliberalen aus dem Berner Oberland setzt sich für den Öffentlichen Verkehr und die Förderung von Solarenergie und Energieeffizienz ein. Er ist Unternehmer im Bereich der Gebäudetechnik.',
    'Text de':
      'Der Präsident der Grünliberalen Schweiz setzt sich für den öffentlichen Verkehr sowie die Förderung von Solarenergie und Energieeffizienz ein. Er ist Unternehmer im Bereich der Gebäudetechnik.',
    'BAT DE': 'fre',
    'Text fr':
      "Le président du Parti vert'libéral suisse est entrepreneur dans le domaine de l'assainissement des bâtiments. Il s'engage notamment au Parlement pour les transports publics, la promotion de l'énergie solaire et l'efficience énergétique. ",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Frutigen',
    'Wohnort fr': 'Frutigen',
    Geburtsdatum: '24.08.1969',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '63',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'ZH',
    Nachname: 'Meyer',
    Vorname: 'Mattea',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Die Studentin schaffte 2011 in Zürich die Wahl als jüngste Kantonsrätin. Den Bundeshausbetrieb kennt sie bereits von innen: Sie arbeitet als persönliche Mitarbeiterin der SP-Nationalräte Cédroic Wermuth und Marina Carobbio.',
    'Text de':
      'Meyer gehört dem linken Flügel ihrer Partei an. Die frühere Vizepräsidentin der Juso hat mit ihren zahlreichen Vorstössen zu Gleichstellungs-, Flüchtlings- und Steuerfragen ihre aktivistische Haltung auch im Parlament beibehalten. Sie steht für eine junge Generation von Politikerinnen, deren Einfluss im Laufe der Legislatur zugenommen hat.',
    'BAT DE': 'fre',
    'Text fr':
      "Mattea Meyer appartient à l'aile gauche de son parti. L'ancienne vice-présidente des Jeunes socialistes a conservé sa posture militante au Parlement, notamment au travers de nombreuses interventions sur les questions d'égalité des sexes, de l'aide aux réfugiés et en matière de de fiscalité. Elle représente une jeune génération de femmes politiques dont l'influence s'est accrue au cours de la législature.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Winterthur',
    'Wohnort fr': 'Winterthur',
    Geburtsdatum: '09.11.1987',
    'Beruf de': 'Wirtschaftsgeographin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '64',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'ZH',
    Nachname: 'Moser',
    Vorname: 'Tiana Angelina',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Moser ist Fraktionspräsidentin der Grünliberalen. Die Umweltwissenschafterin ist zudem Mitglied der Aussenpolitischen Kommission.',
    'Text de':
      'Moser profitiert als GLP-Fraktionschefin von der Hochkonjunktur der Umweltpolitik. Die eloquente Rednerin hat sich in dieser Legislatur definitiv aus dem Schatten von GLP-Gründer Martin Bäumle gelöst.',
    'BAT DE': 'fre',
    'Text fr':
      "La cheffe du groupe Vert-libéral, Tiana Angelina Moser profite de l'essor de la thématique environnementale. Cette oratrice éloquente a définitivement quitté l'ombre du fondateur du parti Martin Bäumle.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '06.04.1979',
    'Beruf de': 'Politik- und Umweltwissenschaftlerin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '65',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'GE',
    Nachname: 'Fehlmann Rielle',
    Vorname: 'Laurence',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Die ehemalige Präsidentin der SP Genf war lange Jahre Kantonsrätin und ist heute im Stadtrat von Genf.',
    'Text de':
      'Die Genferin Rielle Fehlmann verbrachte eine unscheinbare erste Legislatur im Nationalrat. Gemessen an ihren persönlichen Schwerpunktthemen wie der Gesundheits- und Aussenpolitik, aber auch dem Schutz der Sozialwerke und der Frauenrechte, läge wohl mehr drin. Wie Jean-Charles Rielle, ihr Ehemann und Vorgänger im Nationalrat, ist sie eine Tabakgegnerin. ',
    'BAT DE': 'daf',
    'Text fr':
      "Militante anti-tabac comme son mari Jean-Charles Rielle, conseiller national avant elle, la Genevoise ne s'est pas vraiment démarquée au parlement fédéral durant sa première législature. Si ce n'est, peut-être, en faisant reconnaître pénalement la notion de viol sur les hommes, jusque-là limitée aux victimes de sexe féminin. Elle est surtout active sur des questions de santé publique.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Genf',
    'Wohnort fr': 'Genève',
    Geburtsdatum: '11.09.1955',
    'Beruf de': '',
    'Beruf fr': 'Spécialiste en santé publique'
  },
  {
    Elected: 'Ja',
    Sitznummer: '66',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'LU',
    Nachname: 'Fischer',
    Vorname: 'Roland',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Roland Fischer gehört bereits von 2011 bis 2015 dem Nationalrat an. Der Luzerner ist als pointierter Sicherheitspolitiker aufgefallen. Obwohl selber Hauptmann, setzte er sich 2014 entschieden gegen den schliesslich gescheiterten Kauf des schwedischen Kampfjets Gripen ein.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Roland Fischer était déjà membre du Conseil national de 2011 à 2015. Le Lucernois s’est distingué par sa pertinence sur les questions de sécurité. Bien qu'il soit lui-même capitaine, il s'est fermement opposé en 2014 à l'achat finalement avorté de l’avion de combat suédois Gripen.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Udligenswil',
    'Wohnort fr': 'Udligenswil',
    Geburtsdatum: '05.04.1965',
    'Beruf de': 'Ökonom, Dozent HSLU',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '67',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'FR',
    Nachname: 'Piller Carrard',
    Vorname: 'Valérie',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Piller Carrard sitzt für die SP zwar in der Verkehrskommission. Weit mehr als der Verkehr, so scheint es, interessieren sie aber Fragen rund um die Familie.',
    'Text de':
      'Piller Carrard befasst sich insbesondere mit sozial- und familienpolitischen Fragen. Die Freiburgerin musste aber in der vergangenen Legislatur mit einem Sitz in der Staatspolitischen Kommission Vorlieb nehmen. Nun hat sie vor den Wahlen den dringenden Wunsch geäussert, im Fall einer Wiederwahl in die Kommission für soziale Sicherheit und Gesundheit zu wechseln. ',
    'BAT DE': 'fre',
    'Text fr':
      "Bien que membre de la Commission de gestion et de la Commission des institutions politiques, Valérie Piller Carrard s'est davantage engagée sur les questions de politique familiale et sociale lors de la précédente législature. Candidate malheureuse à la course au Conseil d'Etat fribourgeois en 2018, où elle briguait le siège de la Verte Marie Garnier, elle espère pouvoir entrer dans la Commission de la sécurité sociale et de la santé publique.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Cheyres',
    'Wohnort fr': 'Cheyres',
    Geburtsdatum: '09.09.1978',
    'Beruf de': '',
    'Beruf fr': 'Employée de commerce'
  },
  {
    Elected: 'Ja',
    Sitznummer: '68',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'ZH',
    Nachname: 'Gredig',
    Vorname: 'Corina',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Corina Gredig hat einen steilen politischen Aufstieg hinter sich: Die Politologin, die als einer der Treiber des grünliberalen Booms gilt, begann 2010 als Sekretärin in der kantonalen Partei; 2017 schaffte sie den Sprung in den Stadtzürcher Gemeinderat, seit März 2019 sitzt sie im Kantonsrat. Breite Bekanntheit erlangte sie, als sie 2018 zusammen mit Nicola Forster das Präsidium der Zürcher Grünliberalen übernahm.',
    'BAT DE': 'daf',
    'Text fr':
      "Corina Gredig a fait une ascension politique fulgurante: la politologue, considérée comme l'un des moteurs du boom vert-libéral, a commencé comme secrétaire du parti cantonal en 2010; en 2017, alors qu'elle n'a que 30 ans, elle a été élue au conseil de ville de Zurich; et depuis mars 2019, elle est députée au Grand conseil. Elle s'est fait connaître lorsqu'elle pris la co-présidence des Verts libéraux de Zurich en 2018.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '08.09.1987',
    'Beruf de': 'Sozialwissenschaftlerin, Geschäftsführerin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '69',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'VD',
    Nachname: 'Marra',
    Vorname: 'Ada',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Marra ist Mitglied der Wirtschafts- sowie der Immunitätskommission. Sie engagiert sich insbesondere im Kampf gegen die Schwarzarbeit. Gerne hätte sie, dass ihr erster Vorstoss als Nationalrätin überhaupt – eine parlamentarische Initiative für die erleichterte Einbürgerung für Ausländer der dritten Generation – nun endlich erfolgreich zu Ende beraten wird.',
    'Text de':
      'Ada Marra hat sich in der Waadt erfolgreich das Profil der Seconda und Arbeitertochter aufgebaut. Ihr Erfahrungsbericht "Ab wann ist man vor hier?", auf Deutsch im Verlag Zytglogge erschienen, hat in der Romandie für grosses Aufsehen gesorgt. Bei der Wahl als Ständeratskandidatin stach sie SP-Fraktionschef Roger Nordmann aus. Ihr Schwerpunkt ist die Migrations- und Ausländerpolitik.',
    'BAT DE': 'daf',
    'Text fr':
      "Fille d'ouvrier, Ada Marra a fait de son statut de seconda une arme politique. Populaire partout en Suisse romande, elle a peu à peu quitté le terrain des questions de migration pour se profiler sur les thèmes économiques. Mais sa plus grande victoire de la législature passée reste la naturalisation facilitée pour les étrangers de 3e génération acceptée par le peuple. C'est elle aussi que le PS vaud a préféré à Roger Nordmann pour conserver le siège de Géraldine Savary au Conseil des Etats.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lausanne',
    'Wohnort fr': 'Lausanne',
    Geburtsdatum: '10.03.1973',
    'Beruf de': 'Berufspolitikerin',
    'Beruf fr': 'Politicienne professionnelle'
  },
  {
    Elected: 'Ja',
    Sitznummer: '70',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'AG',
    Nachname: 'Flach',
    Vorname: 'Beat',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der frühere Rheinmatrose war in seiner ersten Legislatur einer der auffälligsten Nationalräte seiner Fraktion. Er ist Mitglied der Rechtskommission und der Sicherheitspolitischen Kommission.',
    'Text de':
      '2011 wurde Beat Flach für die Grünliberalen in den Nationalrat gewählt. Der Jurist ist ein Sicherheitspolitiker. Auch in den Bereichen Menschenrechte und Sozialpolitik engagiert er sich.  ',
    'BAT DE': 'daf',
    'Text fr':
      "Déjà élu en 2011 au Conseil national pour les Vert’libéraux, Beat Flach est un juriste qui s'engage en faveur des droits de l'homme et de la politique sociale. Un engagement qui se reflète également à travers son implication dans de nombreuses fondations et associations.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Auenstein',
    'Wohnort fr': 'Auenstein',
    Geburtsdatum: '21.01.1965',
    'Beruf de': 'Jurist MLaw/SIA',
    'Beruf fr': 'Juriste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '71',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'VS',
    Nachname: 'Reynard',
    Vorname: 'Mathias',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Vor vier Jahren wurde Reynard als jüngster Nationalrat gewählt. Er engagiert sich in der Bildungspolitik und für die Rechte von Homosexuellen. Das Parlament stimmte einem Vorstoss Reynards zu, der die Diskriminierung von Homosexuellen unter Strafe stellen will.',
    'Text de':
      'Reynard engagiert sich in der Bildungspolitik und für die Rechte von Homosexuellen. Das Parlament stimmte einem Vorstoss des Wallisers zu, der die Diskriminierung von Homosexuellen unter Strafe stellen will.',
    'BAT DE': 'fre',
    'Text fr':
      "Mathias Reynard était le benjamin du Parlement lors de son élection en 2011. Huit ans plus tard et avec deux législatures dans les jambes, il en est un poids lourd. S'il ne s'est jamais écarté de sa ligne syndicaliste, il s'est illustré cette dernière législature en s'engageant fortement sur les thématiques de la formation, du harcèlement et des discriminations à l'égard des homosexuels. ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Savièse',
    'Wohnort fr': 'Savièse',
    Geburtsdatum: '07.09.1987',
    'Beruf de': 'Lehrer',
    'Beruf fr': 'Enseignant au CO Savièse'
  },
  {
    Elected: 'Ja',
    Sitznummer: '72',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'ZH',
    Nachname: 'Bellaïche',
    Vorname: 'Judith',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Digitalisierung und Start-ups waren bislang die Kernthemen von Judith Bellaïche. Die Geschäftsführerin eines ICT-Verbands amtierte acht Jahre als Gemeinderätin in der Zürichseegemeinde Kilchberg und politisierte im Zürcher Kantonsrat.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Jusqu'à présent, la numérisation et la création d'entreprises ont été les thèmes centraux de Judith Bellaïche. La directrice générale de Swico, l’association pour la Suisse numérique, a siégé huit ans à l'exécutif communal de Kilchberg au bord du lac de Zurich et a été députée au Grand Conseil zurichois.",
    'BAT FR': '',
    'Wohnort de': 'Kilchberg',
    'Wohnort fr': 'Kilchberg',
    Geburtsdatum: '02.02.1971',
    'Beruf de': 'Geschäftsleiterin Swico und Swico Recycling',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '73',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'SO',
    Nachname: 'Roth',
    Vorname: 'Franziska',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Franziska Roth kandidierte schon zweimal für einen Sitz im Nationalrat. Die Heilpädagogin gehört seit 2009 dem Kantonsrat an und präsidiert die SP des Kantons Solothurn. Sie will sich vor allem im Bereich Bildung einsetzen.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Franziska Roth s'est déjà présentée deux fois pour un siège au Conseil national. L'enseignante spécialisée est membre du Grand Conseil depuis 2009 et préside le PS du canton de Soleure. Elle veut avant tout s'impliquer dans le domaine de la formation.",
    'BAT FR': 'pas relu',
    'Wohnort de': 'Solothurn',
    'Wohnort fr': 'Soleure',
    Geburtsdatum: '17.04.1966',
    'Beruf de': 'Heilpädagogin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '74',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'ZH',
    Nachname: 'Mäder',
    Vorname: 'Jörg',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Jörg Mäders Kernthemen sind Digitalisierung, Gesundheit und Nachhaltigkeit. Er möchte, dass jedes Dach ein Solaranlage trägt oder begrünt ist. Erreichen will er das über Marktanreize oder Subventionen, nur im Notfall mit Verboten. Mäder ist Gesundheits-Vorsteher der Stadt Opfikon. Der freischaffende Informatiker und Mathelehrer engagiert sich auch in der freiwilligen Feuerwehr.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Les thèmes centraux de Jörg Mäder sont la numérisation, la santé et la durabilité. Il veut que chaque toit porte des panneaux solaires ou soit végétalisé. Il entend y parvenir par le biais d'incitations commerciales ou de subventions – et uniquement en dernier recours en prononçant des interdictions. Jörg Mäder est responsable de la Santé de la ville d'Opfikon. L'informaticien et professeur de mathématiques est également très impliqué dans les pompiers volontaires.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Opfikon',
    'Wohnort fr': 'Opfikon',
    Geburtsdatum: '20.07.1975',
    'Beruf de':
      'Dr. sc. ETH Umweltnaturwiss., Programmierer, Stadt-/Kantonsrat',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '75',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BL',
    Nachname: 'Marti',
    Vorname: 'Samira',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2018',
    'DabeiSeit fr': 'Au Conseil national depuis 2018',
    'Alte Texte DE': '',
    'Text de':
      'Samira Marti setzt sich für den Feminismus und das Klima ein. Im vergangenen Dezember rückte sie für Susanne Leutenegger Oberholzer in den Nationalrat nach - und schafft nun die Wiederwahl.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Samira Marti s'engage pour le féminisme et le climat. En décembre dernier, elle a succédé à Susanne Leutenegger Oberholzer au Conseil national - et elle est maintenant réélue.",
    'BAT FR': '',
    'Wohnort de': 'Ziefen',
    'Wohnort fr': 'Ziefen',
    Geburtsdatum: '23.01.1994',
    'Beruf de': 'Ökonomin',
    'Beruf fr': 'Économiste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '76',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Haab',
    Vorname: 'Martin',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Martin Haab rückte im Juni 2019 für Natalie Rickli in den Nationalrat nach. Der 57-jährige Landwirt aus Mettmenstetten bezeichnet sich auf seiner Website als leidenschaftlicher Braunviehzüchter.',
    'BAT DE': 'fre',
    'Text fr':
      "Martin Haab est entré au Conseil national en juin 2019. Il y a remplacé Natalie Rickli, élue au Conseil d'Etat zurichois. A 57 ans, ce maître-agriculteur siège dans la commission des affaires juridiques.",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Mettmenstetten',
    'Wohnort fr': 'Mettmenstetten',
    Geburtsdatum: '03.05.1962',
    'Beruf de': 'eidg. dipl. Landwirt',
    'Beruf fr': 'Agriculteur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '77',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'ZH',
    Nachname: 'Glättli',
    Vorname: 'Balthasar',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Glättli ist Fraktionspräsident der Grünen. Als Mitglied der Staatspolitischen Kommission widmet er sich vermehrt der Flüchtlings- und Asylpolitik.',
    'Text de':
      'Es ist nicht nur die alles dominierende Klimadebatte, die Glättli zum einflussreichsten Zürcher Nationalrat macht. Der Schnelldenker und Stratege prägt jene Themen, die dem Zeitgeist entsprechen: Umwelt, Digitalisierung, Grundrechte - überall hat der gut vernetzte Fraktionschef der Grünen die Nase vorn.',
    'BAT DE': 'fre',
    'Text fr':
      "Ce n'est pas seulement le débat sur le climat qui fait de Glättli le Zurichois le plus influent du Conseil national. Vif d'esprit et fin stratège, il parvient à mettre sa patte sur les sujets qui sont dans l'air du temps: environnement, digitalisation, droits fondamentaux – grâce à ses très nombreuses relations dans différents milieux, le chef du groupe parlementaire des Verts a toujours un coup d'avance.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '12.02.1972',
    'Beruf de': 'Präsident Mieterverband Deutschschweiz, Kleinunternehmer',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '78',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'TG',
    Nachname: 'Strupler',
    Vorname: 'Manuel',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Manuel Strupler führt einen eigenen Hof, fühlt sich aber genau so wohl im Sägemehl-Kreis. Er ist seit mehr als zehn Jahren im Schweizer Ringen aktiv - und dies auf hohem Niveau. Ausserdem steht er an der Spitze von verschiedenen Unternehmen, die er gegründet hat. Er betrat 2016 die politische Arena im Grossen Rat von Thurgau und kommt jetzt neu in den Nationalrat. Im Bereich der Klimapolitik hebt sich Weinfeldener Riese von seiner Partei ab. So plädiert er zum Beispiel für eine moderateres Konsumverhalten.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Manuel Strupler dit se sentir autant à l’aise dans le rond de sciure (il a fait de la lutte suisse à haut niveau durant plus de 10 ans), dans l’exploitation agricole qu’il gère, et à la tête des différentes entreprises qu’il a crées. Son entrée dans l’arène politique, en 2016 au Grand conseil thurgovien et en décembre 2019 au Conseil national, est en revanche plutôt récente. Pur produit UDC en matière de politique des étrangers, le géant de Weinfelden se distingue de son parti sur les questions climatiques: il préconise par exemple une modération du consumérisme.',
    'BAT FR': '',
    'Wohnort de': 'Weinfelden',
    'Wohnort fr': 'Weinfelden',
    Geburtsdatum: '12.04.1980',
    'Beruf de': 'Gartenbauunternehmer, Landwirt',
    'Beruf fr': 'Entrepreneur et agriculteur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '79',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'BE',
    Nachname: 'Trede',
    Vorname: 'Aline',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat von 2013 bis 2015 und seit 2018',
    'DabeiSeit fr': 'Au Conseil national de 2013 à 2015 et depuis 2018',
    'Alte Texte DE': '',
    'Text de':
      "Nachdem sie 2013 und 2018 jeweils in den Nationalrat nachgerückt war, schaffte Aline Trede den Sprung jetzt durch die Vordertür. Sie wurde als zweitbeste Grüne des Kantons Bern gewählte, mit 22'000 Stimmen vor Kilian Baumann. Die erfahrene Politikerin Aline Trede half bei der Lancierung der Anti-Offroader-Initiative und war Präsidentin der Jungen Grünen. Von 2008 bis 2012 war sie auch Vizepräsidentin der Grünen Partei der Schweiz. Sie war eine der ersten, die das Macho-Klima im Parlament öffentlich anprangerte.",
    'BAT DE': 'Gelb',
    'Text fr':
      "Après avoir accédé au Conseil national comme vient-ensuite en 2013 et 2018 (elle n'avait pas été réélue en 2015), Aline Trede y est finalement entrée par la grande porte, comme deuxième meilleure élue verte dans le canton de Berne, avec 22000 voix d'avance sur le suivant Kilian Baumann. Politicienne aguerrie, Aline Trede a contribué à lancer l'initiative anti-4x4 et a été présidente des Jeunes Verts. Elle a aussi été vice-présidente des Verts Suisse de 2008 à 2012. Elle a été l'une des premières à dénoncer publiquement le climat machiste au Parlement fédéral.",
    'BAT FR': '',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Berneck',
    Geburtsdatum: '26.08.1983',
    'Beruf de': 'Politikerin',
    'Beruf fr': 'Politicienne'
  },
  {
    Elected: 'Ja',
    Sitznummer: '80',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'VD',
    Nachname: 'Grin',
    Vorname: 'Jean-Pierre',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Der Landwirt im Pensionsalter ist Mitglied der Finanz- und der Bildungskommission.',
    'Text de':
      'Im Bundesparlament gilt der bereits 2007 in den Nationalrat gewählte Landwirt Jean-Pierre Grin als äusserst diskret. Womit er auffiel, waren seine Interventionen für ein Verbot von Palmöl oder für eine Revision der Sanktionen im Verkehrssicherheits-Programm Via sicura.',
    'BAT DE': 'daf',
    'Text fr':
      "Elu au Conseil national depuis 2007, cet agriculteur discret remporte régulièrement des victoires sous la Coupole avec ses interventions, comme pour l'interiction de l'huile de palme ou la révision des sanctions dans Via sicura. Sur le plan judiciaire, l'UDC a fait parler de lui en 2014 pour avoir été condamné avec sursis pour homicide par négligence, alors qu'il était au volant de son tracteur.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Pomy',
    'Wohnort fr': 'Pomy',
    Geburtsdatum: '16.03.1947',
    'Beruf de': 'Landwirt',
    'Beruf fr': 'Maître agriculteur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '81',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'TI',
    Nachname: 'Gysin',
    Vorname: 'Greta',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Regionalmanagerin bei der Gewerkschaft Transfair sitzt für die Grünen im Tessiner Grossen Rat. Umwelt, Gleichstellung der Geschlechter und Arbeitsmarktschutz sind ihre bevorzugten Themen.',
    'BAT DE': 'Gelb',
    'Text fr':
      "La responsable région Est du syndicat Transfair siège au Grand Conseil tessinois pour les Verts. L'environnement, l'égalité des sexes et la protection du marché du travail sont les thèmes favoris de Greta Gysin.",
    'BAT FR': 'pas relu',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '06.10.1983',
    'Beruf de': 'Politologin',
    'Beruf fr': 'Politologue et syndicaliste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '82',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'FR',
    Nachname: 'Page',
    Vorname: 'Pierre-André',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Page ist langjähriger Grossrat in Freiburg und begeisterter Hobby-Musikant.',
    'Text de':
      'Der Meisterlandwirt aus Châtonnaye gehört zu den ruhigeren Naturen im Parlament. Er gilt als gemässigtes Mitglied der SVP-Fraktion. Beim Thema Klimawandel ist er zum Beispiel nicht zufrieden mit seiner Partei.',
    'BAT DE': 'fre',
    'Text fr':
      "Le maître-agriculteur de Châtonnaye, seul élu du district de la Glâne à Berne, passe pour un UDC modéré. Il s'est illustré ces derniers mois par sa position marquée sur les questions climatiques, estimant que les paysans sont les premiers touchés par le réchauffement climatique et que son parti n'a pas assez communiqué à ce sujet. ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Châtonnaye',
    'Wohnort fr': 'Châtonnaye',
    Geburtsdatum: '19.04.1960',
    'Beruf de': 'Landwirt',
    'Beruf fr': 'Maître agriculteur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '83',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'SG',
    Nachname: 'Ryser',
    Vorname: 'Franziska',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Franziska Ryser holt für die Grünen den Nationalratssitz zurück, den die Partei 2015 verloren hat. Parteiintern hat sie sich gegen Yvonne Gilli durchgesetzt. Ryser kandidierte auch für den Ständerat.\n',
    'BAT DE': 'Gelb',
    'Text fr':
      'Franziska Ryser reprend pour les Verts le siège du Conseil national que le parti avait perdu en 2015. Au sein du parti, elle a vaincu Yvonne Gilli.',
    'BAT FR': '',
    'Wohnort de': 'St. Gallen',
    'Wohnort fr': 'Saint-Gall',
    Geburtsdatum: '22.10.1991',
    'Beruf de': 'MSc ETH Maschineningenieurwissenschaften',
    'Beruf fr': 'Ingénieur en mécanique'
  },
  {
    Elected: 'Ja',
    Sitznummer: '84',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'EDU',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BE',
    Nachname: 'Gafner',
    Vorname: 'Andreas',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Obwohl die EDU schwächer abschnitt als 2015, zieht Andreas Gafner in den Nationalrat ein. Dies gelang der Partei dank geschickter Listenverbindungen. Damit erobert der Landwirt aus dem Berner Oberland den 2011verlorenen EDU-Sitz zurück.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Bien que la performance Union démocratique fédérale (UDF) ait été plus faible qu'en 2015, Andreas Gafner fait le saut au Conseil national. Il y est parvenu grâce à des apparentements habiles. Le maître agriculteur de l'Oberland bernois récupère ainsi le siège UDF perdu en 2011.",
    'BAT FR': '',
    'Wohnort de': 'Oberwil',
    'Wohnort fr': 'Oberwil',
    Geburtsdatum: '11.04.1969',
    'Beruf de': 'Betriebsleiter Landwirtschaft\n',
    'Beruf fr': 'Agriculteur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '85',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'ZH',
    Nachname: 'Girod',
    Vorname: 'Bastien',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Der Naturwissenschafter ist Vize-Präsident der Schweizer Grünen. Er sitzt in der Kommission für Umwelt, Raumplanung und Energie. Seine Vorstösse handeln sich vorwiegend um diese Themen.',
    'Text de':
      'Der Naturwissenschafter gehört weiterhin zu den Grünen Wortführern im Rat. Weil die Umweltpolitik inzwischen in fast allen Parteien angekommen ist, sticht Girod mit seinen Voten und Vorstössen weniger hervor als früher. Als er 2017 Zürcher Stadtrat werden wollte, bremste ihn die eigene Partei aus.',
    'BAT DE': 'fre',
    'Text fr':
      "Le docteur en sciences naturelles est toujours l'un des portes-voix des Verts au sein du Conseil national. Parce que la politique environnementale est maintenant de rigueur dans pratiquement tous les partis, Girod se démarque moins qu'avant avec ses votes et ses propositions. Lorsqu'il a voulu devenir membre de l'exécutif de la ville de Zurich en 2017, son propre parti l'a freiné.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '21.12.1980',
    'Beruf de': 'Umweltnaturwissenschafter, ETH-Dozent, Unternehmensberater',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '86',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BE',
    Nachname: 'von Siebenthal',
    Vorname: 'Erich',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Als Bergbauer gehört von Siebenthal zur Landwirtschaftsfraktion innerhalb der SVP. Mitglied der Sicherheits- und der Geschäftsprüfungskommission.',
    'Text de':
      'Als Bergbauer gehört von Siebenthal zur Landwirtschaftsfraktion innerhalb der SVP. Er ist Präsident des Schweizerischer Alpwirtschaftlichen Verbands und leitet die parlamentarischen Gruppe Schweiz-Israel.',
    'BAT DE': 'fre',
    'Text fr':
      "Paysan de montagne, Erich von Siebenthal préside la Société suisse d’économie alpestre et dirige le groupe parlementaire Suisse-Israël. Son nom a été également cité dans des articles en lien avec l'Eglise de scientologie. Le Bernois a en effet repris tel quel – dans une intervention parlementaire – des propositions émanant de scientologues sur l'utilisation des électrochocs en médecine. Unproximité que le principal intéressé nie.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Gstaad',
    'Wohnort fr': 'Gstaad',
    Geburtsdatum: '30.12.1958',
    'Beruf de': 'Bergbauer, Betriebsleiter Bergbahn Wasserngrat',
    'Beruf fr': 'Agriculteur de montagne'
  },
  {
    Elected: 'Ja',
    Sitznummer: '87',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'GE',
    Nachname: 'Pasquier',
    Vorname: 'Isabelle',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Geographin und Umweltwissenschaftlerin hat mehrere politische Coups gemacht, die ihr eine gewisse Aufmerksamkeit ausserhalb des Kantons Genf verschafft haben: Verbot von Plakaten für Kleinkredite, Begrenzung der Flugbewegungen in Genf, Berechnung der Folgen eines möglichen Unfalls beim Chlortransport. Isabelle Pasquier ist auch in einem Teilpensum als westschweizer Koordinatorin der Alpeninitiative tätig.',
    'BAT DE': 'Gelb',
    'Text fr':
      'La géographe et spécialiste en sciences de l’environnement est auteure de plusieurs coups politiques qui lui on donné une certaine assise médiatique au-delà du canton de Genève: interdiction des affiches pour le petit crédit, limitation des mouvements d’avion à l’aéroport de Genève, calcul des conséquences d’un éventuel accident lors du transport de chlore. Isabelle Pasquier est aussi employée à mi-temps comme coordinatrice romande de l’Initiative des Alpes.',
    'BAT FR': '',
    'Wohnort de': 'Carouge (GE)',
    'Wohnort fr': 'Carouge (GE)',
    Geburtsdatum: '17.03.1973',
    'Beruf de': 'Geographin',
    'Beruf fr': "Coodrinatrice de l'initiative des Alpes"
  },
  {
    Elected: 'Ja',
    Sitznummer: '88',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SO',
    Nachname: 'Imark',
    Vorname: 'Christian',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Imark ist Fraktionschef der SVP im Solothurner Kantonsrat. Er ersetzt das Urgestein Roland Borer.',
    'Text de':
      'Imark ist Geschäftsleiter einer kleinen Firma, die Zelte und Partyzubehör vermietet. Er sieht sich als Büezer, der die Sorgen des arbeitenden Volkes kennt. Der 37-Jährige kandidiert auch für den Ständerat und landete auf der dritten Position. In Solothurn gibt es einen zweiten Wahlgang. ',
    'BAT DE': 'fre',
    'Text fr':
      "Christian Imark est le directeur d'une petite entreprise spécialisée dans la location de matériel de fête. Il se sent proche des travailleurs et apte à défendre leurs intérêts. Cette année, le jeune homme de 37 ans a défié en vain les deux conseillers aux États sortant",
    'BAT FR': '',
    'Wohnort de': 'Fehren',
    'Wohnort fr': 'Fehren',
    Geburtsdatum: '29.01.1982',
    'Beruf de': 'selbständiger Unternehmer',
    'Beruf fr': 'Entrepreneur indépendant'
  },
  {
    Elected: 'Ja',
    Sitznummer: '89',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'Grüne',
    'Fraktion de': 'Grüne Fraktion',
    'Fraktion fr': 'Groupe des Verts',
    Kanton: 'NE',
    Nachname: 'Fivaz',
    Vorname: 'Fabien',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Fabien Fivaz, langjähriges Mitglied des Grossen Rates von Neuenburg, ist ein bekanntes Gesicht in der Lokalpolitik. Der Chaux-de-fonnier arbeitet als wissenschaftlicher Mitarbeiter am Schweizerisches Zentrum für die Kartografie der Fauna in Neuenburg. Er setzt sich insbesondere für eine lokale Wirtschaft und Landwirtschaft ein.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Député de longue date au Grand conseil neuchâtelois, Fabien Fivaz est un visage connu de la politique locale. Le Chaux-de-fonnier travaille comme collaborateur scientifique au Centre suisse de cartographie de la faune à Neuchâtel. Il s'engage notamment pour une économie et une agriculture de proximité.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'La Chaux-de-Fonds',
    'Wohnort fr': 'La Chaux-de-Fonds',
    Geburtsdatum: '25.01.1978',
    'Beruf de': 'Biologe',
    'Beruf fr': 'Biologiste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '90',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SO',
    Nachname: 'Wobmann',
    Vorname: 'Walter',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2003',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Im Nationalrat sitzt Wobmann in der Umwelt- und in der Verkehrskommission. Aufgefallen ist er aber vor allem ausserhalb des Parlaments: Als Urheber der Minarett- und nun auch der Burka-Initiative. 2013 war er mit einem Referendum gegen höhere Vignetten-Preise erfolgreich.',
    'Text de':
      'Wobmann ist seit 2003 im Nationalrat. Er politisiert am rechten Flügel der SVP und vertritt nationalkonservative Ansichten. Ausserhalb des Parlaments ist der Verkaufsleiter als Urheber der Minarett- und  der Burka-Initiative aufgefallen. ',
    'BAT DE': 'fre',
    'Text fr':
      "Walter Wobmann siège au Conseil national depuis 2003. Il appartient à l’aile droite de l'UDC et représente les opinions du camp national-conservateur. En dehors du Parlement, le président de la Fédération Motocycliste Suisse est surtout connu pour être l’auteur des initiatives «Contre la construction de minarets» et pour «l'interdiction de se dissimuler le visage», qui vise le port de la burqa ou du niqab.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '29.06.1960',
    'Beruf de': 'Hauswartsangestellter',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '91',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'ZH',
    Nachname: 'Barrile',
    Vorname: 'Angelo',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der Arzt und Kantonsrat rutscht für Daniel Jositsch in den Nationalrat nach.',
    'Text de':
      'Der Hausarzt widmet sich vor allem der Gesundheits- und der Migrationspolitik. Barrile politisierte in seiner ersten Legislatur eher unscheinbar. Dennoch schaffte er es auf Platz eins der Wahlliste der Zürcher SP.',
    'BAT DE': 'fre',
    'Text fr':
      "Le médecin de famille s'occupe en premier lieu de la politique de santé et de migration. Il est un fervent défenseurs des controversés tests pour l'usage récréatif du cannabis. Barrile s'est montré relativement discret lors de sa première législature. Malgré cela, il a réussi à se faire placer en première positionde la liste électorale du PS dans le canton de Zurich.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '22.08.1976',
    'Beruf de': 'Hausarzt',
    'Beruf fr': 'Médecin de famille'
  },
  {
    Elected: 'Ja',
    Sitznummer: '92',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'ZH',
    Nachname: 'Bäumle',
    Vorname: 'Martin',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2003',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Bäumle ist der Präsident der Grünliberalen und deren bedeutendster Kopf. Nach seiner Wahl in den Nationalrat war er ein wichtiger Mann einer Partei-Revolution: Er verliess die Grüne Partei und gründete die GLP mit.',
    'Text de':
      'Seit seinem Rücktritt als Parteipräsident im Sommer 2017 ist es spürbar ruhiger worden um den Mitbegründer der Grünliberalen. Bäumle spielt in der Fraktion aber weiterhin eine wichtige Rolle und tritt seine fünfte Legislatur an.',
    'BAT DE': 'fre',
    'Text fr':
      "Depuis sa démission de la présidence du parti à l'été 2017, le cofondateur des Verts libéraux est devenu nettement plus calme. Mais Martin Bäumle continue de jouer un rôle important au sein du groupe parlementaire et entame sa cinquième législature. Déjà.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Dübendorf',
    'Wohnort fr': 'Dübendorf',
    Geburtsdatum: '03.06.1964',
    'Beruf de': 'Atmosphärenwissenschaftler',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '93',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'ZH',
    Nachname: 'Seiler Graf',
    Vorname: 'Priska',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Die Stadträtin von Kloten wurde einer nationalen Öffentlichkeit als Protagonistin einer grossen «Magazin»-Geschichte bekannt.',
    'Text de':
      'Seiler Graf prägt die Sicherheitspolitik der SP mit. Ihr Nachteil ist, dass das Thema in der Partei an Bedeutung verloren hat und sich nur wegen der Kampfjetbeschaffung in einem Zwischenhoch befindet. Zudem hat sich Seiler Graf noch nicht jenes Renommee erarbeitet, das frühere SP-Sicherheitspolitikerinnen wie Chantal Galladé oder Barbara Haering fraktionsübergreifend besassen.',
    'BAT DE': 'fre',
    'Text fr':
      "Priska Seiler Graf a une grande influence sur la politique de sécurité au sein du PS. Inconvénient: la question a perdu de l'importance au sein du parti et n'a regagné qu'une attention très passagère en raison de l'achat à venir des nouveaux avions de combat. En outre, Priska Seiler Graf n'a pas encore acquis la réputation dont jouissaient d'anciennes politiciennes de la sécurité du parti socialiste, comme Chantal Galladé ou Barbara Haering.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Kloten',
    'Wohnort fr': 'Kloten',
    Geburtsdatum: '29.08.1968',
    'Beruf de': 'Stadträtin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '94',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'BE',
    Nachname: 'Mettler',
    Vorname: 'Melanie',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Melanie Mettler hat sich zu einer prägenden Figur im Berner Stadtparlament entwickelt. Sie leitet dort die grünliberale Fraktion. ',
    'BAT DE': 'Gelb',
    'Text fr':
      'Melanie Mettler est devenue une personnalité influente au Conseil général de la ville de Berne, où elle conduit le groupe parlementaire vert’libéral.',
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Bern',
    Geburtsdatum: '03.12.1977',
    'Beruf de': 'Geschäftsführerin Compasso',
    'Beruf fr': 'Directrice de Compasso'
  },
  {
    Elected: 'Ja',
    Sitznummer: '95',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'SG',
    Nachname: 'Friedl',
    Vorname: 'Claudia',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2013',
    'DabeiSeit fr': 'Au Conseil national depuis 2013',
    'Alte Texte DE':
      'Die gebürtige Österreicherin rückte im März 2013 für die zurückgetretene Hildegard Fässler in den Nationalrat nach. In ihrer zweijährigen Amtszeit ist sie vor allem durch ihre Unauffälligkeit aufgefallen. Als promovierte Umweltnaturwissenschaftlerin liegt ihr die Umweltpolitik am Herzen. Sie ist Mitglied der aussenpolitischen Kommission.',
    'Text de':
      'Die gebürtige Österreicherin gehört zu den eher unauffälligen Nationalrätinnen. Als promovierter Umweltnaturwissenschaftlerin liegt ihr vor allem die Umweltpolitik am Herzen. Im Nationalrat gehört sie allerdings der Aussenpolitischen Kommission an.',
    'BAT DE': 'fre',
    'Text fr':
      "Née en Autriche, elle possède un doctorat en science de l'environnement. Elle s'intéresse du coup particulièrement à la politique environnementale. Siégeant dans la commission de politique extérieure, elle est une des membres les plus discrètes du Conseil national. ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'St.Gallen',
    'Wohnort fr': 'Saint-Gall',
    Geburtsdatum: '19.07.1960',
    'Beruf de': 'Umwelt- naturwissenschaftlerin, Dr.sc.nat.ETH, vpod',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '96',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'NE',
    Nachname: 'Cottier',
    Vorname: 'Damien',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der 38jährige Anwalt Christian Dandrès engagiert sich bei der Mieterinnen- und Mietervereinigung Asloca. Als Mitglied des Ausschusses von Asloca Schweiz hat er damit dasselbe Profil, wie der ehemalige Nationalrat und Neo-Ständerat Carlo Sommaruga. Seit seitzt seit drei Legislaturen im Genfer Kantonsrat. Dort engagierte er sich in der kantonalen Bau- und Immobilienpolitik, gilt aber auch als Spezialist für die Reform der Pensionskasse der Genfer Kantonsangestellten',
    'BAT DE': 'Gelb',
    'Text fr':
      "Figure du PLR neuchâtelois il y a dix ans, cet homme de 44 ans s’est fait oublier de la politique cantonale en devenant conseiller personnel de Didier Burkhalter. Il fait donc un retour en force dans la Berne fédéral. Son coming out lors de la Saint-Valentin, alors qu'il était candidat à la candidature, avait fait les gros titres dans la presse.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Hauterive',
    'Wohnort fr': 'Hauterive',
    Geburtsdatum: '03.04.1975',
    'Beruf de': '',
    'Beruf fr': "Conseiller d'Ambassade (DFAE)"
  },
  {
    Elected: 'Ja',
    Sitznummer: '97',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'FR',
    Nachname: 'Schneider Schüttel',
    Vorname: 'Ursula',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Nationalrätin von 2012 bis 2015, und seit 2019',
    'DabeiSeit fr': 'Au Conseil national entre 2012-2015 et depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Nachdem Ursula Schneider Schüttel 2012 und 2017 in den Nationalrat nachgerückt war, schaffte sie schliesslich die direkte Wahl als zweite SP-Vertreterin des Kantons Freiburg. Sie machte das Rennen mit 3000 Stimmen vor Grossrat Pierre Mauron. Die Anwältin ist seit 2018 Präsidentin des Vereins Pro Natura. In den 90er Jahren arbeitete sie als Juristin im Generalsekretariat des Eidgenössischen Departements für Umwelt, Verkehr, Energie und Kommunikation. Zuerst unter SVP Bundesrat Adolf Ogi, dann unter dem SPler Moritz Leuenberger.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Après avoir accédé au Conseil national comme vient-ensuite en 2012 et 2017 (elle n'avait pas été réélue en 2015), Ursula Schneider Schüttel y est finalement entrée par la grande porte, comme deuxième meilleure élue socialiste dans le canton de Fribourg, avec 3000 voix d'avance sur le suivant, le président du groupe au Grand Conseil Pierre Mauron. L’avocate préside l’association Pro Natura depuis 2018. Plus jeune, elle a travaillé comme juriste au Secrétariat général du Département fédéral de l’environnement, des transports, de l’énergie et de la communication, d’abord sous l’UDC Adolf Ogi, puis sous le socialiste Moritz Leuenberger.",
    'BAT FR': '',
    'Wohnort de': 'Murten',
    'Wohnort fr': 'Morat',
    Geburtsdatum: '26.11.1961',
    'Beruf de': 'Nationalrätin, Anwältin',
    'Beruf fr': 'Conseillère nationale, avocate\n'
  },
  {
    Elected: 'Ja',
    Sitznummer: '98',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'TI',
    Nachname: 'Farinelli',
    Vorname: 'Alex',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Alex Farinelli ist Liberaler Fraktionschef im Tessiner Grossen Rat. Grosse Beachtung fand sein Untersuchungsbericht zur Direktvergabe von Aufträgen im Asylwesen, bei dem ein Regierungsmitglied im Zentraum der Ermittlungen stand.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Alex Farinelli préside le groupe PLR au Grand Conseil tessinois. Il a suscité beaucoup d’attention avec son rapport sur l'attribution directe de contrats d'asile, dans lequel un membre du gouvernement était au centre de l'enquête. ",
    'BAT FR': 'pas relu',
    'Wohnort de': 'Comano',
    'Wohnort fr': 'Comano',
    Geburtsdatum: '16.12.1981',
    'Beruf de': 'Vicedirettore SSIC TI',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '99',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'GE',
    Nachname: 'Dandrès',
    Vorname: 'Christian',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der 38jährige Anwalt Christian Dandrès engagiert sich bei der Mieterinnen- und Mietervereinigung Asloca. Er hat damit ein ähnliches Profil wie der ehemalige Nationalrat und Neo-Ständerat Carlo Sommaruga aus. Seit nunmehr drei Legislaturen sitzt er Genfer Kantonsrat. Dort engagierte er sich in der kantonalen Bau- und Immobilienpolitik. Er gilt aber auch als Spezialist für die Reform der Pensionskasse der Genfer Kantonsangestellten',
    'BAT DE': 'Gelb',
    'Text fr':
      "Avocat à l'Asloca, Christian Dandrès a effectué trois législatures au parlement cantonal. Membre du comité de l'Asloca Suisse, il a le même profil que l'ex conseiller national Carlo Sommaruga. Au cours de ces mandats, le député s'est illustré dans plusieurs dossiers, ceux liés au logements, mais aussi la réforme de la Caisse de pension des fonctionnaires.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Chêne-Bougeries',
    'Wohnort fr': 'Chêne-Bougeries',
    Geburtsdatum: '13.02.1981',
    'Beruf de': '',
    'Beruf fr': "Juriste à l'ASLOCA, avocat"
  },
  {
    Elected: 'Ja',
    Sitznummer: '100',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'AG',
    Nachname: 'Riniker',
    Vorname: 'Maja',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Maja Riniker ist seit zehn Jahren Co-Präsidentin der Aarauer FDP-Frauen. Sie hat in den USA studiert und arbeitete in verschiedenen Banken und als Projektleiterin im Unternehmensstab der Psychiatrischen Dienste des Kantons Aargau. Sie ist Betriebsökonomin und sitzt um Verwaltungsrat der Clientis Bank Aareland AG.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Maja Riniker est coprésidente des femmes PLR du canton d'Argovie depuis dix ans, elle a étudié aux Etats-Unis, travaillé dans des banques et comme chef de projet pour la direction des services psychiatriques du canton d'Argovie. Elle est économiste d'entreprise et siège au conseil d'administration la Clientis Bank Aareland.",
    'BAT FR': '',
    'Wohnort de': 'Suhr',
    'Wohnort fr': 'Suhr',
    Geburtsdatum: '23.05.1978',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '101',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'ZH',
    Nachname: 'Widmer',
    Vorname: 'Céline',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Politologin arbeitet im Stab der Zürcher Stadtpräsidentin Corine Mauch und ist dort insbesondere für das Projekt Nexpo zuständig, eine angedachte Expo der Städte. Seit 2012 sitzt sie im Zürcher Kantonsrat, in dem sie 2019 das Präsidium der Finanzkommission übernommen hat.',
    'BAT DE': 'Gelb',
    'Text fr':
      "La politologue fait partie de l'état-major de Corine Mauch, la présidente de la ville de Zurich, où elle est notamment responsable du projet Nexpo, une initiative lancée par les dix plus grandes villes de Suisse pour réaliser le projet d’une Exposition nationale d’un genre nouveau. Depuis 2012, elle est membre du Grand-conseil zurichois, où elle a pris la présidence de la Commission des finances en 2019.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '26.05.1978',
    'Beruf de': 'Projektleiterin Präsidialdepartement Stadt',
    'Beruf fr': 'Cheffe de projets pour la présidence de la Ville de Zurich'
  },
  {
    Elected: 'Ja',
    Sitznummer: '102',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'VD',
    Nachname: 'De Quattro',
    Vorname: 'Jacqueline',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Sie ist Anwältin, Schweiz-Italienerin und spricht perfekt Deutsch und Französisch. Jacqueline de Quattro hat alle Voraussetzungen, um im Bundeshaus zu einer wichtigen Figur zu werden. Als Waadtländer Regierungsrätin, verantwortlich für Umwelt und Raumplanung, musste sie viel Kritik einstecken. Die Freisinnige zeigte sich als Kämpferin für die Energiewende und setzte einiges in Bewegung, von dem der Kanton profitieren wird. Auch mit ihrem Engagement für die Frauen stach sie in der Waadt heraus.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Avocate de profession, Jacqueline de Quattro siège au Conseil d'État vaudois depuis 2007. A la tête du Département du Territoire et de l'Environnement depuis cinq ans, elle a eu la délicate tâche de gérer la mise en oeuvre de la LAT dans un canton en pleine croissance démographique. L'Italo-Suissesse a présidé les Femmes radicales entre 2008 et 2010. ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'La Tour-de-Peilz',
    'Wohnort fr': 'La Tour-de-Peilz',
    Geburtsdatum: '24.06.1960',
    'Beruf de': '',
    'Beruf fr': "Conseillère d'Etat"
  },
  {
    Elected: 'Ja',
    Sitznummer: '103',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'ZH',
    Nachname: 'Marti',
    Vorname: 'Min Li',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Marti ist Präsidentin der SP-Fraktion im Zürcher Stadtparlament. Sie ist Verlegerin und Chefredaktorin der linken Zürcher Zeitschrift «P.S.» und die Frau von Balthasar Glättli, dem Fraktionschef der Grünen.',
    'Text de':
      'Während Marti zu den prägenden Figuren der Zürcher SP gehört, ist sie in ihrer ersten Legislatur in Bern noch nicht zur Wortführerin geworden. Doch die Themenkonjunktur spielt für die engagierte Gleichstellungspolitikerin. Marti arbeitet als Verlegerin und ist Mitglied der Rechtskommission.',
    'BAT DE': 'fre',
    'Text fr':
      "Si Min Li Marti est l'une des figures marquantes du PS zurichois, elle ne s'est pas encore franchement affirmée lors de sa première législature à Berne. Mais une bonne conjoncture de sujets pour la politicienne très engagée dans le domaine de l'égalité des chances. Au civil, Min Li Marti oeuvre comme éditrice.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '01.06.1974',
    'Beruf de': 'Verlegerin',
    'Beruf fr': 'Éditrice'
  },
  {
    Elected: 'Ja',
    Sitznummer: '104',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'ZH',
    Nachname: 'Silberschmidt',
    Vorname: 'Andri',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Noch bis Ende 2019 amtiert Andri Silberschmidt als Präsident der Jungfreisinnigen Schweiz. Der gebürtige Zürcher Oberländer gilt als junger Überflieger im Zürcher Freisinn. 2018 wurde der Banker und Gastrounternehmer ins Zürcher Stadtparlament gewählt.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Jusqu'à fin 2019, Andri Silberschmidt assure encore la présidence des Jeunes PLR suisses. Il est considéré comme l'un des libéraux-radicaux zurichois les plus prometteurs. En 2018, celui qui est à la fois banquier et entrepreneur dans la restauration, a été élu au Parlement de la ville de Zurich.",
    'BAT FR': '',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zürich',
    Geburtsdatum: '26.02.1994',
    'Beruf de': 'Bankangestellter, Verwaltungsratspräsident',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '105',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'ZH',
    Nachname: 'Molina',
    Vorname: 'Fabian',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2018',
    'DabeiSeit fr': 'Au Conseil national depuis 2018',
    'Alte Texte DE': '',
    'Text de':
      '2018 rückte Fabian Molina für den zurückgetretenen Tim Guldimann im Nationalrat nach. Der Vollblutpolitiker ist Co-Präsident einer Entwicklungsorganisation. Er war Parlamentarier in seiner Heimatgemeinde Illnau-Effretikon, kurz Kantonsrat und drei Jahre lang Präsident der Juso Schweiz.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Fabian Molina est entré au Conseil national en 2018 en succédant au démissionnaire Tim Guldimann. La politique dans le sang, il est co-président d'une organisation de développement. Il a été parlementaire dans sa ville natale d'Illnau-Effretikon, a brièvement été membre du Grand-Conseil et, durant trois ans, président des jeunes socialistes.",
    'BAT FR': '',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '08.07.1990',
    'Beruf de': 'Co-Präsident Entwicklungsorganisation',
    'Beruf fr': "Co-président d'une organisation d'entraide"
  },
  {
    Elected: 'Ja',
    Sitznummer: '106',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'GE',
    Nachname: 'de Montmollin',
    Vorname: 'Simone',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Simone de Montmollin hat einen speziellen Beruf. Sie ist Ingenieurin für Weinbau und Önologie und Präsidentin des Schweizerischen Önologenverbandes. In dieser Funktion organisierte sie im Sommer 2019 den Weltkongress für Wein in Aigle. Wichtige politische Erfahrungen sammelte sie mit ihrer Wahl im Jahr 2008 in die verfassungsgebende Versammlung des Kantons Genf. 2013 wurde sie schliesslich ins kantonale Parlament gewählt.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Ingénieure spécialisée en viticulture et oenologie, présidente de l'Union suisse des oenologues, Simone de Montmollin a fait parler d'elle cet été en organisant le Congrès mondial de la vigne et du vin. Elle est entrée en politique en 2008 par une élection à l'assemblée constituante, puis a été portée au parlement cantonal en 2013.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Genf',
    'Wohnort fr': 'Genève',
    Geburtsdatum: '20.07.1968',
    'Beruf de': '',
    'Beruf fr': 'Ingénieure en viticulture et oenologie'
  },
  {
    Elected: 'Ja',
    Sitznummer: '107',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BL',
    Nachname: 'Nussbaumer',
    Vorname: 'Eric',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Gemeinsam mit Roger Nordmann gehört Nussbaumer zu den führenden Energiepolitikern in der SP-Fraktion. Mitglied der Kommission für Umwelt, Raumplanung und Energie und der aussenpolitischen Fraktion.',
    'Text de':
      'Eric Nussbaumer ist zusammen mit Roger Nordmann der führende Energiepolitiker seiner Partei. Aber auch als Aussenpolitiker hat er sich einen Namen gemacht, vor allem als Befürworter des Rahmenabkommens mit der EU, dies nicht zur Freude der SP. ',
    'BAT DE': 'fre',
    'Text fr':
      "Aux côtés du Vaudois Roger Nordmann, Eric Nussbaumer est le spécialiste de son parti des questions de politique énergétique. Le Bâlois est aussi un promoteur du regroupement des services communaux. Mais il s'est également fait un nom en politique extérieure, en particulier en tant que partisan de l'accord-cadre avec l'UE, au grand dam de son parti.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Liestal',
    'Wohnort fr': 'Liestal',
    Geburtsdatum: '11.07.1960',
    'Beruf de': 'dipl. Elektroingenieur HTL',
    'Beruf fr': 'Ingénieur électricien'
  },
  {
    Elected: 'Ja',
    Sitznummer: '108',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'SG',
    Nachname: 'Vincenz-Stauffacher',
    Vorname: 'Susanne',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Susanne Vincenz-Stauffacher scheiterte Anfang Jahr bei der Ersatzwahl von Karin Keller-Sutter. Sie unterlag dem St. Galler Regierungsrat Benedikt Würth. Die langjährige Präsidentin der St. Galler Frauenzentrale ist Anwältin und Kantonsrätin.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Susanne Vincenz-Stauffacher a échoué à l'élection de remplacement de Karin Keller-Sutter au début de l'année, où elle avsait été battue par le conseiller d’Etat Benedikt Würth. La présidente de longue date du Centre de liaison des associations féminines de Saint-Gall est avocate et membre du Grand Conseil.",
    'BAT FR': 'pas relu',
    'Wohnort de': 'Abtwil',
    'Wohnort fr': 'Abtwil',
    Geburtsdatum: '21.01.1967',
    'Beruf de':
      'lic.iur.HSG, selbstständige Rechtsanwältin, Kantonsrätin, Präsidentin Stiftung Opferhilfe, Ombudsfrau Alter und Behinderung',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '109',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'EVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'BE',
    Nachname: 'Streiff-Feller',
    Vorname: 'Marianne',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2010',
    'DabeiSeit fr': 'Au Conseil national depuis 2010',
    'Alte Texte DE':
      'Streiff-Feller ist Präsidentin der EVP Schweiz. National einen Namen gemacht hat sie sich beim - vergeblichen - Kampf ihrer Partei gegen den Ausbau der Präimplantationsdiagnostik.',
    'Text de':
      'Die Werte Familie und Christentum prägen die Politik der Präsidentin der EVP Schweiz. Die Mittepolitikerin steht umwelt-, wirtschafts- und sozialpolitisch eher links, gesellschaftspolitisch ist sie konservativ. ',
    'BAT DE': 'daf',
    'Text fr':
      "Membre du groupe parlementaire PDC sous la Coupole, la présidente du Parti évangélique suisse mène une politique centriste imprégnée des valeurs chrétiennes. Elle se situe plutôt à gauche en matière d'environnement, d'économie et de politique sociale. Elle se montre  conservatrice sur les questions sociétales.",
    'BAT FR': 'Relu et réécrit par,  Lise.',
    'Wohnort de': 'Urtenen-Schönbühl',
    'Wohnort fr': 'Urtenen-Schönbühl',
    Geburtsdatum: '17.08.1957',
    'Beruf de': 'Politikerin',
    'Beruf fr': 'Politicienne'
  },
  {
    Elected: 'Ja',
    Sitznummer: '110',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Heer',
    Vorname: 'Alfred',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Heer ist Präsident der Zürcher SVP. Im Nationalrat ist er Mitglied der Geschäftsprüfungskommission und Vize-Präsident der Delegation beim Europarat.',
    'Text de':
      'Der Kleinunternehmer Heer ist Präsident des Bundes der Steuerzahler. Im Nationalrat ist er Mitglied der Geschäftsprüfungskommission und -delegation sowie Präsident der Schweizer Delegation im Europarat.',
    'BAT DE': 'fre',
    'Text fr':
      'Le petit entrepreneur Alfred Heer est président du "Bund der Steuerzahler", la "Fédération des contribuables", qui n\'a pratiquement aucune activité en Suisse romande. Ses ambitions – le Zurichois a voulu devenir chef du groupe UDC en 2017, puis se présenter aux Etats en 2019 contre le rédacteur en chef de la Weltwoche Roger Köppel – ont rapidement été tuées dans l\'oeuf par les siens.',
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zurich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '12.10.1961',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '111',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'EVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'ZH',
    Nachname: 'Gugger',
    Vorname: 'Niklaus',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2017',
    'DabeiSeit fr': 'Au Conseil national depuis 2017',
    'Alte Texte DE': '',
    'Text de':
      'Nachdem Nik Gugger 15 Jahre im Winterthurer und im kantonalen Parlament politisiert hatte, rückte er 2017 für Maja Ingold in den Nationalrat nach. Der Unternehmer gilt als Brückenbauer mit internationalem Flair.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Après une carrière politique de 15 ans à Winterthour et au parlement cantonal, Nik Gugger a rejoint le Conseil national pour remplacer Maja Ingold en 2017. L'entrepreneur social est considéré comme un bâtisseur de ponts avec des contacts à l'international.",
    'BAT FR': '',
    'Wohnort de': 'Winterthur',
    'Wohnort fr': 'Winterthur',
    Geburtsdatum: '01.05.1970',
    'Beruf de': 'Nationalrat',
    'Beruf fr': 'Conseil National'
  },
  {
    Elected: 'Ja',
    Sitznummer: '112',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Walliser',
    Vorname: 'Bruno',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der Kantonsrat und Gemeindepräsident von Volketswil setzt seine politischen Schwerpunkte bei den Themen Sicherheit, Ausländer und Wirtschaft. Der Kaminfegermeister ist unter anderem im Verwaltungsrat der Bank BSU Uster.',
    'Text de':
      'Bruno Walliser zählt zu den unscheinbaren Mitgliedern der SVP-Delegation - fraktionsintern wie gegen aussen. Der Ex-Gemeindepräsident von Volketswil macht sich vor allem für Zürcher Anliegen wie die Oberlandautobahn oder den Flughafen stark. Ansonsten tritt er kaum in Erscheinung.',
    'BAT DE': 'fre',
    'Text fr':
      "Bruno Walliser est l'un des membres discrets de la délégation de l'UDC, tant à l'intérieur qu'à l'extérieur du groupe parlementaire. L'ancien président de la commune de Volketswil est particulièrement engagé dans les questions cantonales zurichoises telles que l'autoroute qui doit relier enfin l'Oberland zurichois ou l'aéroport. A part cela, on le remarque à peine.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Volketswil',
    'Wohnort fr': 'Volketswil',
    Geburtsdatum: '11.04.1966',
    'Beruf de': 'eidg. dipl. Kaminfegermeister',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '113',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'EVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'AG',
    Nachname: 'Studer',
    Vorname: 'Lilian',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Seit 2002 politisiert Lilian Studer im Aargauer Grossen Rat. Ihr Vater war für die EVP im Nationalrat. Lilian Studer engagiert sich für die Freiwilligenarbeit und den Gesundheitsbereich.\n',
    'BAT DE': 'Gelb',
    'Text fr':
      'Depuis 2002, Lilian Studer fait de la politique au Grand Conseil.  Son père était également membre du Conseil national sous la bannière évangélique. Lilian Studer est engagée dans le bénévolat et le secteur de la santé.',
    'BAT FR': '',
    'Wohnort de': 'Wettingen',
    'Wohnort fr': 'Wettingen',
    Geburtsdatum: '20.12.1977',
    'Beruf de': 'Lehrerin',
    'Beruf fr': 'Einseignante'
  },
  {
    Elected: 'Ja',
    Sitznummer: '114',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Schläpfer',
    Vorname: 'Therese',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Therese Schläpfer rückte im Juni 2019 für den zurückgetretenen Jürg Stahl in den Nationalrat nach. Sie konzentriert sich vor allem auf die Asylpolitik. Landesweit bekannt wurde Schläpfer durch den «Fall Hagenbuch». Sie kritisierte, dass eine eritreische Familie wegen hoher Sozialkosten die Gemeindefinanzen aus dem Lot bringe.',
    'BAT DE': 'fre',
    'Text fr':
      "Therese Schläpfer n'est entrée au Conseil national que le 3 juin 2019. Elle y a remplacé le démissionnaire Jürg Stahl. La Zurichoise s'est surtout fait un nom jusqu'ici outre-Sarine dans \"l'affaire Hagenbuch\". Elle critiquait une famille érythréenne à l'aide sociale, domiciliée dans sa commune, qui à ses yeux mettait en péril les finances de la localité.",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Hagenbuch',
    'Wohnort fr': 'Hagenbuch',
    Geburtsdatum: '14.04.1959',
    'Beruf de': 'Gemeindepräsidentin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '115',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'UR',
    Nachname: 'Stadler',
    Vorname: 'Simon',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Simon Stadler ist der Sohn des ehemaligen Urner Landammanns und Alt-Ständerats Hansruedi Stadler. Der 31-jährige präsidiert im Urner Landrat die Spitalkomission.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Simon Stadler est le fils de l'ancien Conseiller d’Etat et sénateur PDC Hansruedi Stadler. Comme son père, Simon Stalder s'est opposé à la construction d'un deuxième tube au Gothard. Son implication dans les questions de santé et d'éducation a également été remarqué.",
    'BAT FR': '',
    'Wohnort de': 'Altdorf',
    'Wohnort fr': 'Altdorf',
    Geburtsdatum: '02.05.1988',
    'Beruf de': 'Maurer und Primarlehrer',
    'Beruf fr': 'Maçon et enseignant'
  },
  {
    Elected: 'Ja',
    Sitznummer: '116',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'TI',
    Nachname: 'Marchesi',
    Vorname: 'Piero',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Piero Marchesi ist Präsident der kleinen Grenzstadt Monteggio und Präsident der Tessiner SVP. Sein Hauptthema ist die Konkurrenz im Kanton duch die zahlreichen Grenzgänger. Als talentierter Redner beherrscht er die Codes von Instagram und Facebook wie nur wenige andere Politiker im Tessin.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Le syndic de la petite commune frontalière de Monteggio et président de l'UDC tessinoise Piero Marchesi a fait de la lutte contre la concurrence déloyale des frontaliers son thème favori. Orateur de talent, il maîtrise les codes d'Instagram et de Facebook comme peu d'autres politiciens au Tessin",
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '117',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'LU',
    Nachname: 'Wismer-Felder',
    Vorname: 'Priska',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Bäuerin, Lehrerin, Mutter von fünf Töchter, Chorleiterin und Vizepräsidentin vom Verein "Fair – für einen fairen Milchpreis": Priska Wismer-Felder ist nebst alle dem auch noch eine Vollblutpolitikerin. 26 Hektare gross ist der Hof der Sie zusammen mit Ihrem Mann führt. Sie setzt sich seit Jahren für Windenergie ein.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Agricultrice, enseignante, mère de cinq filles, directrice de chorale et vice-présidente d'une association pour un prix du lait équitable: Priska Wismer-Felder est également une politicienne accomplie. La ferme, qu'elle dirige avec son mari, couvre une superficie de 26 hectares. Elle est engagée dans l'énergie éolienne depuis des années.",
    'BAT FR': '',
    'Wohnort de': 'Rickenbach',
    'Wohnort fr': 'Rickenbach',
    Geburtsdatum: '02.10.1970',
    'Beruf de': 'Bäuerin, Familienfrau, Lehrerin',
    'Beruf fr': 'Agricultrice, femme au foyer, enseignante'
  },
  {
    Elected: 'Ja',
    Sitznummer: '118',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'NW',
    Nachname: 'Keller',
    Vorname: 'Peter',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Keller ist Historiker und redaktioneller Mitarbeiter der «Weltwoche». Er ist der frühere Redenschreiber von Christoph Blocher.',
    'Text de':
      'Keller ist Historiker, redaktioneller Mitarbeiter der «Weltwoche» und Programmchef der SVP. Er ist der frühere Redenschreiber von Christoph Blocher und der erste SVP-Politiker, der Nidwalden im Nationalrat vertritt.',
    'BAT DE': 'fre',
    'Text fr':
      'Peter Keller est historien, rédacteur à la "Weltwoche" et responsable du programme politique de l\'UDC. Auparavant, il rédigeait les discours de Christoph Blocher. Peter Keller est le premier UDC à représenter le demi-canton de Nidwald au Conseil national.',
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Hergiswil',
    'Wohnort fr': 'Hergiswil',
    Geburtsdatum: '22.04.1971',
    'Beruf de': 'Autor, Journalist',
    'Beruf fr': 'Auteur, journaliste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '119',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'BDP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'BE',
    Nachname: 'Siegenthaler',
    Vorname: 'Heinz',
    Bisher: 'Schon früher',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat von 2014 bis 2015 und seit 2017',
    'DabeiSeit fr': 'Au Conseil national de 2014 à 2015 et depuis 2017',
    'Alte Texte DE': '',
    'Text de':
      'Heinz Siegenthaler hat selber Hanf legal angepflanzt, und setzt sich für eine Hanf-Liberalisierung ein. Für ihn ist Hanf auch ein wertvoller Rohstoff für Medizin- und Industrieprodukte.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Heinz Siegenthaler lui-même a planté légalement du chanvre et préconise une libéralisation du cannabis. Pour lui, le chanvre est une drogue, mais la plante est aussi une matière première précieuse pour les produits médicaux et industriels.',
    'BAT FR': '',
    'Wohnort de': 'Rüti bei Büren',
    'Wohnort fr': 'Rüti bei Büren',
    Geburtsdatum: '11.10.1955',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '120',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'GE',
    Nachname: 'Nidegger',
    Vorname: 'Yves',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Der konservative Anwalt vertritt die SVP in der Rechtskommission. Er gehört dem Initiativkomitee für ein Burkaverbot in der Schweiz an.',
    'Text de':
      'Yves Nidegger nimmt selten ein Blatt vor den Mund - besonders dann nicht, wenn es um Asyl- und Ausländerfragen geht. Der Genfer gehört zu den erfahrenen Bundesparlamentariern. Eein Regierungsamt in Genf blieb ihm trotz mehreren Anläufen verwehrt.',
    'BAT DE': 'daf',
    'Text fr':
      "En tant qu’avocat, Yves Nidegger n'a peur de rien et comme politicien, il ose aussi dire ce qu'il pense. Son franc-parler est souvent un peu trop direct pour beaucoup de gens et il ne mâche pas ses mots, surtout quand il s'agit de questions en matière d'asile et d'étrangers. Il est l'un des parlementaires fédéraux les plus expérimentés. Malgré plusieurs tentatives, il n’occupe toujours pas une fonction gouvernementale à Genève.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Genève',
    'Wohnort fr': 'Genève',
    Geburtsdatum: '17.05.1957',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '121',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'BDP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'BE',
    Nachname: 'Hess',
    Vorname: 'Lorenz',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der PR-Berater und Vizepräsident der BDP ist Mitglied der Kommission für soziale Sicherheit und Gesundheit und Gemeindepräsident von Stettlen.',
    'Text de':
      'Lorenz Hess ist PR-Berater und Verwaltungsrats­präsident der Krankenkasse Visana. Zugleich politisiert er in der nationalrätlichen Gesundheitskommission, was immer wieder für Kritik sorgt.',
    'BAT DE': 'fre',
    'Text fr':
      'Avec sa casquette de conseiller en communication, sa présidence de Visana Services et du groupe d\'intérêts "Boissons rafraîchissantes", Lorenz Hess passe pour un représentant de l\'économie à Berne. Le Bernois siège notamment dans la Commission de la santé et de la sécurité sociale.',
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Stettlen',
    'Wohnort fr': 'Stettlen',
    Geburtsdatum: '28.06.1961',
    'Beruf de': 'eidg. dipl. PR-Berater',
    'Beruf fr': 'Conseiller en communication'
  },
  {
    Elected: 'Ja',
    Sitznummer: '122',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'VS',
    Nachname: 'Addor',
    Vorname: 'Jean-Luc',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der Walliser Grossrat ist in der restlichen Schweiz als Urheber eines polemischen Tweets bekannt geworden, der eine Klage des Islamischen Zentralrats zur Folge hatte.',
    'Text de':
      'Der Walliser macht regelmässig als Rechtsaussen-Nationalrat von sich reden. In dieser Legislatur kämpfte der Interimspräsident von Pro Tell vor allem gegen ein schärferes Waffenrecht. Er findet, bewaffnete Bürger trügen zur Sicherheit bei, weil sie etwa im Falle eines Terroranschlags sofort eingreifen könnten. ',
    'BAT DE': 'fre',
    'Text fr':
      "Jean-Luc Addor est pleinement aligné avec son parti sur les questions de souveraineté ou d'identité nationale. Farouchement opposé à tout ce qui conduirait à un rapprochement avec l'UE, il est également très engagé sur les questions sécuritaires et sa casquette de président de Pro Tell n'y est pas étrangère. Placé sur une liste sans réelle concurrence, il devrait continuer de s'imposer comme le successeur d'Oskar Freysinger.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Savièse',
    'Wohnort fr': 'Savièse',
    Geburtsdatum: '22.04.1964',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '123',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'BDP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'GL',
    Nachname: 'Landolt',
    Vorname: 'Martin',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2009',
    'DabeiSeit fr': 'Au Conseil national depuis 2009',
    'Alte Texte DE':
      'Seit 2012 präsidiert Landolt die BDP Schweiz. Kurz darauf gab er sein Mandat als Berater der UBS ab, das ihm wieder den Vorwurf eingebracht hatte, im Auftrag der Grossbank unterwegs zu sein. Landolt ist Mitglied der Staatspolitischen Kommission und der Verkehrskommission.',
    'Text de':
      'Der 51-Jährige ist seit 2009 Nationalrat, seit 2012 präsidiert er die BDP Schweiz. Der frühere Bankangestellte ist Mitglied der Kommission für Wirtschaft und Abgaben.',
    'BAT DE': 'fre',
    'Text fr':
      "Il est membre du Conseil national depuis 2009 et préside le PBD Suisse depuis 2012. L'ancien employé de banque est membre de la Commissions de l'économie et des redevances (la fameuse WAK, en allemand). Il est père de trois filles et vit à Näfels, dans le canton de Glaris.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Näfels',
    'Wohnort fr': 'Näfels',
    Geburtsdatum: '30.06.1968',
    'Beruf de': 'Kommunikations- und Strategieberater',
    'Beruf fr': 'Conseiller en communication et en stratégie'
  },
  {
    Elected: 'Ja',
    Sitznummer: '124',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Steinemann',
    Vorname: 'Barbara',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Die Juristin wurde 2003 in den Zürcher Kantonsrat gewählt. Sie gilt als Urheberin des Minarettverbots; ein solches hatte sie 2006 erfolglos verlangt. Sorgte für Aufregung mit ihrer Forderung, in Statistiken zwischen eingebürgerten und gebürtigen Schweizern zu unterscheiden.',
    'Text de':
      'Steinemann beackert mit der Ausländer- und Sozialhilfepolitik klassische SVP-Themen. Das sichert ihr zwar regelmässige Medienauftritte, ihr Einfluss innerhalb der Fraktion ist indes gering. Obenaus schwingt sie dafür mit der Anzahl eingereichter Vorstösse.',
    'BAT DE': 'fre',
    'Text fr':
      "La juriste de Rümlang est active principalement sur les thèmes classiques de l'UDC: lutte contre l'immigration et critiques concernant l'aide sociale. Si elle apparaît régulièrement pour cela dans les médias, son influence au sein de son groupe parlementaire reste faible.  ",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Regensdorf',
    'Wohnort fr': 'Regensdorf',
    Geburtsdatum: '18.06.1976',
    'Beruf de': 'lic. iur. LL.M.',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '125',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'GLP',
    'Fraktion de': 'Grünliberale Fraktion',
    'Fraktion fr': 'Groupe Vert’libéral',
    Kanton: 'SG',
    Nachname: 'Brunner',
    Vorname: 'Thomas',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Thomas Brunner ist Klimatologe und sitzt im St.Galler Stadtparlament. Er erobert den St.Galler Nationalratssitz zurück, den die GLP 2015 verloren hatte.\n',
    'BAT DE': 'Gelb',
    'Text fr':
      "Thomas Brunner est climatologue et siège au parlement de la ville de Saint-Gall. Il a repris le siège du Conseil national de Saint-Gall, que les Vert'libéraux ont perdu en 2015.",
    'BAT FR': '',
    'Wohnort de': 'St. Gallen',
    'Wohnort fr': 'Saint-Gall',
    Geburtsdatum: '25.07.1960',
    'Beruf de': 'Klimatologe und Politiker',
    'Beruf fr': 'Climatologue et politicien'
  },
  {
    Elected: 'Ja',
    Sitznummer: '126',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Rutz',
    Vorname: 'Gregor A.',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2012',
    'DabeiSeit fr': 'Au Conseil national depuis 2012',
    'Alte Texte DE':
      'Der Jurist Rutz sitzt in der Staatspolitischen Kommission. Er ist einer der Treiber jener Initiative, die Schweizer Recht über das Völkerrecht stellen möchte.',
    'Text de':
      'Rutz sitzt in der Staatspolitischen Kommission und in der Verkehrskommission. Der Zürcher ist zusammen mit Hans-Ueli Vogt der Rechtsspezialist der SVP-Fraktion, und übt regelmässig scharfe Kritik an völkerrechtlichen Verpflichtungen der Schweiz.',
    'BAT DE': 'fre',
    'Text fr':
      "Ce juriste passe, avec Hans-Ueli Vogt, pour le spécialiste de droit du groupe parlementaire UDC. Il est en particulier très critique par rapport aux obligations internationales de la Suisse. De 2001 à 2008, il a été secrétaire général de l'UDC suisse, ce qui lui offre encore des relais avec la base partout en dans le pays et une solide expérience avec les médias.",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Zollikon',
    'Wohnort fr': 'Zollikon',
    Geburtsdatum: '12.10.1972',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '127',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'VD',
    Nachname: 'Maillard',
    Vorname: 'Pierre-Yves',
    Bisher: 'Schon früher',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat von 1999 bis 2004,\nund seit 2019',
    'DabeiSeit fr': 'Au Conseil national de 1999 à 2004, réélu en 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Waadtländer Regierung verliess der langjährige Gesundheitsdirektor durch die grosse Pforte. Pierre-Yves Maillard schaffte die Wahl zur Präsidenten des Schweizer Gewerkschaftsbundes nach hartem Wahlkampf letztlich klar. Machtpositionen wie diese gefallen ihm, auch wenn er als SGB-Präsident nun die Interessen vieler Verbände berücksichtigen muss. Das Mandat als Nationalrat bedeutet eine Rückkehr nach Bern, wo er als junger, scharfzüngiger Nationalrat den einen oder anderen Bürgerlichen vor den Kopf stiess. Als Regierungsrat pflegte er mit seinem FDP-Ratskollegen Pascal Broulis ein erfolgreiches Duo. Maillard bekam von der Wirtschaft Geld für den Ausbau des Sozialstaats. Maillard sorgte dafür, dass die Linke Steuererleichterungen zustimmte.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Déjà considéré comme poids lourd au Parlement fédéral lors de sa premier passage à Berne entre 1999 et 2004, le syndicaliste Pierre-Yves Maillard a depuis appris l’art de gouverner au Conseil d’Etat vaudois durant presque quinze ans. Avec sa nouvelle casquette de président de la puissante Union syndicale suisse, le vaudois a acquis encore davantage d’assise politique.',
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Renens',
    'Wohnort fr': 'Renens',
    Geburtsdatum: '16.03.1968',
    'Beruf de': '',
    'Beruf fr': "Président de l'USS"
  },
  {
    Elected: 'Ja',
    Sitznummer: '128',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'ZH',
    Nachname: 'Portmann',
    Vorname: 'Hans-Peter',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2014',
    'DabeiSeit fr': 'Au Conseil national depuis 2014',
    'Alte Texte DE':
      'Portmann ist Bankdirektor und Neo-Nationalrat. Er hat den Sitz im letzten Frühling von Filippo Leutenegger übernommen.',
    'Text de':
      'Portmann ist der aussenpolitische Wortführer der FDP-Fraktion. Als solcher setzt er sich mit Vehemenz für das Rahmenabkommen mit der EU ein - und vergreift sich bisweilen in der Kritik an den politischen Gegnern im Ton.',
    'BAT DE': 'fre',
    'Text fr':
      "Hans-Peter Portmann est le porte-parole du groupe parlementaire PLR en matière de politique étrangère. A ce poste, il s'engage avec force en faveur de l'accord-cadre avec l'UE. De profession, il est directeur à la banque liechtensteinoise LGT Bank (Schweiz) AG à Zurich, en charge du \"Private Banking\".",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Rüschlikon',
    'Wohnort fr': 'Rüschlikon',
    Geburtsdatum: '22.02.1963',
    'Beruf de': 'Bankkaufmann',
    'Beruf fr': 'Banquier'
  },
  {
    Elected: 'Ja',
    Sitznummer: '129',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BE',
    Nachname: 'Wasserfallen',
    Vorname: 'Flavia',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Politologin und Ökonomin war von 2012 bis März 2018 Co-Leiterin des Generalsekretariats der SP Schweiz und gilt als eine der stärksten Figuren der Partei im Nationalrat. Flavia Wasserfallen ist Präsidentin vom Schweizerische Fachverband Mütter- und Väterberatung. Sie präsidiert auch ein Lieferdienst für biologische Lebensmittel den sie in Jahr 2010 mitgegründet hat. Von 2006 bis 2010 arbeitete sie in der Sektion Bundesrats- und Parlamentsgeschäfte im Bundesamt für Energie.',
    'BAT DE': 'Gelb',
    'Text fr':
      "La politologue et économiste a été co-responsable du Secrétariat général du PS Suisse de 2012 à mars 2018 et est considérée comme l'une des figures les plus fortes de son parti au sein du Conseil national. Flavia Wasserfallen est présidente de l'Association suisse de conseil aux mères et aux pères. Elle préside également un service de livraison de produits biologiques qu'elle a cofondé en 2010. De 2006 à 2010, elle a travaillé à la Section des affaires du Conseil fédéral et du Parlement de l'Office fédéral de l'énergie.",
    'BAT FR': '',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Berne',
    Geburtsdatum: '07.02.1979',
    'Beruf de': 'Politologin',
    'Beruf fr': 'Politologue et économiste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '130',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'LDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'BS',
    Nachname: 'Eymann',
    Vorname: 'Christoph',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Eymann ist ein alter Bekannter in Bern. Er sass bereits von 1991 bis 2001 für die Liberalen im Nationalrat. Seit 2000 ist Eymann Basler Erziehungsdirektor, seit 2013 präsidiert er die Kantonale Konferenz der Erziehungsdirektoren.',
    'Text de':
      'Eymann sass schon von 1991 bis 2001 im Nationalrat. Seit 2015 ist er wieder in Bern. Dort ist der langjährige Erziehungsdirektor Mitglied der Bildungskommsision. Zudem setzt sich der Co-Präsident der Solar-Agentur für den Ausbau der Subventionen für Sonnenenergie ein. ',
    'BAT DE': 'fre',
    'Text fr':
      "Christoph Eymann a siégé au Conseil national de 1991 à 2001. Il quitte Berne pour devenir conseiller d'Etat à Bâle, en charge de l'instruction publique. Il y deviendra une référence en matière d'éducation. Réélu en 2015 au Conseil national,  le coprésident de l'Agence solaire suisse s'engage pour accroître les subventions en faveur de l'énergie solaire. Souvent en décalage avec son parti, il ne réussit pas à peser sur les décisions de son groupe.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Basel',
    'Wohnort fr': 'Bâle',
    Geburtsdatum: '15.01.1951',
    'Beruf de': 'Jurist',
    'Beruf fr': 'Juriste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '131',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'AG',
    Nachname: 'Feri',
    Vorname: 'Yvonne',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Feri ist Präsidentin der SP Frauen Schweiz. Zu ihren Schwerpunkten im Parlament gehört die Familienpolitik. Feri ist Vizepräsidentin der Geschäftsprüfungskommission.',
    'Text de':
      'Die Aargauerin wollte auf die neue Legislatur hin als Ständerätin kandidieren, unterlag in der parteiinternen Ausmarchung jedoch Cédric Wermuth. Feri gehört dem Reformflügel der SP an. Zu ihren Schwerpunkten gehören die Gesundheits- und Familienpolitik.',
    'BAT DE': 'fre',
    'Text fr':
      "L’Argovienne voulait se présenter au Conseil des États pour la nouvelle législature, mais Cédric Wermuth l’a emporté lors de la sélection interne au parti. Ses thèmes prioritaires au Parlement sont la santé et la politique familiale, ainsi que les questions d'égalité.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Wettingen',
    'Wohnort fr': 'Wettingen',
    Geburtsdatum: '21.03.1966',
    'Beruf de': 'Unternehmerin',
    'Beruf fr': 'Entrepreneure'
  },
  {
    Elected: 'Ja',
    Sitznummer: '132',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'VD',
    Nachname: 'Wehrli',
    Vorname: 'Laurent',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der ehemalige Journalist und Vater von fünf Kindern ist Stadtpräsident von Montreux. Er sitzt auch im Waadtländer Grossen Rat.',
    'Text de':
      'Der Syndic von Montreux gilt als freisinniger Pöstchenjäger alter Schule. Die Affäre rund um seine ausgiebige Reisetätigkeit als Stadtpräsident überstand er unbeschadet. Das liegt auch daran, dass er sich in den letzten Jahren kaum Feinde schuf. Laurent Wehrli wird in der Waadt stets als künftiger Regierungsrat gehandelt. Doch dafür muss ein Sitz frei werden.In Bern ist sein Einfluss beschränkt.',
    'BAT DE': 'daf',
    'Text fr':
      "Le Montreusien est-il le dernier humaniste du PLR? C'est ce qu'inspirent ses positions au sein de la commission de politique extérieure. Ex- président de Pro familia, il est à la tête d'Helvetia latina, qui défend Romands et Tessinois dans l'adminisrtration. L'affaire autour de ses voyages en tant que syndic n'a pas entaché sa popularité. Issu de la souche radicale du PLR, Laurent Wehrli séduit à gauche, sans rebuter les plus libéraux de son parti. Il a tout du futur conseiller d'Etat vaudois.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Glion',
    'Wohnort fr': 'Glion',
    Geburtsdatum: '04.06.1965',
    'Beruf de': '',
    'Beruf fr': 'Indépendant et syndic'
  },
  {
    Elected: 'Ja',
    Sitznummer: '133',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'AG',
    Nachname: 'Suter',
    Vorname: 'Gabriela',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Gabriela Sutter ist Interimsmanagerin in einem Verein für Kinderbetreuung. Seit 2017 sitzt sie im Grossen Rat, seit diesem Juni ist sie Präsidentin der SP Aargau - und nun gelingt ihr auch der Schritt aufs nationale politische Parkett. ',
    'BAT DE': 'Gelb',
    'Text fr':
      "Gabriela Sutter est gestionnaire ad interim dans une association de garde d'enfants. Elle est membre du Grand Conseil depuis 2017, présidente du PS argovien depuis juin de cette année – et maintenant elle fait également son entrée sur la scène politique nationale.\n",
    'BAT FR': '',
    'Wohnort de': 'Aarau',
    'Wohnort fr': 'Aarau',
    Geburtsdatum: '11.12.1972',
    'Beruf de': 'Historikerin',
    'Beruf fr': 'Historienne'
  },
  {
    Elected: 'Ja',
    Sitznummer: '134',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'GR',
    Nachname: 'Giacometti',
    Vorname: 'Anna',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Anna Giacometti ist als Präsidentin der Gemeinde Bregaglia durch den Bergsturz von Bondo national bekannt geworden. Sie schaffte die Wahl, obschon sie auf dem vierten von fünf Listenplätzen stand.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Anna Giacometti est devenue célèbre au niveau national en sa qualité de présidente de la commune de Bregaglia après le glissement de terrain du Bondo. Elle a réussi à se faire élire malgré une quatrième place sur une liste à cinq.',
    'BAT FR': '',
    'Wohnort de': 'Stampa',
    'Wohnort fr': 'Stampa',
    Geburtsdatum: '08.09.1961',
    'Beruf de': 'Gemeindepräsidentin',
    'Beruf fr': 'Présidente de commune'
  },
  {
    Elected: 'Ja',
    Sitznummer: '135',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'VD',
    Nachname: 'Bendahan',
    Vorname: 'Samuel',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2017',
    'DabeiSeit fr': 'Au Conseil national depuis 2017',
    'Alte Texte DE': '',
    'Text de':
      'Er kam in der Mitte der Legislaturperiode als Nachfolger von Cesla Amarelles, die in den Waadtländer Staatsrat wechselte. Inzwischen hat er sich im Nationalrat eingefunden. Der Ökonom und gebürtige Lausanner ist bekannt für seine phantasievollen Erklärungen mit denen er den Gesprächspartner seine Themen näher bringt. Die Rechte hat inzwischen festgestellt, dass er weniger dogmatisch politisiert als erwartet. Als Mitglied des Finanzausschusses, zeigt er sich zum Beispiel eher offen in Steuerfragen.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Arrivé en cours de législature pour reprendre le siège de Cesla Amarelle partie au Conseil d’État, le Vaudois a depuis fait son bonhomme de chemin au National. Cet économiste est toujours prêt a se lancer dans des explications très imagées pour faire comprendre sa matière de prédilection à ses interlocuteurs. À droite on remarque qu’il est moins dogmatique que prévu. Le Lausannois, membre de la Commission des finances, se montre par exemple ouvert sur les questions fiscales.',
    'BAT FR': '',
    'Wohnort de': 'Lausanne',
    'Wohnort fr': 'Lausanne',
    Geburtsdatum: '01.06.1980',
    'Beruf de': 'Ökonome',
    'Beruf fr': "Economiste, Maître d'Enseignement et de Recherche"
  },
  {
    Elected: 'Ja',
    Sitznummer: '136',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'AG',
    Nachname: 'Jauslin',
    Vorname: 'Matthias',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Nach der Wahl von Müller in den Ständerat wird im Nationalrat voraussichtlich Matthias Jauslin nachrücken. Der 53-jährige Jauslin aus dem Freiamt ist Unternehmer und FDP-Kantonalpräsident.',
    'Text de':
      'Jauslin rückte 2015 für Phillip Müller in den Nationalrat, weil dieser in den Ständerat gewählt wurde. Der Unternehmer sieht sich als Praktiker, der die Bevölkerung und die KMU versteht. ',
    'BAT DE': 'fre',
    'Text fr':
      "En 2015, Matthias Jauslin a pris la place de l'ancien président du PLR Phillip Müller au Conseil national, ce dernier ayant été élu au Conseil des États. L'entrepreneur se considère comme un homme de terrain qui comprend la population et les PME.  ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Wohlen',
    'Wohnort fr': 'Wohlen',
    Geburtsdatum: '20.04.1962',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '137',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'VD',
    Nachname: 'Crottaz',
    Vorname: 'Brigitte',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die Diabetologin von Epalinges war im Grossen Rat diskret. Sie viel auch in Bern nicht speziell auf. Als Nationalrätin kam sie als Ersatz von Jean Christophe Schwaab im Februar 2010. Ihre Kantonspartei sähe sie am liebsten in der Gesundheitskommisison, wo sie sich gut einbingen könnte.',
    'BAT DE': 'Gelb',
    'Text fr':
      "La diabétologue d’Épalinges était discrète au Grand Conseil. Elle l’est toujours à Berne, où elle a succédé à Jean Christophe Schwaab. Sa présence à la Commission de sécurité la cantonne à un rôle d’opposition à la droite sur les sujets de défense. Son parti cantonal aimerait la voir à la Commission de la santé, où elle serait sans doute plus à l'aise.",
    'BAT FR': '',
    'Wohnort de': 'Epalinges',
    'Wohnort fr': 'Epalinges',
    Geburtsdatum: '06.10.1957',
    'Beruf de': 'Ärztin',
    'Beruf fr': 'Médecin, spécialiste en Endocrinologie-Diabétologie\n'
  },
  {
    Elected: 'Ja',
    Sitznummer: '138',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'VD',
    Nachname: 'Borloz',
    Vorname: 'Frédéric',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der ausgebildete Kaufmann und ehemalige Bürgermeister von Aigle ist langjähriger Kantonsrat im Kanton Waadt.',
    'Text de':
      'Der Treuhänder und langjährige Gemeindepräsident aus Aigle bleibt in Bern genauso farblos, wie er es als Präsident der FDP Waadt war. Er träumte davon, einen Waadtländer FDP-Bundesrat hervorzubringen. Der Traum ging nicht in Erfüllung.',
    'BAT DE': 'daf',
    'Text fr':
      "A la tête de deux fiduciaires, l'inusable syndic d'Aigle n'a pour l'heure jamais réussi à percer sous la Coupole, ni même dans la commission des transports dans laquelle il siège. Sa gestion calamiteuse des candidatures vaudoises pour reprendre le siège de Didier Burkhalter au Conseil fédéral lui a aussi valu son lot de critiques. Il présidait alors la section cantonale du parti.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Aigle',
    'Wohnort fr': 'Aigle',
    Geburtsdatum: '22.04.1966',
    'Beruf de': '',
    'Beruf fr': 'Comptable'
  },
  {
    Elected: 'Ja',
    Sitznummer: '139',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'SH',
    Nachname: 'Munz',
    Vorname: 'Martina',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2013',
    'DabeiSeit fr': 'Au Conseil national depuis 2013',
    'Alte Texte DE':
      'Munz ist während der Legislatur für den ehemaligen SP-Präsidenten Hans-Jürg Fehr nachgerückt. Sie sitzt in der Bildungskommission, was der Berufsschullehrerin sehr behagt. Kämpft vehement gegen ein Atommüll-Tiefenlager im zürcherischen Weinland.',
    'Text de':
      'Die Berufsschullehrerin befasst sich vor allem mit Bildungsthemen. Zudem kämpft sie vehement gegen ein Atommüll-Tiefenlager im zürcherischen Weinland. ',
    'BAT DE': 'fre',
    'Text fr':
      "Enseignante dans une école professionnelle, Martina Munz s'occupe principalement de sujets liés à la formation. Elle lutte également avec force contre le projet de dépôt de déchets nucléaires dans sa région du Weinland zurichois.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Hallau',
    'Wohnort fr': 'Hallau',
    Geburtsdatum: '26.12.1955',
    'Beruf de': 'Agronomin ETH, Berufsschullehrperson',
    'Beruf fr': 'Agronome'
  },
  {
    Elected: 'Ja',
    Sitznummer: '140',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'TI',
    Nachname: 'Cattaneo',
    Vorname: 'Rocco',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2017',
    'DabeiSeit fr': 'Au Conseil national depuis 2017',
    'Alte Texte DE': '',
    'Text de':
      'Der Quereinsteiger sitzt erst seit 2017 im Rat, als er für den in den Bundesrat gewählten Ignazio Cassis nachrückte.Cattaneo war von 1986 bis 1994 Radprofi und organisierte 1996 die Strassen-WM in Lugano. Heute führt er eine Mineralölfirma. Im Nationalrat setzt sich Cattaneo unter anderem für mehr Sicherheit für Velofahrer ein.',
    'BAT DE': 'fre',
    'Text fr':
      "Cycliste professionnel de 1986 à 1994 et organisateur des Championnats du monde sur route à Lugano en 1996, Rocco Cattaneo ne siège au Conseil national que depuis 2017, lorsqu'il a pris la succession d'Ignazio Cassis. Aujourd'hui, il dirige une société qui gère plusieurs stations-service. Il est aussi à la tête des infrastructures du très touristique Monte-Tamaro. Au National, le président de l'Union européenne de cyclisme s'engage pour améliorer la sécurité des cyclistes.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Monteceneri',
    'Wohnort fr': 'Monteceneri',
    Geburtsdatum: '06.12.1958',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '141',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'GR',
    Nachname: 'Locher Benguerel',
    Vorname: 'Sandra',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Mit Sandra Benguerel Locher ist nach dem Rücktritt von Silva Semadeni wieder eine Bündner SP-Frau im Nationalrat. Die Lehrerin ist momentan Grossrätin in Graubünden.\n',
    'BAT DE': 'Gelb',
    'Text fr':
      'Sandra Benguerel Locher est enseignante. Elle a été membre du parlement cantonal des Grisons.',
    'BAT FR': '',
    'Wohnort de': 'Chur',
    'Wohnort fr': 'Coire',
    Geburtsdatum: '16.09.1975',
    'Beruf de': 'Lehrerin',
    'Beruf fr': 'Enseignante'
  },
  {
    Elected: 'Ja',
    Sitznummer: '142',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'ZH',
    Nachname: 'Sauter',
    Vorname: 'Regine',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Sauter ist Direktorin der Zürcher Handelskammer. Als Mitglied des Zürcher Kantonsrats sitzt sie in der Wirtschafts- und der Justizkommission.',
    'Text de':
      'Sauter ist Direktorin der Zürcher Handelskammer. Die promovierte Staatswissenschafterin widmet sich im Nationalrat primär der Wirtschafts- und Sozialpolitik.',
    'BAT DE': 'fre',
    'Text fr':
      "Regine Sauter est directrice de la Chambre de commerce zurichoise et à ce titre membre du comité directeur des associations d'Economiesuisse. Pur produit de l'appareil libéral radical, elle y a d'abord oeuvré en tant que secrétaire politique, avant d'occuper diverses fonctions dans la communication et l'administration. Docteur en administration publique à Saint-Gall, est également titulaire d'un MBA conjoint entre les universités de Saint-Gall et de Berkeley, en Californie.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '16.04.1966',
    'Beruf de': 'Wissenschaftlerin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '143',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'GR',
    Nachname: 'Pult',
    Vorname: 'Jon',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Jon Pult wollte auch in den Ständerat, scheiterte jedoch als Drittplatzierter an den Bisherigen. Er sagt es sei Zeit für eine neue Generation im Parlament, die den übermächtigen Lobbys entgegentritt.\n',
    'BAT DE': 'Gelb',
    'Text fr':
      "Jon Pult voulait également être membre du Conseil des Etats, mais il a échoué à la troisième au classement. Selon lui, le temps est venu pour qu'une nouvelle génération s'impose contre le poids des lobbies au Parlement.",
    'BAT FR': '',
    'Wohnort de': 'Chur',
    'Wohnort fr': 'Coire',
    Geburtsdatum: '12.10.1984',
    'Beruf de': 'Strategie- und Kommunikationsberater',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '144',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'SG',
    Nachname: 'Dobler',
    Vorname: 'Marcel',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der Mitgründer von Digitec setzt sich für einen starken Wirtschaftsstandort ein und kämpft gemäss eigenen Angaben gegen die «Hochpreisinsel Schweiz». Auch sportlich ist Dobler aktiv: 2009 wurde er Schweizermeister im olympischen Zehnkampf.',
    'Text de':
      'Der Mitgründer der Firma Digitec setzt sich für einen starken Wirtschaftsstandort ein und kämpft gemäss eigenen Angaben gegen die «Hochpreisinsel Schweiz». Auch sportlich ist Dobler aktiv: 2009 wurde er Schweizermeister im olympischen Zehnkampf.',
    'BAT DE': 'fre',
    'Text fr':
      "Le cofondateur de la boutique en ligne Digitec s'engage en faveur d'une place économique forte et connectée digitalement. Il lutte contre la réglementation dans le commerce qui fait de la Suisse un îlot de cherté. Dobler est également un sportif accompli. En 2009, il a décroché le titre de champion suisse de décathlon.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Rapperswil-Jona',
    'Wohnort fr': 'Rapperswil-Jona',
    Geburtsdatum: '29.08.1980',
    'Beruf de': 'Wirtschaftsinformatiker B.Sc.FH, Unternehmer',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '145',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BE',
    Nachname: 'Aebischer',
    Vorname: 'Matthias',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der ehemalige Fernsehjournalist hat sich in seiner ersten Legislatur vor allem in Bildungs- und Kulturfragen bemerkbar gemacht. Der Präsident von Fussverkehr Bern setzt sich auch gerne für die schwächsten Verkehrsteilnehmer ein.',
    'Text de':
      'Der ehemalige TV-Journalist ist vor allem in der Medien-, Bildungs- und Kulturpolitik aktiv. Er ist ausserdem Präsident von Velo Schweiz und setzt sich mit Nachdruck für den Veloverkehr ein. Ausserdem gehört er zu den Organisatoren des Grand Prix Bern, dem grössten Laufereignis der Schwiez.',
    'BAT DE': 'fre',
    'Text fr':
      "Ancien journaliste à la télévision alémanique SRF, le socialiste bernois est avant tout actif en matière de politique des médias, de formation et de politique culturelle. Il est aussi président de Velo Suisse et l'un des organisateurs de la course pédestre populaire Grand Prix de Berne. ",
    'BAT FR': 'Relu et complété par Lise',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Berne',
    Geburtsdatum: '18.10.1967',
    'Beruf de': 'Nationalrat, Journalist',
    'Beruf fr': 'Journaliste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '146',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'LU',
    Nachname: 'Vitali',
    Vorname: 'Albert',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Vitali ist Inhaber eines Treuhandbüros. Im Nationalrat macht er als Mitglied der Finanzkommission vor allem Finanzpolitik.',
    'Text de':
      'Vitali ist Inhaber eines Treuhandbüros in Oberkirch. Im Nationalrat gehört der Luzerner eher zu den Hinterbänklern. Sein Gebiet ist insbesondere die Finanzpolitik.',
    'BAT DE': 'fre',
    'Text fr':
      "Albert Vitali est propriétaire d'une agence fiduciaire à Oberkirch. Au Conseil national, le Lucernois est davantage un député d'arrière-ban. Son domaine d'expertise est en particulier la politique financière.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Oberkirch',
    'Wohnort fr': 'Oberkirch',
    Geburtsdatum: '26.06.1955',
    'Beruf de': 'Unternehmer, Nationalrat',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '147',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'FR',
    Nachname: 'Bulliard-Marbach',
    Vorname: 'Christine',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Die Gemeindepräsidentin von Ueberstorf ist Mitglied der Bildungskommission. Sie setzt sich ein für Familien, Behinderte, Innovation – und natürlich die Gemeinden.',
    'Text de':
      'Die ehemalige Gemeindepräsidentin von Ueberstorf tritt vor allem als Familien- und Bildungspolitikerin in Erscheinung. Zusammen mit ihrem Mann ist sie als Gastwirtin tätig. Bulliard ist zudem Präsidentin der Schweizerischen Lauterkeitskommission und der Schweizerischen Arbeitsgemeinschaft für das Berggebiet (SAB).',
    'BAT DE': 'fre',
    'Text fr':
      "L'ancienne présidente de la commune d'Ueberstorf s'investit en particulier sur les thématiques de la formation et de la politique familiale. Présidente du Groupement suisse pour les régions de montagne, elle défend les campagnes. Avec son mari, elle exploite aussi l'auberge de son village.  ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Ueberstorf',
    'Wohnort fr': 'Ueberstorf',
    Geburtsdatum: '13.10.1959',
    'Beruf de': '',
    'Beruf fr': "Responsable d'une exploitation agricole, présidente CSEC"
  },
  {
    Elected: 'Ja',
    Sitznummer: '148',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BL',
    Nachname: 'Sollberger',
    Vorname: 'Sandra',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Bei den Landratswahlen 2015 im Kanton Basel-Land holte Sollberger die meisten Stimmen. Sie setzt sich für eine strengere Einwanderungspolitik ein.',
    'Text de':
      'Sandra Sollberger führt mit ihrem Mann ein Malergeschäft. Sie ist Mitglied der Finanzkommission und der Kommission für Verkehr und Fernmeldewesen. Sie setzt sich für eine Obergrenze der Anzahl Bundesbeamter und einen Ausbau der Strasseninfrastruktur ein. ',
    'BAT DE': 'fre',
    'Text fr':
      "Sandra Sollberger dirige l'entreprise de peinture en bâtiment héritée de sa belle famille. Elle est membre de la Commission des finances et de la Commission des transports et des télécommunications. Elle milite pour un plafonnement du nombre de fonctionnaires fédéraux et une extension de l'infrastructure routière. ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Bubendorf',
    'Wohnort fr': 'Bubendorf',
    Geburtsdatum: '27.10.1973',
    'Beruf de': 'eidg. dipl. Malermeisterin, Geschäftsführerin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '149',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'JU',
    Nachname: 'Gschwind',
    Vorname: 'Jean-Paul',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Gschwind ist Mitglied der Finanzkommission und setzte sich stark dafür ein, dass der Finanzausgleich-Beitrag für die Nehmerkantone nicht gekürzt. Der Veterinär hat sich dem Kampf gegen zu teure Tierarzneimittel verschrieben.',
    'Text de':
      'Der Veterinär ist ein unscheinbarer Parlamentarier. Doch plötzlich stand er im Wahljahr als Präsident der Gerichtskommission im Rampenlicht - als sich das Gremium gegen die Wiederwahl von Bundesanwalt Michael Lauber ausgesprochen hat.',
    'BAT DE': 'fre',
    'Text fr':
      "Le vétérinaire à la retraite est un parlementaire discret. Mais il a été propulsé en pleine année électorale sur le devant de la scène, puisqu’il occupait la présidence de la commission judiciaire, lorsque celle-ci s'est prononcée contre la réélection du procureur général de la Confédération Michael Lauber.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Courchavon',
    'Wohnort fr': 'Courchavon',
    Geburtsdatum: '31.10.1952',
    'Beruf de': '',
    'Beruf fr': 'Médecin-vétérinaire retraité'
  },
  {
    Elected: 'Ja',
    Sitznummer: '150',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Köppel',
    Vorname: 'Roger',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der Weltwoche-Chefredaktor dürfte im Vorfeld am meisten Aufmerksamkeit erhalten haben – und arbeitete sich wohl auch deshalb auf der SVP SVP-Liste bis auf den ersten Platz vor.',
    'Text de':
      'Der SVP-Mann und Weltwoche Verleger kandidierte vergeblich für den Ständerat und befindet sich auf einem Kreuzzug gegen «Klima-Apokalyptiker». Das Wahlkampfpensum und die Medienauftritte waren enorm, entsprechend nachlässig nahm er sein Parlamentsmandat wahr. Fraktionsintern ist Köppels Einfluss beschränkt, eine wichtige Stimme in der öffentlichen Debatte ist er dennoch.',
    'BAT DE': 'fre',
    'Text fr':
      "Elu avec le meilleur score au Conseil national en 2015, alors qu'il venait d'entrer en politique, l'éditeur et rédacteur en chef de la Weltwoche était aussi candidat au Conseil des Etats. Il a fait la tournée des 162 communes de son canton avant le 20 octobre, fustigeant \"l'hystérie climatique\". Il ne s'est pas présenté au second tour, jugeant ses chances trop minces. Sa popularité est inversément proportionnelle à son influence au Parlement fédéral, où il peine à peser en commission et s'est distingué en manquant  un grand nombre de votations. ",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Küsnacht',
    'Wohnort fr': 'Küsnacht',
    Geburtsdatum: '21.03.1965',
    'Beruf de': 'Journalist, Medienunternehmer',
    'Beruf fr': 'Journaliste, entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '151',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'TI',
    Nachname: 'Regazzi',
    Vorname: 'Fabio',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Ein Jahr vor seiner Wahl in den Nationalrat wurde der Rechtsanwalt Geschäftsleiter der Regazzi SA, einem Familienunternehmen, das im Maschinenbau und in der Metallverarbeitung tätig ist. Im Nationalrat sitzt Regazzi in der Verkehrs- und Fernmeldekommission sowie in der Redaktions- und in der Immunitätskommission.',
    'Text de':
      'Der Anwalt ist eine eher unscheinbare Figur im Nationalrat. Er sitzt in zahlreichen Verwaltungsräten und setzt sich leidenschaftlich für die Anliegen der Jäger sowie der Autofahrer ein.',
    'BAT DE': 'fre',
    'Text fr':
      "L'avocat de formation est à la tête de plusieurs entreprises au Tessin. Fabio Regazzi siège aussi dans de nombreux conseils d'administration et se montre très réceptif aux préoccupations des chasseurs et des automobilistes. Il s'est notamment largement engagé pour la construction d'un deuxième tunnel autoroutier pour le Gothard.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Gordola',
    'Wohnort fr': 'Gordola',
    Geburtsdatum: '22.06.1962',
    'Beruf de': 'Imprenditore',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '152',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BE',
    Nachname: 'Pieren',
    Vorname: 'Nadja',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Als Leiterin von mehreren Kinderkrippen bringt sie eine andere Perspektive in die SVP-Fraktion. Sie ist eine von mehreren Vizepräsidenten der SVP Schweiz und Mitglied der Kommission für Wissenschaft, Bildung und Kultur.',
    'Text de':
      'Pieren ist Mitglied der SVP-Parteileitung und dort zuständig für die Familien- und Gesellschaftspolitik. Die diplomierte Kleinkinderzieherin arbeitet als Leiterin einer privaten Kindertagesstätte.',
    'BAT DE': 'fre',
    'Text fr':
      "Inconnue en Suisse romande, Nadja Pieren est pourtant membre de la présidence de l'UDC suisse. Elle y occupe la place de responsable de la politique familiale et sociale du parti. Des domaines qu'elle pratique dans sa profession puisqu'elle travaille comme responsable d'une crèche.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Heimiswil',
    'Wohnort fr': 'Heimiswil',
    Geburtsdatum: '14.02.1980',
    'Beruf de': 'Führungsfachfrau eidg. FA, dipl. Kleinkinderz.',
    'Beruf fr': 'Éducatrice de la petite enfance'
  },
  {
    Elected: 'Ja',
    Sitznummer: '153',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'VS',
    Nachname: 'Kamerzin',
    Vorname: 'Sidney',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Sidney Kamerzin ist Doktor der Rechtwissenschaften und arbeitet als Anwalt und Notar. Er galt seit einiger Zeit als Geheimfavorit für eine Wahl in den Nationalrat. Im Walliser Kantonsrat ist er eine der wichtigen Figuren innerhalb der CVP. Kamerzin ist Mitglied im Stiftungsrat des Casinos von Crans-Montana.',
    'BAT DE': 'Gelb',
    'Text fr':
      'Sidney Kamerzin est un avocat-notaire et docteur en droit. Politiquement, il est l’actuel chef du groupe PDC du Centre au Grand Conseil valaisan. Une assemblée dans laquelle il siège pour sa deuxième période. Il a été membre des commissions permanentes de gestion et de justice.',
    'BAT FR': 'pas relu',
    'Wohnort de': 'Siders',
    'Wohnort fr': 'Sierre',
    Geburtsdatum: '19.03.1975',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '154',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SH',
    Nachname: 'Hurter',
    Vorname: 'Thomas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Der umgängliche Hurter wird immer mal wieder als möglicher Bundesratskandidat gehandelt. Er ist – nicht zuletzt weil er auch Militärpilot ist – ein gefragter Sicherheitspolitiker. Zudem ist er Mitglied der Verkehrskommission.',
    'Text de':
      'Der frühere Militärpilot ist ein gemässigtes Mitglied der SVP-Fraktion und ein gefragter Sicherheitspolitiker. Im Vorfeld der Bundesratwahl von Guy Parmelin brachte er sich selber als Sprengkandidat ins Spiel - machte dann aber nur 22 Stimmen. ',
    'BAT DE': 'fre',
    'Text fr':
      "Le pilote de ligne est un membre modéré de l'UDC. Ancien pilote à l'armée et parlant très bien le français, c'est un expert des questions militaires. Son avis compte au sein de la commission de politique de sécurité, où il siège, mais aussi dans les médias toutes régions confondues. Il s'était lancé dans la course à la succession d'Evelyne Widmer-Schlumpf, mais il n'avait pas été retenu par le groupe UDC.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Schaffhausen',
    'Wohnort fr': 'Schaffhouse',
    Geburtsdatum: '01.11.1963',
    'Beruf de': 'Pilot',
    'Beruf fr': 'Pilote'
  },
  {
    Elected: 'Ja',
    Sitznummer: '155',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Fraktion Mitte.CEB',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'GE',
    Nachname: 'Maitre',
    Vorname: 'Vincent',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Der Genfer Anwalt Vincent Maitre bewies bereits kurze Zeit nach seiner Wahl zum Präsidenten der Genfer CVP ein gesundes Machtbewusstsein. Anschauungsunterricht hatte er als Sohn des alts Nationalrats und Regierungsrats Jean-Philippe Maitre. Auf zwei Jahre im Genfer Gemeinderat folgten zehn Jahre im Kantonsparlament. Vincent Maitre ist im Mitglied des Stiftungsrates des Genfer Autosalons.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Fils du conseiller national et conseiller d'Etat Jean-Philippe Maitre, petit-fils du conseiller d'Etat Yves Maître, Vincent Maitre est un pur produit du PDC. Cet avocat préside le PDC cantonal depuis 2018 et siège au parlement local depuis dix ans. Durant deux ans, il a effectué une partie de législature au conseil municipal de la Ville de Genève. Vincent Maitre préside la société Swiss Ambulance Rescue et est membre du conseil de fondation du salon de l'automobile.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '16.07.1981',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '156',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'VD',
    Nachname: 'Buffat',
    Vorname: 'Michael',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE': 'Bankenexperte und Grossrat im Kanton Waadt.',
    'Text de':
      'Der Filialleiter einer Bank galt als grosser Hoffnungsträger bei der Westschweizer SVP. Doch sein Einfluss in seinem Heimatkanton Waadt und in Bundesbern bleibt überschaubar.',
    'BAT DE': 'daf',
    'Text fr':
      "Le banquier siège à Berne depuis 2015. Dans le canton de Vaud, il s'était fait connaître comme chef de groupe de l'UDC au Grand conseil. Présenté comme la relève du parti en Suisse romande par la présidence de l'UDC, Michael Buffat n'a pas encore vraiment réussi à percer sous la Coupole. Les thèmes de prédilection de ce fils de paysans sont l'économie mais surtout l'asile. Il fustige régulièrement le laxisme de son canton en la matière.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Vuarrens',
    'Wohnort fr': 'Vuarrens',
    Geburtsdatum: '27.09.1979',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '157',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'FR',
    Nachname: 'Roth Pasquier',
    Vorname: 'Marie-France',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Marie-France Roth Pasquier ist Vizepräsidentin der CVP Freiburg. Als Finanzdirektorin der Stadt Bulle sammelte sie Erfahrungen als Exekutivpolitikerin. Dann entschied sie sich, für die Nachfolge von Nationalrat Dominique de Buman zu kandidieren. Sie schaffte die Wahl als Vertreterin des frankophonen Kantonsteils, was nicht selbstverständlich ist.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Vice-présidente du PDC Fribourg, forte de son expérience de responsable des Finances de la ville de Bulle, Marie-France Roth Pasquier va s'installer sur le siège laissé libre par Dominique de Buman au Conseil national. Elle sauve ainsi le siège romand du PDC Fribourg à Berne.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Bulle',
    'Wohnort fr': 'Bulle',
    Geburtsdatum: '25.04.1968',
    'Beruf de': 'Politikerin',
    'Beruf fr': 'Politicienne'
  },
  {
    Elected: 'Ja',
    Sitznummer: '158',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'TG',
    Nachname: 'Gutjahr',
    Vorname: 'Diana',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Im November 2017 rückte Diana Gutjahr ins Bundeshaus nach anstelle des ehemaligen Bauerverbandspräsident Hansjörg Walter. Über die Ostschweiz hinaus ist sie noch wenig bekannt. Die Politikerin studierte Betriebswirtschaftslehre in St. Gallen. Sie ist mit ihrem Mann Geschäftsführerin des Familienunternehmens Ernst Fischer AG, das im Bereich Stahl- und Metallbauarbeiten tätig ist.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Arrivée au Parlement fédéral comme vient-ensuite en novembre 2017, Diana Gutjahr ne s'est pas vraiment fait remarquer au-delà de la Suisse orientale. La politicienne a étudié l'administration des affaires à Saint-Gall. Elle est membre du conseil d'administration de la société familiale Ernst Fischer AG active dans le secteur des constructions métallique, qu'elle co-dirige avec son mari.",
    'BAT FR': '',
    'Wohnort de': 'Amriswil',
    'Wohnort fr': 'Amriswil',
    Geburtsdatum: '13.01.1984',
    'Beruf de': 'Unternehmerin',
    'Beruf fr': "Cheffe d'entreprise"
  },
  {
    Elected: 'Ja',
    Sitznummer: '159',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'AG',
    Nachname: 'Binder-Keller',
    Vorname: 'Marianne',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Seit 2013 ist Marianne Binder-Keller Grossrätin im Kanton Aargau und seit Januar 2016 ist sie die Parteipräsidentin der kantonalen CVP. Binder-Keller setzt sich für die Sicherung von Arbeitsplätzen und für ethische Fragen ein.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Marianne Binder-Keller est membre du Grand Conseil argovien depuis 2013 et présidente du PDC cantonal depuis janvier 2016. Elle s'engage en faveur de la sécurité d'emploi et des questions éthiques.",
    'BAT FR': '',
    'Wohnort de': 'Baden',
    'Wohnort fr': 'Baden',
    Geburtsdatum: '15.06.1958',
    'Beruf de': 'Kommunikationsberaterin und Publizistin',
    'Beruf fr': 'Conseillère en communication'
  },
  {
    Elected: 'Ja',
    Sitznummer: '160',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BE',
    Nachname: 'Geissbühler',
    Vorname: 'Andrea Martina',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Die Polizistin und ehemalige Kindergärtnerin sitzt in der Geschäftsprüfungskommission und der Sicherheitspolitischen Kommission. Sie setzt sich ein gegen die Legalisierung von Cannabis und Drogenmissbrauch.',
    'Text de':
      'Die Polizistin und ehemalige Kindergärtnerin setzt sich ein gegen die Legalisierung von Cannabis und gegen den Drogenmissbrauch.',
    'BAT DE': 'fre',
    'Text fr':
      'La policière est une politicienne assidue, puisqu\'elle est celle qui manque le moins de vote au Conseil naitonal. Andrea Geissbühler s\'est fait un nom dans la lutte contre la légalisation du cannabis. Ses positions en matière de drogue sont en effet très tranchées. Elle a également suscité la critique en insinuant que les victimes de viol se montraient parfois "naïves" en invitant des hommes chez eux.',
    'BAT FR': 'Relu et réécrit par FQZ',
    'Wohnort de': 'Lauperswil',
    'Wohnort fr': 'Lauperswil',
    Geburtsdatum: '03.08.1976',
    'Beruf de': 'Polizistin',
    'Beruf fr': 'Policière'
  },
  {
    Elected: 'Ja',
    Sitznummer: '161',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'AI',
    Nachname: 'Rechsteiner',
    Vorname: 'Thomas',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Appenzell Innerrhoden bleibt eine CVP-Hochburg: Der ehemalige Finanzdirektor Thomas Rechsteiner verteidigt den einzigen Nationalratssitz. Der 47-jährige Versicherungsfachmann ist verheiratet und hat drei erwachsene Kinder. Er ist schon lange politisch aktiv. Vor seiner Zeit als Regierungsrat sass er im Grossen Rat und war Schulrat der Gemeinde Appenzell.',
    'BAT DE': 'Gelb',
    'Text fr':
      "L’ancien directeur des Finances Thomas Rechsteiner est parvenu à conserver le seul siège du canton en main du PDC. L'expert en assurance, âgé de 47 ans, est marié et père de trois enfants adultes. Il est politiquement actif depuis longtemps. Avant d'être membre du gouvernement, il a siégé au Grand Conseil et a été inspecteur scolaire pour la commune d'Appenzell.",
    'BAT FR': '',
    'Wohnort de': 'Appenzell',
    'Wohnort fr': 'Appenzell',
    Geburtsdatum: '14.11.1971',
    'Beruf de': 'Selbstständiger Generalagent',
    'Beruf fr': 'Agent général indépendant'
  },
  {
    Elected: 'Ja',
    Sitznummer: '162',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SG',
    Nachname: 'Friedli',
    Vorname: 'Esther',
    Bisher: 'Nein',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Die 42-jährige Esther Friedli ist Politologin, Gastronomin im «Haus der Freiheit» in Ebnat-Kappel und selbstständige Beraterin für politische Kommunikation. Sie hatte bisher kein nennenswertes politisches Amt inne, hat aber einen erfahrenen Politiker als Freund: Toni Brunner.',
    'BAT DE': 'Gelb',
    'Text fr':
      'La politologue de 42 ans est également restauratrice à la "Haus der Freiheit" à Ebnat-Kappel et conseillère indépendante en communication politique. Esther Friedli n\'a pas occupé de poste politique important jusqu\'à présent, mais elle peut compter sur l’expérience de son compagnon Toni Brunner.',
    'BAT FR': 'pas relu',
    'Wohnort de': 'Ebnat-Kappel',
    'Wohnort fr': 'Ebnat-Kappel',
    Geburtsdatum: '04.06.1977',
    'Beruf de': 'Beraterin für politische Kommunikation, Gastronomin',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '163',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'VS',
    Nachname: 'Bregy',
    Vorname: 'Philipp Matthias',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Philipp Matthias Bregy hat eine politische Ochsentour hinter sich. Der Oberwalliser Anwalt und CVP-Politiker war Gemeinderat, Fraktionschef im Grossrat und sitzt nun im Nationalrat. Im Bundeshaus wird der gemütliche und redegewandte Walliser mit einem Faible für Fussball, Krimis und gute Weine sicher noch auf sich aufmerksam machen.',
    'BAT DE': 'daf',
    'Text fr':
      "Il est le dernier arrivé aux Chambres fédérales en cours de législature précédente. Philipp Matthias Bregy n'a participé qu'à deux sessions avant les élections d'octobre 2019. C'est lui qui a succédé à Viola Amherd après son élection au Conseil fédéral. Mais même avec une si courte expérience, le Haut-Valaisan jouit d'une solide assise dans son canton. Associé du sénateur Beat Rieder dans le privé, l'avocat est parfaitement bilingue. Défini comme un pur conservateur, il a déjà pu montrer qu'il n'était pas totalement réfractaire au changement.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Naters',
    'Wohnort fr': 'Naters',
    Geburtsdatum: '07.07.1978',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '164',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'AG',
    Nachname: 'Giezendanner',
    Vorname: 'Benjamin',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Benjamin Giezendanner ist der Sohn von Ulrich Giezendanner, der dieses Jahr nach 28 Jahren im Parlament zurücktritt. Gienzendanner Junior politisiert auch für die SVP und arbeitet wie sein Vater im familieneigenen Transportunternehmen.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Benjamin Giezendanner est le fils d'Ulrich Giezendanner, qui a démissionné cette année après 28 ans au Parlement. Gienzendanner Junior fait aussi de la politique pour l'UDC et travaille comme son père dans l'entreprise familiale de transport.",
    'BAT FR': '',
    'Wohnort de': 'Rothrist',
    'Wohnort fr': 'Rothrist',
    Geburtsdatum: '22.04.1982',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '165',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'SG',
    Nachname: 'Paganini',
    Vorname: 'Nicolo',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2019',
    'DabeiSeit fr': 'Au Conseil national depuis 2019',
    'Alte Texte DE': '',
    'Text de':
      'Nicolo Paganini ist der Direktor der Messe Olma im St.Gallen. Er sieht sich als Wirtschaftsvertreter der sich für die Ostschweiz und den Standort Schweiz einsetzt.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Nicolo Paganini est directeur de la Foire de Saint-Gall, la fameuse Olma. Il se considère comme un représentant des entreprises qui s'engage en faveur de la Suisse orientale et de la place économique suisse.",
    'BAT FR': '',
    'Wohnort de': 'Abtwil',
    'Wohnort fr': 'Abtwil',
    Geburtsdatum: '08.06.1966',
    'Beruf de': 'Anwalt, Direktor OLMA Messen',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '166',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'LU',
    Nachname: 'Grüter',
    Vorname: 'Franz',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Grüter ist CEO von green.ch. Der Kantonsrat und Präsident der SVP des Kantons Luzern ist im Beirat des FC Luzern und besucht regelmässig dessen Heimspiele.',
    'Text de':
      'Grüter ist CEO von green.ch. Der erfolgreiche IT-Unternehmer gilt als gemässigter SVP-Vertreter und schmiedet bei digitalen Themen immer wieder Allianzen mit der Ratslinken. Er wird als künftiger Bunderatskandidat gehandelt.',
    'BAT DE': 'fre',
    'Text fr':
      "Franz Grüter a su profiter de l’essor d’internet pour devenir un entrepreneur à succès. En 2016, il a quitté ses fonctions de CEO du cinquième fournisseur internet suisse green.ch pour se consacrer à son mandat politique. Il reste le président du conseil d’administration. L’ancien apprenti mécanicien est considéré comme un représentant modéré de l'UDC et a constitué à plusieurs reprises des alliances avec la gauche sur le numérique. Il est pressenti comme candidat au poste de Conseiller fédéral.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Eich',
    'Wohnort fr': 'Eich',
    Geburtsdatum: '29.07.1963',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '167',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'LU',
    Nachname: 'Birrer-Heimo',
    Vorname: 'Prisca',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2010',
    'DabeiSeit fr': 'Au Conseil national depuis 2010',
    'Alte Texte DE':
      'Als Präsidentin der Stiftung für Konsumentenschutz bearbeitet Birrer-Heimo seit Jahren Konsumententhemen: hohe Preise, Parallelimporte, Produktedeklarationen. Sie ist Mitglied der nationalrätlichen Kommission für Wirtschaft und Abgaben.',
    'Text de':
      'Als langjährige Präsidentin der Stiftung für Konsumentenschutz bearbeitet Birrer-Heimo seit Jahren Konsumententhemen: hohe Preise, Parallelimporte, Produktedeklarationen.',
    'BAT DE': 'fre',
    'Text fr':
      "En tant que présidente de longue date de la Fondation pour la protection des consommateurs, Prisca Birrer-Heimo s'occupe depuis des années des questions de consommation: prix trop élevés, importations parallèles, déclarations sur la composition des produits.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Rothenburg',
    'Wohnort fr': 'Rothenburg',
    Geburtsdatum: '04.02.1959',
    'Beruf de': 'Konsumenten- schützerin',
    'Beruf fr': 'Protectrice des consommateurs'
  },
  {
    Elected: 'Ja',
    Sitznummer: '168',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'FR',
    Nachname: 'Bourgeois',
    Vorname: 'Jacques',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Bourgeois ist Direktor des Schweizerischen Bauernverbandes. Wenn es um die Anliegen der Landwirtschaft geht, stellt er die Interessen seiner Partei hinten an. Wenig Freude hatte die FDP etwa an seiner Forderung, dass Lebenmittel vom Cassis-De-Dijon-Prinzip ausgenommen werden oder dass Littering strafbar wird.',
    'Text de':
      'Bourgeois ist Direktor des einflussreichen Schweizerischen Bauernverbandes. Wenn es um die Anliegen der Landwirtschaft geht, stellt er die Interessen seiner Partei hintan.',
    'BAT DE': 'fre',
    'Text fr':
      "Jacques Bourgeois est le directeur de l'influente Union suisse des paysans. Le libéral-radical n'hésite pas à dévier de la ligne de son parti, lorsqu'il s'agit de défendre les intérêts des agriculteurs. Homme de réseau, il bénéficie d'entrées solides dans l'administration fédérale.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Avry-sur-Matran',
    'Wohnort fr': 'Avry-sur-Matran',
    Geburtsdatum: '14.03.1958',
    'Beruf de': 'Direktor Schweizer Bauernverband',
    'Beruf fr': "Directeur de l'Union suisse des paysans"
  },
  {
    Elected: 'Ja',
    Sitznummer: '169',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BS',
    Nachname: 'Jans',
    Vorname: 'Beat',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2010',
    'DabeiSeit fr': 'Au Conseil national depuis 2010',
    'Alte Texte DE':
      'Jans ist in Bern als Energiepolitiker und Naturschützer unterwegs. Er sitzt in der Umwelt- und Energiekommission sowie in der Wirtschaftskommission, wo er Landwirtschaftspolitik betreibt.',
    'Text de':
      'Beat Jans prägte als Vizepräsident der SP deren Wirtschaftspapier, das eine Demokratisierung der Wirtschaft fordert. Er sitzt sowohl in der Wirtschafts- wie auch in der Kommission für Umwelt, Energie und Raumplanung. Als Präsident der Energiestiftung setzt er sich für mehr Subventionen für erneuerbare Energien ein. ',
    'BAT DE': 'fre',
    'Text fr':
      "En tant que vice-président du PS, Beat Jans fortement influencé les papiers de position économiques du parti, notamment en appelant à une démocratisation de l'économie. En tant que président de la Fondation pour l'énergie, il s'est engagé pour l'augmentation des subventions aux énergies renouvelables.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Basel',
    'Wohnort fr': 'Bâle',
    Geburtsdatum: '12.07.1964',
    'Beruf de': 'Umweltberater',
    'Beruf fr': 'Conseiller en environnement'
  },
  {
    Elected: 'Ja',
    Sitznummer: '170',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'BE',
    Nachname: 'Wasserfallen',
    Vorname: 'Christian',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Als er im Nationalrat begann, da war Wasserfallen zuerst nur der Sohn des ehemaligen Berner Sicherheitsdirektors Kurt Wasserfallen. Nach relativ kurzer Zeit gelang es dem Sohn aus dem grossen Schatten des Vaters zu treten. Heute ist Christian Wasserfallen eine prägende Figur im rechten Flügel der FDP und kämpft dort unter anderem gegen eine überstürzte Energiewende.',
    'Text de':
      'Wasserfallen gehört zum rechten Flügel der FDP. Er ist einer der grössten Kritikern des von Parteichefin Petra Gössi initiierten, klimafreundlicheren Kurses der Partei. Aus Verärgerung über diese neue Ausrichtung trat er als Vizepräsident der FDP zurück.',
    'BAT DE': 'fre',
    'Text fr':
      "Christian Wasserfallen appartient à l'aile droite du PLR, et est farouchement attaché à la responsabilité individuelle. Il fut l'un des plus grands critiques du virage climatique initié par la cheffe du parti, Petra Gössi, refusant d'imposer davantage de taxes. Isolé sur cette question, il a fini par annoncer sa démission de son poste de vice-président du PLR.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Berne',
    Geburtsdatum: '30.06.1981',
    'Beruf de': 'dipl. Maschinen-Ingenieur',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '171',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'SG',
    Nachname: 'Gysi',
    Vorname: 'Barbara',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Als Vizepräsidentin ihrer Partei erlangte Gysi in ihrer ersten Legislatur rasch einen Bekanntheitsgrad auf nationaler Ebene. Die Wilerin profilierte sich als wirtschaftspolitische Wortführerin, etwa als Verfechterin der 1:12-Initiative der SP.',
    'Text de':
      'Die SP-Vizepräsidentin ist eine der Wortführerinnen ihrer Partei. Gysi ist vor allem in der Gesundheits- und Finanzpolitik aktiv. 2018 wollte sie Präsidentin des Schweizerischen Gewerkschaftsbundes werden, unterlag aber Pierre-Yves Maillard.',
    'BAT DE': 'fre',
    'Text fr':
      "La vice-présidente du PS est l'une des porte-voix de son parti. Gysi est particulièrement active dans les domaines de la santé et de la politique financière. Elle préside l'Association du personnel de la Confédération. En 2018, elle a voulu devenir présidente de la Fédération syndicale suisse. Elle a échoué face au Vaudois Pierre-Yves Maillard.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Wil',
    'Wohnort fr': 'Wil',
    Geburtsdatum: '14.05.1964',
    'Beruf de':
      'Sozialpädagogin, Vizepräsidentin SP Schweiz, Präsidentin kantonaler Gewerkschaftsbund',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '172',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'VD',
    Nachname: 'Feller',
    Vorname: 'Olivier',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Jurist Feller, der auch perfekt den Berner Dialekt beherrscht, gehört der Finanzkommission an. Er arbeitet als Direktor der Waadtläner Immobilienkammer.',
    'Text de':
      'Der perfekt zweisprachige Jurist fällt immer wieder durch seine Unabhängigkeit auf. Statt sich dem freisinnigen Korpsgeist zu unterwerfen, pflegt er gerne seinen kritischen Geist. Den kompetenten und stets gut aufgelegten Olivier Feller könnte man sich auch als Waadtländer Regierungsrat vorstellen. ',
    'BAT DE': 'daf',
    'Text fr':
      "Parfait bilingue et vulgarisateur hors-pair pour les questions économiques et financières, Olivier Feller est très présent dans les médias. Cultivant son indépendance d'esprit, il est parfois en porte-à-faux avec son parti. Ardent défenseur des propriétaires – dont il est un des porte-paroles romands – le Vaudois s'est aussi montré très critique à l'égard de la Poste dans sa gestion de l'affaire CarPostal.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Genolier',
    'Wohnort fr': 'Genolier',
    Geburtsdatum: '30.08.1974',
    'Beruf de': '',
    'Beruf fr': 'Directeur de la Chambre vaudoise immobilière (CVI)'
  },
  {
    Elected: 'Ja',
    Sitznummer: '173',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'AG',
    Nachname: 'Wermuth',
    Vorname: 'Cédric',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der frühere Juso-Chef und heutige Co-Präsident der SP Aargau ist Mitglied der nationalrätlichen Finanzkommission. Viele seiner Vorstösse drehen sich um Steuer- und Aussenpolitik.',
    'Text de':
      'Der frühere Juso-Chef kandidierte auch für den Ständerat. Am ersten Wahlgang landete auf der dritten Position und zog seine Kandidatur zurück. Viele Vorstösse von Wermuth drehen sich um Steuer- und Aussenpolitik. Er weiss noch immer, wie man provoziert, ist aber sachlicher geworden. ',
    'BAT DE': 'fre',
    'Text fr':
      "L'ancien président de la Jeunesse socialiste suisse a mené une campagne à l'américaine lors de ces élections 2019. Il y a investi 300'000 francs -  dont une grande part récoltée grâce à du crowdfunding, a bénéficié du soutien d'un comité de campagne fort de 5200 membres et a engagé l'agence de communication américaine qui a travaillé avec la démocrate Alexandria Ocasio-Cortez. Cédric Wermuth visait en effet avant tout un siège au Conseil des Etats dans son canton conservateur d'Argovie. Jugeant ses chances de l'emporter trop minces, il ne s'est pas présenté au second tour.",
    'BAT FR': 'BAT',
    'Wohnort de': 'Zofingen',
    'Wohnort fr': 'Zofingen',
    Geburtsdatum: '19.02.1986',
    'Beruf de': 'Strategie- und Kommunikationsberater, Nationalrat',
    'Beruf fr': 'Conseiller en stratégie et en communication'
  },
  {
    Elected: 'Ja',
    Sitznummer: '174',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'BL',
    Nachname: 'Schneeberger',
    Vorname: 'Daniela',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Als Präsidentin des Schweizerischen Treuhänderverbands vertritt sie mehrheitlich Interessen der Branche im Nationalrat. Mitglied der Finanz- und der staatspolitischen Kommission.',
    'Text de':
      'Daniela Schneeberger ist Treuhänderin und präsidiert den Berufsverband der Treuhänder. Als Mitglied der Kommission für Wirtschaft und Abgaben setzt sie sich gegen Regulierung und Abgaben ein. ',
    'BAT DE': 'fre',
    'Text fr':
      "Daniela Schneeberger est présidente de l'association professionnelle des fiduciaires. En tant que membre de la Commission de l'économie et des redevances, elle se bat contre la bureaucratie et les nouvelles taxes. C'est elle qui porte les espoirs des partis bourgeois de son canton pour revenir au Conseil des Etats.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Thürnen',
    'Wohnort fr': 'Thürnen',
    Geburtsdatum: '19.09.1967',
    'Beruf de': 'Unternehmerin',
    'Beruf fr': 'Entrepreneure'
  },
  {
    Elected: 'Ja',
    Sitznummer: '175',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'VD',
    Nachname: 'Nordmann',
    Vorname: 'Roger',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2004',
    'DabeiSeit fr': 'Au Conseil national depuis 2004',
    'Alte Texte DE':
      'Nordmann ist Vizepräsident der SP-Fraktion und ein einflussreicher Mann unter der Bundeshauskuppel. Der Berufspolitiker prägt vor allem die Energie- und Verkehrspolitik massgeblich mit.',
    'Text de':
      'Nordmann ist Präsident der SP-Fraktion und ein einflussreicher Mann unter der Bundeshauskuppel. Der Berufspolitiker prägt vor allem die Energie- und Verkehrspolitik massgeblich mit. Die SP Waadt verhinderte ihn als Ständeratskandidat.',
    'BAT DE': 'fre',
    'Text fr':
      "En tant que président du groupe parlementaire socialiste, Roger Nordmann est le numéro deux du parti et l'un des hommes les plus influents sous la Coupole fédérale. Parfait bilingue, le Vaudois est un acteur majeur des politiques de l'énergie et des transports. Malgré ce pédigré, le PS Vaud l'a empêché de se porter candidat au Conseil des Etats, lui préférant Ada Marra d'une poignée de voix.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Lausanne',
    'Wohnort fr': 'Lausanne',
    Geburtsdatum: '23.03.1973',
    'Beruf de': 'Berufspolitiker',
    'Beruf fr': 'Politicien professionnel'
  },
  {
    Elected: 'Ja',
    Sitznummer: '176',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'SZ',
    Nachname: 'Gössi',
    Vorname: 'Petra',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Die Juristin und Finanzpolitikerin aus Küssnacht am Rigi war bis 2011 Schwyzer Kantonsrätin und Chefin der FDP-Fraktion. Sie bezeichnet sich als „leidenschaftlichen Bewegungsmenschen“, fährt Ski und taucht. Neben der Arbeit im Parlament ist die Gössi (39) Steuer- und Unternehmensberaterin.',
    'Text de':
      'Gössi ist die Parteipräsidentin, die im Wahljahr am meisten für Aufsehen sorgte: Mit ihrem im Februar angekündigten Kurswechsel hin zu einer ökologischeren FDP hat sie viel Wirbel und parteiinterne Kritik ausgelöst. Am Ende stützten die Delegierten diesen Kurs jedoch klar. Neben der Arbeit im Parlament ist Gössi Steuer- und Unternehmensberaterin.',
    'BAT DE': 'fre',
    'Text fr':
      "Petra Gössi est la présidente de parti qui a fait le plus sensation au cours de l'année électorale. Avec son changement de cap vers un PLR plus écologique annoncé en février, elle a suscité de vives critiques à l’interne, mais les représentants de son parti ont finalement soutenu cette nouvelle orientation. La conseillère juridique se montre plutôt conservatrice sur les thèmes sociétaux, elle est par exemple contre la légalisation des drogues douces et contre l’euthanasie active. ",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Küssnacht',
    'Wohnort fr': 'Küssnacht',
    Geburtsdatum: '12.01.1976',
    'Beruf de': 'Juristin',
    'Beruf fr': 'Juriste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '177',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SP',
    'Fraktion de': 'SP Fraktion',
    'Fraktion fr': 'Groupe socialiste',
    Kanton: 'BE',
    Nachname: 'Masshardt',
    Vorname: 'Nadine',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2013',
    'DabeiSeit fr': 'Au Conseil national depuis 2013',
    'Alte Texte DE':
      'Die Historikerin sitzt in der Staatspolitischen Kommission und setzt sich für eine bessere Vereinbarkeit von Frau und Beruf und mehr Transparenz in den Parteifinanzen ein.',
    'Text de':
      'Masshardt leitete den Wahlkampf der SP. Die Historikerin ist Vizepräsidentin der SP-Bundeshausfraktion. Sie setzt sich für eine bessere Vereinbarkeit von Beruf und Familie sowie für mehr Transparenz bei den Parteifinanzen ein. ',
    'BAT DE': 'fre',
    'Text fr':
      "Responsable de la campagne électorale du Parti socialiste suisse cette année, Nadine Masshardt est historienne, vice-présidente du groupe parlementaire PS aux Chambres fédérales. Elle s'engage pour une meilleure conciliation entre vie privée et vie professionnelle ainsi que pour davantage de transparence dans le financement des partis. ",
    'BAT FR': 'Relu et complété par Lise',
    'Wohnort de': 'Bern',
    'Wohnort fr': 'Bern',
    Geburtsdatum: '04.10.1984',
    'Beruf de': 'Historikerin',
    'Beruf fr': 'Historienne'
  },
  {
    Elected: 'Ja',
    Sitznummer: '178',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'ZH',
    Nachname: 'Walti',
    Vorname: 'Beat',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2014',
    'DabeiSeit fr': 'Au Conseil national depuis 2014',
    'Alte Texte DE':
      'Walti ist Präsident der Zürcher FDP. Anfang 2014 rückte er für Markus Hutter in den Nationalrat nach. Walti sitzt in der Verkehrskommission.',
    'Text de':
      'Walti hat die Wahl von Ignazio Cassis und Karin Keller-Sutter in den Bundesrat souverän orchestriert. Als Chef der drittgrössten Fraktion spielt er eine wichtige Rolle im Parlament. Im Vergleich zu früheren FDP-Fraktionschefs agiert der parteiübergreifend geschätzte Walti eher zurückhaltend, was seinen Einfluss etwas mindert.',
    'BAT DE': 'fre',
    'Text fr':
      "Beat Walti a magistralement orchestré l'élection d'Ignazio Cassis et de Karin Keller-Sutter au Conseil fédéral. En tant que chef du troisième plus grand groupe parlementaire, il joue un rôle important au Parlement. Comparé aux anciens chefs de groupe PLR, Beat Walti pêche peut-être par excès de prudence, ce qui diminue quelque peu son influence.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zollikon',
    'Wohnort fr': 'Zollikon',
    Geburtsdatum: '22.11.1968',
    'Beruf de': 'Rechtsanwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '179',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'TG',
    Nachname: 'Lohr',
    Vorname: 'Christian',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der thalidomidgeschädigte Lohr macht sich in Bern für die Anliegen Behinderter stark. So kämpfte er im Juni dieses Jahres etwa gegen die Präimplantationsdiagnostik – erfolglos. Der Kreuzlinger Publizist ist Vorstandsmitglied von Pro Infirmis.',
    'Text de':
      'Der Kreuzlinger Publizist macht sich in Bern für die Anliegen Behinderter stark. So kämpfte er (erfolglos) gegen die Präimplantationsdiagnostik. Er ist Vizepräsident von Pro Infirmis.',
    'BAT DE': 'fre',
    'Text fr':
      "Au début des années 1960, la mère de Christian Lohr s'est vu prescrire pendant la grossesse un médicament à base de thalidomide, dont on a découvert par la suite qu’il provoquait de graves malformations congénitales. Le journaliste indépendant et formateur pour des hautes écoles est ainsi né sans bras et avec des jambes malformées. Il défend les intérêts des personnes handicapées à Berne et s'est battu (sans succès) contre les diagnostics préimplantatoires. Il est vice-président de Pro Infirmis.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Kreuzlingen',
    'Wohnort fr': 'Kreuzlingen',
    Geburtsdatum: '05.04.1962',
    'Beruf de': 'Dozent, Publizist',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '180',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'SO',
    Nachname: 'Fluri',
    Vorname: 'Kurt',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2003',
    'DabeiSeit fr': 'Au Conseil national depuis 2003',
    'Alte Texte DE':
      'Der langjährige Solothurner Stadtpräsident präsidiert den Städteverband, was sich in seinen Positionen in Verkehrs- und Energiefragen abbildet. Als Mitglied der Staatspolitischen Kommission kümmert sich Fluri um Migrationspolitik.',
    'Text de':
      'Fluri ist der geistige Vater des Inländervorrangs, der umstrittenen Umsetzung der Masseneinwanderungsinitiative. Er setzt sich auch immer wieder mal für Positionen ein, die nicht allen in der FDP gefallen. So forderte er diesen Sommer, dass die Schweiz Bootsflüchtlinge aus Italien aufnimmt.',
    'BAT DE': 'fre',
    'Text fr':
      "En Suisse-alémanique, on considère Kurt Fluri comme le père spirituel de la préférence nationale, coeur de la mise en œuvre controversée de l'initiative dite \"d'immigration de masse\". Il est régulièrement en porte à faux avec son parti. En été 2019, il a ainsi réclamé que la Suisse accueille des réfugiés qui ont traversé la Méditerranée en bateau. Celui qui est maire de Soleure est aussi à la tête de l'Union des villes suisses.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Solothurn',
    'Wohnort fr': 'Soleure',
    Geburtsdatum: '19.08.1955',
    'Beruf de': 'Stadtpräsident',
    'Beruf fr': 'Président de la ville de Soleure'
  },
  {
    Elected: 'Ja',
    Sitznummer: '181',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'TI',
    Nachname: 'Romano',
    Vorname: 'Marco',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Wird als Tessiner auch in der Deutschschweiz rege wahrgenommen - wahrscheinlich auch darum, weil er perfekt deutsch spricht. Der frühere Mitarbeiter des Tessiner Regierungsrats Luigi Pedrazzini thematisiert immer wieder die teils schwierigen Beziehungen mit Italien. Mitglied der Staatspolitischen und der Sicherheitspolitischen Kommission.',
    'Text de':
      'Wird als Tessiner auch in der Deutschschweiz rege wahrgenommen - wahrscheinlich auch darum, weil er perfekt deutsch spricht. Romano thematisiert immer wieder die teils schwierigen Beziehungen mit Italien.',
    'BAT DE': 'fre',
    'Text fr':
      "Le Tessinois est très apprécié en Suisse alémanique et en Suisse romande – probablement parce qu'il maîtrise parfaitement l'allemand et le français. Marco Romano aborde régulièrement le thème des relations parfois difficiles avec l'Italie. Très engagé sur les questions sécuritaires, ce jeune père de famille plaide pour davantage de gardes-frontière.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Mendrisio',
    'Wohnort fr': 'Mendrisio',
    Geburtsdatum: '06.11.1982',
    'Beruf de': '',
    'Beruf fr': 'Consultant'
  },
  {
    Elected: 'Ja',
    Sitznummer: '182',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'ZH',
    Nachname: 'Fiala',
    Vorname: 'Doris',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Die Zürcher Freisinnige ist spezialisiert auf Auslandpolitik. Fiala sitzt in der Aussenpolitischen Kommission und ist Präsidentin der Delegation beim Europarat.',
    'Text de':
      'Fiala ist Präsidentin der FDP-Frauen. Die Zürcherin ist Mitglied der Schweizer Delegation im Europarat und äussert sich mit Vorliebe zu aussenpolitischen Themen. ',
    'BAT DE': 'fre',
    'Text fr':
      "Doris Fiala est la présidente des femmes libérales-radicales. La Zurichoise fait partie de la délégation suisse auprès du Conseil de l'Europe et a une prédilection pour les questions de politique étrangère. Son entreprise de conseils en communication est spécialisée dans gestion de crise et le lobbying. Elle siège au conseil d'administration de l'Ecole hôtelière de Lausanne.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Zürich',
    'Wohnort fr': 'Zurich',
    Geburtsdatum: '29.01.1957',
    'Beruf de': 'selbständige Beraterin Risikomanagement & PR',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '183',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'SO',
    Nachname: 'Müller-Altermatt',
    Vorname: 'Stefan',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der 39-jährige Biologe politisiert seit vier Jahren in der Umweltkommission des Nationalrats, ausserdem ist er Mitglied der parlamentarischen Gruppe «Biodiversität und Artenschutz» und engagiert sich in umweltpolitischen Organisationen wie Pro Natura.',
    'Text de':
      'Für den Wahlkampf hat Stefan Müller-Altermatt mit einem Freund einen Popsong komponiert. Der Biologe kämpft für sichere Arbeitsplätze und eine intakte Umwelt. Er sitzt in der Umweltkomission des Nationalrats.',
    'BAT DE': 'fre',
    'Text fr':
      "Pour la campagne électorale, Stefan Müller-Altermatt a composé avec un ami une chanson pop. Le biologiste se bat pour des emplois stables et un environnement durable, des positions qu’il défend au sein des Commissions de l'environnement, de l’aménagement du territoire et de l’énergie (CEATE) du Conseil national.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Herbetswil',
    'Wohnort fr': 'Herbetswil',
    Geburtsdatum: '17.06.1976',
    'Beruf de': 'Dr. phil., Biologe',
    'Beruf fr': 'Docteur en biologie'
  },
  {
    Elected: 'Ja',
    Sitznummer: '184',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'BE',
    Nachname: 'Markwalder',
    Vorname: 'Christa',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2003',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Sie steht für den gesellschaftsliberalen Flügel der freisinnigen Fraktion. Markwalder war lange Jahre Präsidentin der NEBS (Neue europäische Bewegung Schweiz) und soll 2016 den Nationalrat präsidieren. Im Sommer 2015 geriet sie wegen der Kasachstan-Lobbying-Affäre unter Druck.',
    'Text de':
      'Als Jungpolitikerin wurde sie 2003 in den Nationalrat gewählt – nun bestreitet Christa Markwalder bereits ihre fünfte Legislatur. 2016 konnte sie, erst 41-jährig, den Nationalrat präsidieren. Die Bernerin steht für den gesellschaftsliberalen Flügel der freisinnigen Fraktion und ist überzeugte Pro-Europäerin geblieben.',
    'BAT DE': 'daf',
    'Text fr':
      "En 2003, lors de sa première élection au Conseil national, elle était la plus jeune élue du pays. Aujourd'hui, Christa Markwalder est en lice pour sa cinquième législature. En 2016, à l'âge de 41 ans, elle a présidé le Conseil national, malgré la polémique sur l'une de ses interventions au Parlement téléguidée par le  Kazakhstan. Elle a toujours nié. Elle représente l'aile humaniste du groupe PLR. Et ent tant qu'ancienne tête de file du NOMES, elle est restée une pro-européenne convaincue.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Burgdorf',
    'Wohnort fr': 'Burgdorf',
    Geburtsdatum: '27.07.1975',
    'Beruf de': 'Juristin',
    'Beruf fr': 'Juriste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '185',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'GR',
    Nachname: 'Candinas',
    Vorname: 'Martin',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der romanischsprachige Candinas politisiert in Bern als Vertreter der Randregionen. Wenn es darum geht, die SRG gegen Kritik zu unterstützen, ist er zur Stelle. Mitglied der Verkehrskommission.',
    'Text de':
      'Der romanischsprachige Candinas politisiert in Bern als klassischer Vertreter der Randregionen. Wenn es darum geht, die SRG gegen Kritik zu unterstützen, ist er zur Stelle. Candinas ist Mitglied der Verkehrskommission.',
    'BAT DE': 'fre',
    'Text fr':
      "Le rhéto-romanche Martin Candinas est l'ârchétype même du défenseur des régions périphériques. Père de trois enfants, il travaille pour l'assurance Helsana. Et dès qu'il s'agit de soutenir la SSR contre les critiques, on peut compter sur lui.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Chur',
    'Wohnort fr': 'Coire',
    Geburtsdatum: '20.08.1980',
    'Beruf de': 'Sozialversicherungsfachmann mit eidg. Fachausweis',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '186',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'VS',
    Nachname: 'Nantermod',
    Vorname: 'Philippe',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Der ehemalige Co-Präsident der Schweizer Jungfreisinnigen sitzt seit 2009 im Walliser Grossen Rat. Er ist Jurist und Doktorand an der Universität Lausanne.',
    'Text de':
      'Nantermod gehört zu den ambitioniertesten jungen Politikern im Nationalrat. Der Ziehsohn des früheren FDP-Bundesrats Pascal Couchepin hat eine steile Karriere hingelegt und ist Vizepräsident der FDP Schweiz. Der 35-Jähriged strebe nach noch mehr, heisst es im Wallis.',
    'BAT DE': 'daf',
    'Text fr':
      "En une législature, Philippe Nantermod a répondu présent là où on l'attendait. A 35 ans, le vice-président du PLR Suisse fait déjà partie de ces politiciens qui comptent. (Hyper)actif sur tous les dossiers et connu pour ses positions assumées quitte à provoquer, sa réélection n'a jamais fait l'ombre d'un doute.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Morgins-Troistorrents',
    'Wohnort fr': 'Morgins-Troistorrents',
    Geburtsdatum: '27.03.1984',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '187',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'LU',
    Nachname: 'Glanzmann-Hunkeler',
    Vorname: 'Ida',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2006',
    'DabeiSeit fr': 'Au Conseil national depuis 2006',
    'Alte Texte DE':
      'Die frühere Präsidentin der CVP Frauen Schweiz kümmert sich vor allem um sicherheitspolitische Themen. Daneben ist sie Mitglied der Geschäftsprüfungskommission.',
    'Text de':
      'Die frühere Präsidentin der CVP Frauen Schweiz kümmert sich vor allem um sicherheitspolitische Themen. Neben ihrer Arbeit im Parlament engagiert sich Glanzmann-Hunkeler im Gesundheitsbereich, etwa im politischen Beirat der Schweizer Paraplegiker-Stiftung.',
    'BAT DE': 'fre',
    'Text fr':
      "L'ancienne présidente des Femmes PDC suisses s'occupe essentiellement de questions de politique de sécurité. En plus de son travail parlementaire, Ida Glanzmann-Hunkeler est active dans le domaine de la santé, par exemple au sein du conseil politique de la Fondation suisse pour paraplégiques.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Altishofen',
    'Wohnort fr': 'Altishofen',
    Geburtsdatum: '29.09.1958',
    'Beruf de': 'Kauffrau',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '188',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'FDP',
    'Fraktion de': 'FDP-Liberale Fraktion',
    'Fraktion fr': 'Groupe libéral-radical',
    Kanton: 'GE',
    Nachname: 'Lüscher',
    Vorname: 'Christian',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2007',
    'DabeiSeit fr': 'Au Conseil national depuis 2007',
    'Alte Texte DE':
      'Vielbeschäftigter Anwalt, ehemaliger Bundesratskandidat, wortgewaltiger und talentierter Vertreter des rechten Parteiflügels und Vizepräsident der FDP Schweiz : Gemäss der «Tribune de Genève» ist Lüscher der wichtigste Genfer Nationalrat. Er setzt sich stark für den Finanzplatz ein.',
    'Text de':
      'Vielbeschäftigter Anwalt, ehemaliger Bundesratskandidat, wortgewaltiger Vertreter des rechten Parteiflügels und Vizepräsident der FDP Schweiz. Lüscher setzt sich stark für den Finanzplatz ein. Er half mit, Bundesanwalt Michael Lauber vor der Abwahl zu retten.',
    'BAT DE': 'daf',
    'Text fr':
      "Avocat de renom spécialisé dans la criminalité économique et ancien candidat au Conseil fédéral, Christian Lüscher fait partie des PLR qui comptent à Berne. Le Genevois a le verbe facile et une aisance devant les médias. Fervent défenseur de la place financière, le vice-président du parti suisse s'est fait remarquer dernièrement pour son plaidoyer en faveur de la réélection du procureur général de la Confédération Michael Lauber. Ce fut un des moments forts de la dernière session de septembre.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Anières',
    'Wohnort fr': 'Anières',
    Geburtsdatum: '06.12.1963',
    'Beruf de': 'Anwalt',
    'Beruf fr': 'Avocat'
  },
  {
    Elected: 'Ja',
    Sitznummer: '189',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'LU',
    Nachname: 'Müller',
    Vorname: 'Leo',
    Bisher: 'Nein',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE': '',
    'Text de':
      'Der Luzerner musste nach der Nichtwiederwahl des Tessiners Filippo Lombardi kurzfristig die Leitung der Mitte Fraktion übernehmen. Der Anwalt und Notar hat sich bisher vor allem in Wirtschafts- und Finanzpolitische Fragen profiliert. Er ist Mitglied des Verwaltungsrats von Fenaco, die grösste landwirtschaftliche Genossenschaft des Landes.',
    'BAT DE': 'Gelb',
    'Text fr':
      "Le Lucernois a du reprendre au pied levé la direction du groupe parlementaire du centre, suite à la non-réélection du Tessinois Filippo Lombardi. L'avocat notaire s'est jusque-là surtout profilé sur les questions économiques et financières. Il siège au conseil d'administration de Fenaco, la plus grande coopérative agricole du pays.",
    'BAT FR': '',
    'Wohnort de': 'Ruswil',
    'Wohnort fr': 'Ruswil',
    Geburtsdatum: '04.07.1958',
    'Beruf de': 'Rechtsanwalt und Notar',
    'Beruf fr': 'Avocat et notaire'
  },
  {
    Elected: 'Ja',
    Sitznummer: '190',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'GE',
    Nachname: 'Amaudruz',
    Vorname: 'Céline',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Die Präsidentin der Genfer SVP wird von der Parteileitung auffällig oft für Medienkonferenzen aufgeboten. Sie ist eine der wenigen Aushängeschilder der SVP in der Romandie. Amaudruz vertritt die SVP in der Finanzkommission und der staatspolitischen Kommission.',
    'Text de':
      'Sie leidet bisweilen an ihrer eigenen Partei, vor allem dann, wenn sie auf ihr Äusseres reduziert wird. Als Feministin gilt Amaudruz im Nationalrat trotzdem nicht. In Ausländer- und Asylfragen war sie in den letzten Jahren eine Hardlinerin. Danebst fokussierte sie auf die Finanzpolitik. Amaudruz ist die bekannteste Westschweizer SVP-Vertreterin.',
    'BAT DE': 'daf',
    'Text fr':
      "Personnalité de l'UDC la plus connue en Suisse romande, Céline Amaudruz est aussi la vice-présidente du parti national. Si elle défend une ligne libérale du point de vue économique et est en accord avec les positions dures de l'UDC en matière de politique des étrangers et d'asile, la Genevoise est de plus en plus souvent en décalage avec le reste de la présidence UDC sur les questions de société, comme le mariage pour tous, le congé paternité ou l'égalité salariale.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Genf',
    'Wohnort fr': 'Genève',
    Geburtsdatum: '15.03.1979',
    'Beruf de': '',
    'Beruf fr': 'Gestionnaire'
  },
  {
    Elected: 'Ja',
    Sitznummer: '191',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'ZG',
    Nachname: 'Pfister',
    Vorname: 'Gerhard',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2003',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Pfister repräsentiert und führt den konservativen Flügel der CVP. Gehört zu den klügsten Köpfen im Parlament. Mitglied der Aussenpolitischen und der Staatspolitischen Kommission.',
    'Text de':
      'Der Präsident der CVP sitzt bereits seit 2003 im Nationalrat. Der frühere Lehrer für Literatur und Philosophie gehört zum wertkonservativen CVP-Flügel und liebt die engagierte Debatte. Sehr engagiert ist er auch auf Twitter, wo er sich bisweilen zu flapsigen Äusserungen hinreissen lässt.',
    'BAT DE': 'fre',
    'Text fr':
      "Le président du PDC siège au Conseil national depuis 2003. Avec son profil très à droite, son élection à la tête du parti a suscité des craintes en Suisse romande. L'ancien enseignant d’allemand et de philosophie donne des conseils littéraires sur ses sites internet et affectionne particulièrement les débats animés. Il est également très actif sur Twitter, où ses déclarations manquent parfois de nuance.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Oberägeri',
    'Wohnort fr': 'Oberägeri',
    Geburtsdatum: '01.10.1962',
    'Beruf de': 'Dr. phil.',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '192',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZH',
    Nachname: 'Matter',
    Vorname: 'Thomas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2014',
    'DabeiSeit fr': 'Au Conseil national depuis 2014',
    'Alte Texte DE':
      'Der Banker sitzt erst seit Kurzem im Nationalrat. Er rückte Anfang 2014 für Christoph Blocher nach und ist seither Mitglied der Wirtschaftskommission. Ausserhalb des Parlaments hat er sich als Initiant der Bankgeheimnis-Initiative einen Namen gemacht.',
    'Text de':
      'Matter gehört zum inneren Kreis um Christoph Blocher, der die Geschicke der SVP prägt. Als Banker, der hemdsärmelig auftritt, steht Matter für das, was die Partei stark gemacht hat: demonstrative Volksnähe im Verbund mit Finanz- und Wirtschaftskraft. Auch wenn die SVP bei den Wahlen Verluste einfährt, wird sie die stärkste Fraktion bleiben und Wortführer wie Matter entsprechend einflussreich.',
    'BAT DE': 'fre',
    'Text fr':
      "Thomas Matter fait partie du cercle rapproché de Christoph Blocher. Ce banquier se présente comme proche du peuple tout en étant très impliqué dans les milieux financiers et économiques zurichois. Il est aussi le cerveau créatif du parti. C'est principalement à lui que l'on doit les scénarios des clips et séries de campagne tournés par l'UDC.",
    'BAT FR': 'Relu et réécrit par Lise',
    'Wohnort de': 'Meilen',
    'Wohnort fr': 'Meilen',
    Geburtsdatum: '23.03.1966',
    'Beruf de': 'Unternehmer',
    'Beruf fr': 'Entrepreneur'
  },
  {
    Elected: 'Ja',
    Sitznummer: '193',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'BL',
    Nachname: 'Schneider-Schneiter',
    Vorname: 'Elisabeth',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2010',
    'DabeiSeit fr': 'Au Conseil national depuis 2010',
    'Alte Texte DE':
      'Schneider ist Mitglied des CVP-Parteipräsidiums und kümmert sich als Mitglied der Europarats-Delegation und der aussenpolitischen Kommission in erster Linie um Aussenpolitik.',
    'Text de':
      'Schneider-Schneiter ist Mitglied des CVP-Parteipräsidiums und kümmert sich als Mitglied der Europarats-Delegation und als Präsidentin der aussenpolitischen Kommission in erster Linie um Aussenpolitik. 2018 scheiterte sie parteiintern mit ihrer Kandidatur für die Nachfolge von Bundesrätin Doris Leuthard.',
    'BAT DE': 'fre',
    'Text fr':
      "Elisabeth Schneider-Schneiter est membre du comité directeur du PDC. En tant que membre de la délégation suisse au Conseil de l'Europe et présidente de la commission de politique étrangère, elle s'occupe principalement de politique étrangère. En 2018, déjà lors de la sélection interne au parti, elle a échoué dans sa tentative de succéder à la conseillère fédérale Doris Leuthard.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Biel-Benken',
    'Wohnort fr': 'Biel-Benken',
    Geburtsdatum: '19.02.1964',
    'Beruf de': 'Juristin',
    'Beruf fr': 'Juriste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '194',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'BE',
    Nachname: 'Rösti',
    Vorname: 'Albert',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Rösti ist in den vergangenen Jahren innerhalb der SVP-Fraktion aufgestiegen. So war er etwa 2015 Wahlkampfleiter der nationalen Kampagne. Als Präsident von Aves (Aktion für vernünftige Energiepolitik) ist er ein Gegner der Energiewende.',
    'Text de':
      'Rösti ist seit 2016 Präsident der SVP Schweiz. Im Ton umgänglich, vertritt er ebenso wie sein Vorgänger Toni Brunner einen dezidierten Anti-EU-Kurs. In der Klimafrage lehnt Rösti Vorschläge wie eine Benzinverteuerung oder eine Flugticketabgabe ab. Stattdessen weist der studierte Agronom darauf hin, dass die Bauern seit je ökologisch produzierten und dass der Konsum einheimischer Lebensmittel klimaschonend sei.',
    'BAT DE': 'fre',
    'Text fr':
      "Président de l'UDC depuis 2016, Albert Rösti est un homme qui a le contact facile. Si son ton est joviale, ses positions sont aussi dure que celle de ses prédécesseurs concernant les relations Suisse-UE. Sur la question du climat, le Bernois rejette toute augmentation du prix de l'essence, de même que l'idée de taxer les billets d'avion. Pour cet ingénieur agronome, la politique environnementale de la Suisse doit passer par une agriculture locale.",
    'BAT FR': 'Réécrit par FQZ',
    'Wohnort de': 'Uetendorf',
    'Wohnort fr': 'Uetendorf',
    Geburtsdatum: '07.08.1967',
    'Beruf de': 'Dr. Ing. Agr. ETH, Gemeindepräsident',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '195',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'SZ',
    Nachname: 'Gmür',
    Vorname: 'Alois',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der Geschäftsführer und Mitinhaber der Brauerei Rosengarten in Einsiedeln zählt zum Wirtschaftsflügel der CVP. Mitglied der Finanzkommission.',
    'Text de':
      'Der Geschäftsführer und Mitinhaber der Brauerei Rosengarten in Einsiedeln. Er zählt zum Wirtschaftsflügel der CVP und ist Vorstandsmitglied der IG Freiheit.',
    'BAT DE': 'fre',
    'Text fr':
      "Dirigeant et copropriétaire de la brasserie Rosengarten à Einsiedeln, Alois Gmür fait partie de l’aile libérale du PDC. Le major à l'armée et père de cinq enfants est d’ailleurs membre du comité directeur de la Communauté d’intérêts Priorité Liberté qui compte le Genevois Christian Lüscher comme vice-président.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Einsiedeln',
    'Wohnort fr': 'Einsiedeln',
    Geburtsdatum: '03.04.1955',
    'Beruf de': 'Braumeister',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '196',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'ZG',
    Nachname: 'Aeschi',
    Vorname: 'Thomas',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der Harvard-Absolvent, der als Unternehmensberater tätig ist, steht für eine neue Generation von Politikern in der SVP-Fraktion. Spezialisiert auf Finanzpolitik, Mitglied der Wirtschaftskommission.',
    'Text de':
      'Der Harvard-Absolvent ist spezialisiert auf Finanz- und Wirtschaftspolitik. Als SVP-Fraktionschef gelingt es ihm recht gut, die grösste Vertretung im Parlament zu disziplinieren - ohne dass er wie sein Vorgänger Adrian Amstutz als Feldweibel auftreten muss.',
    'BAT DE': 'fre',
    'Text fr':
      "Le chef du groupe parlementaire de l'UDC parvient à maintenir une certaine cohésion dans la plus grande représentation au Parlement, sans pour autant passer pour un sergent-major comme son prédécesseur Adrian Amstutz. Le diplômé d'Harvard, candidat malheureux au Conseil fédéral, est un spécialiste des questions financières et économiques. On le dit très proche de Christoph Blocher.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Baar',
    'Wohnort fr': 'Baar',
    Geburtsdatum: '13.01.1979',
    'Beruf de': 'Unternehmensberater',
    'Beruf fr': 'Conseiller en entreprises'
  },
  {
    Elected: 'Ja',
    Sitznummer: '197',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'AG',
    Nachname: 'Humbel',
    Vorname: 'Ruth',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2003',
    'DabeiSeit fr': 'Au Conseil national depuis 2003',
    'Alte Texte DE':
      'Im Nationalrat kennt man Humbel als Gesundheitspolitikerin. Die Juristin ist im Gesundheitswesen breit vernetzt. Sie ist auch Mitglied der Staatspolitischen Kommission.',
    'Text de':
      'Ruth Humbel ist eine Gesundheitspolitikerin und sitzt im Verwaltungsrat der Krankenkasse Concordia. Sie setzt sich für Transparenz und Kostendämpfung im Gesundheitswesen ein, sieht sich aber regelmässig mit dem Vorwurf konfrontiert, eine Kassen-Lobbyistin zu sein.',
    'BAT DE': 'fre',
    'Text fr':
      "Ruth Humbel s'est surtout profilée sur les questions de politique de la santé et siège au conseil d'administration de la caisse maladie Concordia. Elle s'engage en faveur de la transparence et de la maîtrise des coûts de la santé, mais on lui reproche souvent d’appartenir au lobby des assurances maladies.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Birmenstorf',
    'Wohnort fr': 'Birmenstorf',
    Geburtsdatum: '23.07.1957',
    'Beruf de': 'Juristin',
    'Beruf fr': 'Juriste'
  },
  {
    Elected: 'Ja',
    Sitznummer: '198',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'GR',
    Nachname: 'Martullo-Blocher',
    Vorname: 'Magdalena',
    Bisher: 'Ja',
    Geschlecht: 'w',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Martullo-Blocher schaffte überraschend als Neueinsteigerin den Sprung in den Nationalrat. Sie übernahm die Gesamtverantwortung über die Ems-Chemie, als ihr Vater, Christoph Blocher, 2003 in den Bundesrat gewählt wurde.',
    'Text de':
      'Martullo-Blocher ist CEO der Ems-Chemie Holding AG. Die Unternehmerin sitzt in der einflussreichen Kommission für Wirtschaft und Abgaben. Mit einem intensiven Wahlkampf in ganz Graubünden hat die Zürcherin die Wiederwahl geschafft.',
    'BAT DE': 'fre',
    'Text fr':
      "Magdalena Martullo-Blocher est PDG d'Ems-Chemie Holding AG, héritée de son père Christoph Blocher. Elle est membre de l'influente Commission des économies et des redevances. Grâce à une campagne électorale intensive dans les Grisons, la femme d'affaires zurichoise a réussi à se faire réélire.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Meilen ZH',
    'Wohnort fr': 'Meilen ZH',
    Geburtsdatum: '13.08.1969',
    'Beruf de': 'Unternehmerin EMS CHEMIE',
    'Beruf fr': "Directrice d'EMS-Chemie"
  },
  {
    Elected: 'Ja',
    Sitznummer: '199',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'CVP',
    'Fraktion de': 'Die Mitte-Fraktion. CVP-EVP-BDP.',
    'Fraktion fr': 'Le groupe du centre. PDC-PEV-PBD.',
    Kanton: 'SG',
    Nachname: 'Ritter',
    Vorname: 'Markus',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2011',
    'DabeiSeit fr': 'Au Conseil national depuis 2011',
    'Alte Texte DE':
      'Der Bauernverbandspräsident gilt als geschickter Netzwerker und setzt sich in Bern erfolgreich für landwirtschaftliche Anliegen ein. Der dossierfeste und redegewandte Wirtschaftspolitiker bewirtschaftet einen Biobetrieb im Rheintal.',
    'Text de':
      'Der Bauernverbandspräsident gilt als geschickter Netzwerker und setzt sich in Bern erfolgreich für landwirtschaftliche Anliegen ein. Der dossierfeste und redegewandte Wirtschaftspolitiker bewirtschaftet einen Biobetrieb im Rheintal.',
    'BAT DE': 'fre',
    'Text fr':
      "Si les Romands ont Jacques Bourgeois, les Alémaniques ont Markus Ritter. Le premier est directeur de l'Union suisse des paysans, le second est son président. A eux deux, ils incarnent la puissance du lobby agricole à Berne. Quitte à fâcher dans les autres partis. Markus Ritter dirige une exploitation bio dans la vallée du Rhin saint-galloise.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Altstätten',
    'Wohnort fr': 'Altstätten',
    Geburtsdatum: '19.04.1967',
    'Beruf de':
      'Meisterlandwirt, Präsident Schweizer Bauernverband, Wirtschaftsingenieur FH, Nationalrat',
    'Beruf fr': ''
  },
  {
    Elected: 'Ja',
    Sitznummer: '200',
    Rat: 'Nationalrat',
    'Funktion de': '',
    'Funktion fr': '',
    Partei: 'SVP',
    'Fraktion de': 'SVP Fraktion',
    'Fraktion fr': 'Groupe UDC',
    Kanton: 'SZ',
    Nachname: 'Dettling',
    Vorname: 'Marcel',
    Bisher: 'Ja',
    Geschlecht: 'm',
    'DabeiSeit de': 'Im Nationalrat seit 2015',
    'DabeiSeit fr': 'Au Conseil national depuis 2015',
    'Alte Texte DE':
      'Dettling schaffte eine der grossen Überraschungen bei diesen Wahlen: Der Landwirt schaffte den Einzug in den Nationalrat auf Kosten von SP-Bundeshausfraktionschef Andy Tschümperlin.',
    'Text de':
      'Der Landwirt ist seit 2015 im Rat. Er engagiert sich vor allem für die Landwirtschaft. Aufgefallen ist er mit umstrittenen Aussagen zum Klimawandel ("Ich lebe gerne in wärmeren Zeiten.") und mit dem Kampf gegen das geplante Bundesasylzentrum in seinem Kanton. ',
    'BAT DE': 'fre',
    'Text fr':
      "L'agriculteur est conseiller national depuis 2015 et s’est avant tout engagé dans la défense des intérêts de l'agriculture. Il a attiré l'attention par ses déclarations controversées sur le changement climatique («J'aime vivre dans une époque plus chaude») et par la lutte contre l’implantation d’un centre fédéral pour requérants d’asile dans son canton.",
    'BAT FR': 'relu par Titus',
    'Wohnort de': 'Oberiberg',
    'Wohnort fr': 'Oberiberg',
    Geburtsdatum: '01.02.1981',
    'Beruf de': 'Landwirt',
    'Beruf fr': 'Agriculteur'
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '201',
    Rat: 'Nationalrat',
    'Funktion de': 'Mitglied des Bundesrats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '202',
    Rat: 'Nationalrat',
    'Funktion de': 'Mitglied des Bundesrats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '203',
    Rat: 'Nationalrat',
    'Funktion de': 'Mitglied des Bundesrats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '204',
    Rat: 'Nationalrat',
    'Funktion de': 'Berichterstatter/-in',
    'Funktion fr': 'Rapporteurs des commissions',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '205',
    Rat: 'Nationalrat',
    'Funktion de': 'Berichterstatter/-in',
    'Funktion fr': 'Rapporteurs des commissions',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '206',
    Rat: 'Nationalrat',
    'Funktion de': 'Rednerpult',
    'Funktion fr': 'Tribune des orateurs',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '207',
    Rat: 'Nationalrat',
    'Funktion de': 'Mitglied des Bundesrats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '208',
    Rat: 'Nationalrat',
    'Funktion de': 'Mitglied des Bundesrats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '209',
    Rat: 'Nationalrat',
    'Funktion de': 'Mitglied des Bundesrats',
    'Funktion fr': 'Membre du Conseil fédéral',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '210',
    Rat: 'Nationalrat',
    'Funktion de': 'Sekretäre und Übersetzer',
    'Funktion fr': 'Secrétaires et traducteurs',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '211',
    Rat: 'Nationalrat',
    'Funktion de': 'Sekretäre und Übersetzer',
    'Funktion fr': 'Secrétaires et traducteurs',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  },
  {
    Elected: 'Funktionär',
    Sitznummer: '212',
    Rat: 'Nationalrat',
    'Funktion de': 'Generalsekretär',
    'Funktion fr': 'Secrétaire général',
    Partei: 'Keine',
    'Fraktion de': '',
    'Fraktion fr': '',
    Kanton: '',
    Nachname: '',
    Vorname: '',
    Bisher: '',
    Geschlecht: '',
    'DabeiSeit de': '',
    'DabeiSeit fr': '',
    'Alte Texte DE': '',
    'Text de': '',
    'BAT DE': '',
    'Text fr': '',
    'BAT FR': '',
    'Wohnort de': '',
    'Wohnort fr': '',
    Geburtsdatum: '',
    'Beruf de': '',
    'Beruf fr': ''
  }
]
